import * as i0 from '@angular/core';
import { Injectable, NgModule, Pipe, EventEmitter, Component, Input, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import * as i4$1 from '@angular/forms';
import { FormBuilder, Validators, FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2 from '@arc/arc-shared-frontend';
import { UserPermissionStore, AuthUserStore, UserNotificationAction, UserService, PermissionTypes, ArcSharedModule } from '@arc/arc-shared-frontend';
import { map, withLatestFrom as withLatestFrom$1, switchMap as switchMap$1, catchError as catchError$1 } from 'rxjs/operators';
import * as i1$1 from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, map as map$1, withLatestFrom, switchMap, of, catchError, filter, Subject, takeUntil, combineLatest } from 'rxjs';
import * as i1$2 from '@ngrx/store';
import { createFeatureSelector, createSelector, select, createAction, props, StoreModule, createFeature, createReducer, on } from '@ngrx/store';
import * as i1$4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$3 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i5 from '@arc/aureus';
import { MessageService as MessageService$1, AureusModule } from '@arc/aureus';
import * as i2$1 from 'primeng/dialog';
import * as i2$2 from 'primeng/api';
import { MessageService } from 'primeng/api';
import * as i4 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import * as i6 from 'primeng/checkbox';
import { CheckboxModule } from 'primeng/checkbox';
import * as i8 from 'primeng/messages';
import { MessagesModule } from 'primeng/messages';
import * as i5$1 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import * as i7 from 'primeng/table';
import { TableModule } from 'primeng/table';
import * as i8$1 from 'primeng/overlaypanel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import * as i2$3 from 'primeng/tabview';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';

/* tslint:disable */
class MerchantAccountService {
    constructor(http, configSettings, translateService) {
        this.http = http;
        this.configSettings = configSettings;
        this.translateService = translateService;
        // GATEWAY CREDENTIALS NEW API ENDPOINTS
        this.getGatewayCredentialsBaseUrl = (tenantId, merchantAccountId) => {
            return `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}/gatewaycredentials`;
        };
    }
    get merchantRegistrationUrl() {
        return this.configSettings.getconfig('merchantRegistrationUrl');
    }
    // Gets a specific merchant account by its ID
    GetMerchantAccount(tenantId, merchantAccountId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}`;
        return this.http.get(uri, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_GET_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Gets a list of merchant accounts for the tenant
    GetMerchantAccountList(tenantId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card`;
        return this.http.get(uri, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_GET_MERCHANT_ACCOUNT_LIST_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Creates a new merchant account
    CreateNewMerchantAccount(requestPayload, tenantId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card`;
        return this.http
            .post(uri, requestPayload, { observe: 'response' })
            .pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_CREATE_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Updates and existing merchant account
    UpdateMerchantAccount(requestPayload, tenantId, merchantAccountId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}`;
        return this.http
            .put(uri, requestPayload, { observe: 'response' })
            .pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_UPDATE_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Deletes a merchant account. Note: the success of the deletion depends on the state of the merchant account. Once an account has payments made against it it cannot be deleted.
    DeleteMerchantAccount(tenantId, merchantAccountId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}`;
        return this.http.delete(uri, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_DELETE_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Creates interchange defaults under an existing merchant account.
    CreateInterchangeDefaults(tenantId, requestPayload) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${requestPayload.merchantAccountId}/interchangedefaults`;
        return this.http
            .post(uri, requestPayload, { observe: 'response' })
            .pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_CREATE_INTERCHANGE_DEFAULT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Updates existing interchange defaults under an existing merchant account.
    UpdateInterchangeDefaults(tenantId, requestPayload) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${requestPayload.merchantAccountId}/interchangedefaults/${requestPayload.interchangeDefaultId}`;
        return this.http
            .put(uri, requestPayload, { observe: 'response' })
            .pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_UPDATE_INTERCHANGE_DEFAULT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Deletes interchant defaults under an existing merchant account.
    DeleteInterchangeDefaults(tenantId, merchantAccountId, interchangeDefaultsId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}/interchangedefaults/${interchangeDefaultsId}`;
        return this.http.delete(uri, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_DELETE_INTERCHANGE_DEFAULT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Disables an existing merchant account so that it can no longer be used to make new payments.
    DisableMerchantAccount(tenantId, merchantAccountId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}/disable`;
        return this.http.put(uri, null, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_DISABLE_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    // Enables a merchant account so it can be used for production payments.
    EnableMerchantAccount(tenantId, merchantAccountId) {
        let uri = `${this.merchantRegistrationUrl}/v1/tenants/${tenantId}/accounts/card/${merchantAccountId}/enable`;
        return this.http.put(uri, null, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_ENABLE_MERCHANT_ACCOUNT_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    CreateGatewayCredential(tenantId, merchantAccountId, gatewayCredential) {
        let uri = `${this.getGatewayCredentialsBaseUrl(tenantId, merchantAccountId)}`;
        const dataBody = {
            merchantId: gatewayCredential.merchantId,
            secondaryMerchantId: gatewayCredential.secondaryMerchantId,
            merchantPassword: gatewayCredential.password,
            role: gatewayCredential.role,
            merchantUrl: gatewayCredential.url,
            gatewayOptions: gatewayCredential.gatewayOptions,
            active: gatewayCredential.active,
        };
        return this.http.post(uri, dataBody, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok) {
                throw new Error(this.translateService.instant('ARC_PAYMENTS_CREATE_GATEWAY_CREDENTIAL_ERROR_MESSAGE'));
            }
            return response.body;
        }));
    }
    VerifyGateWayCredential(tenantId, merchantAccountId, gatewayCredential) {
        let uri = `${this.getGatewayCredentialsBaseUrl(tenantId, merchantAccountId)}/${gatewayCredential.gatewayCredentialId}/verifycredentials`;
        return this.http
            .post(uri, gatewayCredential, { observe: 'response' })
            .pipe(map((response) => {
            if (!response.ok) {
                throw new Error(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_SERVICE_VERIFY_CREDENTIALS_ERROR_MESSAGE'));
            }
            return response.body;
        }));
    }
    UpdateGatewayCredential(tenantId, merchantAccountId, gatewayCredential) {
        let uri = `${this.getGatewayCredentialsBaseUrl(tenantId, merchantAccountId)}/${gatewayCredential.gatewayCredentialId}`;
        const dataBody = {
            merchantId: gatewayCredential.merchantId,
            secondaryMerchantId: gatewayCredential.secondaryMerchantId,
            merchantPassword: gatewayCredential.password,
            role: gatewayCredential.role,
            merchantUrl: gatewayCredential.url,
            gatewayOptions: gatewayCredential.gatewayOptions,
            active: gatewayCredential.active,
        };
        return this.http.put(uri, dataBody, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok) {
                throw new Error(this.translateService.instant('UPDATE_GATEWAY_CREDENTIAL_ERROR_MESSAGE'));
            }
            return response.body;
        }));
    }
    DeleteGatewayCredential(tenantId, merchantAccountId, gatewayCredential) {
        let uri = `${this.getGatewayCredentialsBaseUrl(tenantId, merchantAccountId)}/${gatewayCredential.gatewayCredentialId}`;
        return this.http.delete(uri, { observe: 'response' }).pipe(map((response) => {
            if (!response.ok) {
                throw new Error(this.translateService.instant('DELETE_GATEWAY_CREDENTIAL_ERROR_MESSAGE'));
            }
            return response.body;
        }));
    }
    buildApiCalls(tenantId, merchantAccountid, gatewayCredentials) {
        let apicallsArray = gatewayCredentials.map((gatewaycredential) => {
            if (gatewaycredential.gatewayCredentialId) {
                return this.UpdateGatewayCredential(tenantId, merchantAccountid, gatewaycredential);
            }
            else {
                return this.CreateGatewayCredential(tenantId, merchantAccountid, gatewaycredential);
            }
        });
        return forkJoin(apicallsArray);
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantAccountService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantAccountService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigSettings), i0.ɵɵinject(i1$1.TranslateService)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: MerchantAccountService, factory: MerchantAccountService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantAccountService, [{
        type: Injectable
    }], () => [{ type: i1.HttpClient }, { type: i2.AppConfigSettings }, { type: i1$1.TranslateService }], null); })();

/* tslint:disable */
class GatewayRegistrationV1Service {
    constructor(translateService, http, configSettings) {
        this.translateService = translateService;
        this.http = http;
        this.configSettings = configSettings;
    }
    get gatewayRegistrationUrl() {
        return this.configSettings.getconfig('gatewayRegistrationUrl');
        ;
    }
    GetGatewayList(tenantId) {
        let uri = `${this.gatewayRegistrationUrl}/v1/tenants/${tenantId}/gateways`;
        return this.http.get(uri, { observe: 'response' }).pipe(map(response => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_GATEWAY_REGISTRATION_SERVICE_GET_GATEWAY_LIST_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    GetGateway(tenantId, gatewayId) {
        let uri = `${this.gatewayRegistrationUrl}/v1/tenants/${tenantId}/gateways/${gatewayId}`;
        return this.http.get(uri, { observe: 'response' }).pipe(map(response => {
            if (!response.ok)
                throw new Error(this.translateService.instant('ARC_PAYMENTS_GATEWAY_REGISTRATION_SERVICE_GET_GATEWAY_ERROR_MESSAGE'));
            return response.body;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayRegistrationV1Service_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayRegistrationV1Service)(i0.ɵɵinject(i1$1.TranslateService), i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigSettings)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: GatewayRegistrationV1Service, factory: GatewayRegistrationV1Service.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayRegistrationV1Service, [{
        type: Injectable
    }], () => [{ type: i1$1.TranslateService }, { type: i1.HttpClient }, { type: i2.AppConfigSettings }], null); })();

class GatewayActionTypes {
    static { this.LoadGatewayList = '[Gateway] Load Gateway List'; }
    static { this.GatewayListLoaded = '[Gateway] Gateway List Loaded'; }
    static { this.LoadGateway = '[Gateway] Load Gateway'; }
    static { this.GatewayLoaded = '[Gateway] Gateway Loaded'; }
    static { this.ResetGateway = '[Gateway] Reset Gateway'; }
}
class LoadGatewayListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayActionTypes.LoadGatewayList;
    }
}
class GatewayListLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayActionTypes.GatewayListLoaded;
    }
}
class LoadGatewayAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayActionTypes.LoadGateway;
    }
}
class GatewayLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayActionTypes.GatewayLoaded;
    }
}
class ResetGatewayAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayActionTypes.ResetGateway;
    }
}

class MerchantAccountActionTypes {
    static { this.NewMerchantAccountCreated = "[MerchantAccount] Merchant Account Created"; }
    static { this.CreateMerchantAccount = "[MerchantAccount] Create Merchant Account"; }
    static { this.LoadMerchantAccountList = "[MerchantAccount] Load Merchant Account List"; }
    static { this.MerchantAccountListLoaded = "[MerchantAccount] Merchant Account List Loaded"; }
    static { this.LoadMerchantAccount = "[MerchantAccount] Load Merchant Account"; }
    static { this.MerchantAccountLoaded = "[MerchantAccount] Merchant Account Loaded"; }
    static { this.UpdateMerchantAccount = "[MerchantAccount] Update Merchant Account"; }
    static { this.MerchantAccountUpdated = "[MerchantAccount] Merchant Account Updated"; }
    static { this.DeleteMerchantAccount = "[MerchantAccount] Delete Merchant Account"; }
    static { this.MerchantAccountDeleted = "[MerchantAccount] Merchant Account Deleted"; }
    static { this.CreateInterchangeDefaults = "[MerchantAccount] Create Interchange Defaults"; }
    static { this.InterchangeDefaultsCreated = "[MerchantAccount] Interchange Defaults Created"; }
    static { this.UpdateInterchangeDefaults = "[MerchantAccount] Update Interchange Defaults"; }
    static { this.DeleteInterchangeDefaults = "[MerchantAccount] Delete Interchange Defaults"; }
    static { this.InterchangeDefaultsDeleted = "[MerchantAccount] Interchange Defaults Deleted"; }
    static { this.InterchangeDefaultsUpdated = "[MerchantAccount] Interchange Defaults Updated"; }
    static { this.DisableMerchantAccount = "[MerchantAccount] Disable Merchant Account"; }
    static { this.MerchantAccountDisabled = "[MerchantAccount] Merchant Account Disabled"; }
    static { this.EnableMerchantAccount = "[MerchantAccount] Enable Merchant Account"; }
    static { this.MerchantAccountEnabled = "[MerchantAccount] Merchant Account Enabled"; }
    static { this.ResetMerchantAccount = "[MerchantAccount] Reset Merchant Account"; }
}
class NewMerchantAccountCreatedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.NewMerchantAccountCreated;
    }
}
class CreateMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.CreateMerchantAccount;
    }
}
class LoadMerchantAccountListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.LoadMerchantAccountList;
    }
}
class MerchantAccountListLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountListLoaded;
    }
}
class UpdateMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.UpdateMerchantAccount;
    }
}
class MerchantAccountUpdatedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountUpdated;
    }
}
class DeleteMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.DeleteMerchantAccount;
    }
}
class MerchantAccountDeletedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountDeleted;
    }
}
class CreateInterchangeDefaultsAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.CreateInterchangeDefaults;
    }
}
class InterchangeDefaultsCreatedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.InterchangeDefaultsCreated;
    }
}
class UpdateInterchangeDefaultsAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.UpdateInterchangeDefaults;
    }
}
class DeleteInterchangeDefaultsAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.DeleteInterchangeDefaults;
    }
}
class InterchangeDefaultsDeletedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.InterchangeDefaultsDeleted;
    }
}
class InterchangeDefaultsUpdatedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.InterchangeDefaultsUpdated;
    }
}
class DisableMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.DisableMerchantAccount;
    }
}
class MerchantAccountDisabledAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountDisabled;
    }
}
class EnableMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.EnableMerchantAccount;
    }
}
class MerchantAccountEnabledAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountEnabled;
    }
}
class LoadMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.LoadMerchantAccount;
    }
}
class MerchantAccountLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.MerchantAccountLoaded;
    }
}
class ResetMerchantAccountAction {
    constructor(payload) {
        this.payload = payload;
        this.type = MerchantAccountActionTypes.ResetMerchantAccount;
    }
}

class TenantUserActionTypes {
    static { this.LoadTenantUserList = '[Tenant User] Load User List'; }
    static { this.TenantUserListLoaded = '[Tenant User] User List Loaded'; }
}
class LoadTenantUserListAction {
    constructor(payload) {
        this.payload = payload;
        this.type = TenantUserActionTypes.LoadTenantUserList;
    }
}
class TenantUserListLoadedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = TenantUserActionTypes.TenantUserListLoaded;
    }
}

class GatewayCredentialsActionTypes {
    static { this.VerifyGatewayCredential = "[MerchantAccount] Verify Gateway Credential"; }
    static { this.VerifyGatewayCredentialSuccess = "[MerchantAccount] Verify Gateway Credential Success"; }
    static { this.VerifyGatewayCredentialError = "[MerchantAccount] Verify Gateway Credential Error"; }
    static { this.DeleteGateWayCredential = "[MerchantAccount] Delete Gateway Credential"; }
    static { this.DeleteGateWayCredentialSuccess = "[MerchantAccount] Gateway Credential Successfully Deleted"; }
    static { this.DeleteGateWayCredentialError = "[MerchantAccount] Gateway Credential Deleted Failed"; }
    static { this.CreateUpdateGatewayCredential = "[MerchantAccount] Create Gateway Credential"; }
    static { this.GatewayCredentialCreatedUpdated = "[MerchantAccount] Gateway Credential Created"; }
}
class VerifyGatewayCredentialAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.VerifyGatewayCredential;
    }
}
class VerifyGatewayCredentialSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.VerifyGatewayCredentialSuccess;
    }
}
class VerifyGatewayCredentialErrorAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.VerifyGatewayCredentialError;
    }
}
class DeleteGateWayCredentialAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.DeleteGateWayCredential;
    }
}
class DeleteGateWayCredentialSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.DeleteGateWayCredentialSuccess;
    }
}
class DeleteGateWayCredentialErrorAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.DeleteGateWayCredentialError;
    }
}
class CreateAndUpdateGatewayCredentialAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.CreateUpdateGatewayCredential;
    }
}
class GatewayCredentialCreatedOrUpdatedAction {
    constructor(payload) {
        this.payload = payload;
        this.type = GatewayCredentialsActionTypes.GatewayCredentialCreatedUpdated;
    }
}

class GatewayCredentials {
}
const GET_EMPTY_CREDS = () => {
    return {
        merchantId: '',
        gatewayCredentialId: null,
        secondaryMerchantId: '',
        password: '',
        url: '',
        gatewayOptions: [],
        enabled: false,
        role: null,
        hasPayments: false,
        createdBy: '',
        createdOn: '',
        lastModifiedOn: '',
        lastModifiedBy: '',
        active: false,
    };
};
function isEmptyCreds(creds) {
    return !creds.merchantId && !creds.secondaryMerchantId && !creds.role;
}

const initialMerchantAccountState = {
    merchantAccountId: 0,
    url: null,
    createdBy: null,
    enabled: false,
    tenantId: null,
    createdOn: null,
    name: null,
    token: null,
    settlementTime: null,
    gatewayId: 0,
    gatewayCredentials: [GET_EMPTY_CREDS()],
    hasPayments: null,
    status: null,
    interchangeDefaults: null,
    fraudMonitoringDataTrackingEnabled: false,
    allowableCardBrands: [],
    maxPaymentThreshold: null,
    isDefault: false,
    branches: [],
    email: null,
    paymentFacilitator: "None",
    gatewayOptions: null,
};
const initialMerchantAccountListState = [];
const initialMerchantAccountStateState = {
    merchantAccount: initialMerchantAccountState,
    configurationChanged: false,
    verifyingCredential: false,
    loadingConfig: false,
    deletingCredential: false,
};
function merchantAccountReducer(state = initialMerchantAccountStateState, action) {
    switch (action.type) {
        case MerchantAccountActionTypes.InterchangeDefaultsUpdated: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.ResetMerchantAccount: {
            return { ...initialMerchantAccountStateState };
        }
        case MerchantAccountActionTypes.MerchantAccountDisabled: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.MerchantAccountEnabled: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.InterchangeDefaultsCreated: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.NewMerchantAccountCreated: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.MerchantAccountUpdated: {
            return {
                ...state,
                merchantAccount: action.payload,
                configurationChanged: true,
            };
        }
        case MerchantAccountActionTypes.MerchantAccountDeleted: {
            return { ...initialMerchantAccountStateState };
        }
        case MerchantAccountActionTypes.MerchantAccountLoaded: {
            return { ...state, merchantAccount: action.payload };
        }
        case MerchantAccountActionTypes.InterchangeDefaultsDeleted: {
            return {
                ...state,
                merchantAccount: {
                    ...state.merchantAccount,
                    interchangeDefaults: null,
                },
            };
        }
        case GatewayCredentialsActionTypes.VerifyGatewayCredential: {
            return { ...state, ...action.payload, verifyingCredential: true };
        }
        case GatewayCredentialsActionTypes.VerifyGatewayCredentialSuccess: {
            return { ...state, ...action.payload, verifyingCredential: false };
        }
        case GatewayCredentialsActionTypes.VerifyGatewayCredentialError: {
            return { ...state, ...action.payload, verifyingCredential: false };
        }
        case GatewayCredentialsActionTypes.DeleteGateWayCredential: {
            return { ...state, ...action.payload, deletingCredential: true };
        }
        case GatewayCredentialsActionTypes.DeleteGateWayCredentialSuccess: {
            return { ...state, ...action.payload, deletingCredential: false };
        }
        case GatewayCredentialsActionTypes.DeleteGateWayCredentialError: {
            return { ...state, ...action.payload, deletingCredential: false };
        }
        default: {
            return state;
        }
    }
}
function merchantAccountListReducer(state = initialMerchantAccountListState, action) {
    switch (action.type) {
        case MerchantAccountActionTypes.MerchantAccountListLoaded: {
            return action.payload;
        }
        case MerchantAccountActionTypes.InterchangeDefaultsCreated: {
            if (state.some((x) => x.merchantAccountId == action.payload.merchantAccountId)) {
                let acc = state.filter((x) => x.merchantAccountId == action.payload.merchantAccountId)[0];
                acc.interchangeDefaults = action.payload;
                return [
                    ...state.filter((x) => x.merchantAccountId !== acc.merchantAccountId),
                    acc,
                ];
            }
            return state;
        }
        case MerchantAccountActionTypes.InterchangeDefaultsDeleted: {
            if (state.some((x) => x.merchantAccountId == action.payload.merchantAccountId)) {
                let acc = state.filter((x) => x.merchantAccountId == action.payload.merchantAccountId)[0];
                acc.interchangeDefaults = null;
                return [
                    ...state.filter((x) => x.merchantAccountId !== acc.merchantAccountId),
                    acc,
                ];
            }
            return state;
        }
        case MerchantAccountActionTypes.MerchantAccountUpdated: {
            if (state.some((x) => x.merchantAccountId == action.payload.merchantAccountId)) {
                return [
                    ...state.filter((x) => x.merchantAccountId !== action.payload.merchantAccountId),
                    action.payload,
                ];
            }
            return state;
        }
        case MerchantAccountActionTypes.MerchantAccountDeleted: {
            if (state.some((x) => x.merchantAccountId === action.payload)) {
                return state.filter((x) => x.merchantAccountId !== action.payload);
            }
            return state;
        }
        case MerchantAccountActionTypes.NewMerchantAccountCreated: {
            if (!state.some((x) => x.merchantAccountId === action.payload.merchantAccountId)) {
                let account = action.payload;
                return [...state, account];
            }
            return state;
        }
        case MerchantAccountActionTypes.InterchangeDefaultsUpdated: {
            if (state.some((x) => x.merchantAccountId == action.payload.merchantAccountId)) {
                let acc = state.filter((x) => x.merchantAccountId == action.payload.merchantAccountId)[0];
                acc.interchangeDefaults = action.payload;
                return [
                    ...state.filter((x) => x.merchantAccountId !== acc.merchantAccountId),
                    acc,
                ];
            }
            return state;
        }
        default: {
            return state;
        }
    }
}

const initialGatewayListState$1 = [];
const initialGatewayState = {
    gatewayId: 0,
    gatewayName: null,
    displayName: null,
    settlementTime: null,
    credentialFields: [
        { gatewayFieldName: "MerchantId", standardizedFieldName: "MerchantId", isRequired: true },
        { gatewayFieldName: "SecondaryMerchantId", standardizedFieldName: "SecondaryMerchantId", isRequired: true },
        { gatewayFieldName: "MerchantPassword", standardizedFieldName: "MerchantPassword", isRequired: true }
    ]
};
function gatewayListReducer(state = initialGatewayListState$1, action) {
    switch (action.type) {
        case GatewayActionTypes.GatewayListLoaded: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
function gatewayReducer(state = initialGatewayState, action) {
    switch (action.type) {
        case GatewayActionTypes.GatewayLoaded: {
            return { ...state, ...action.payload };
        }
        case GatewayActionTypes.ResetGateway: {
            return { ...initialGatewayState };
        }
        default: {
            return state;
        }
    }
}

const initialGatewayListState = [];
function tenantUserListReducer(state = initialGatewayListState, action) {
    switch (action.type) {
        case TenantUserActionTypes.TenantUserListLoaded: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}

const reducers = {
    merchantAccountList: merchantAccountListReducer,
    merchantAccount: merchantAccountReducer,
    gatewayList: gatewayListReducer,
    gateway: gatewayReducer,
    tenantUserList: tenantUserListReducer
};
const getMerchantAccountState = createFeatureSelector('merchantaccount');

const SingleMerchantAccountStore = createSelector(getMerchantAccountState, (state) => state.merchantAccount);
const MerchantAccountListStore = createSelector(getMerchantAccountState, (state) => state.merchantAccountList);
const SelectSingleMerchantAccount = createSelector(getMerchantAccountState, (state) => state.merchantAccount.merchantAccount);
const SelectVerifyingCredentials = createSelector(getMerchantAccountState, (state) => state.merchantAccount.verifyingCredential);
const SelectConfigurationChanged = createSelector(getMerchantAccountState, (state) => state.merchantAccount.configurationChanged);
const SelectDeleteCredential = createSelector(getMerchantAccountState, (state) => state.merchantAccount.deletingCredential);

const SingleGatewayStore = createSelector(getMerchantAccountState, state => state.gateway);
const GatewayListStore = createSelector(getMerchantAccountState, state => state.gatewayList);

const TenantUserListStore = createSelector(getMerchantAccountState, state => state.tenantUserList);

class CreateNewMerchantAccountRequest {
}

class CreateInterchangeDefaultsRequest {
}

class UpdateMerchantAccountRequest {
}

class UpdateInterchangeDefaultsRequest {
}

class InterchangeFields {
}

class ReferentialValue {
}

class RelativeOrderDate {
}

class TimeOfDayServiceModel {
}

class VerifyCredentialsRequest {
}

class UserStore {
}

class MerchantRegistrationPermissions {
    constructor(store) {
        this.store = store;
    }
    //read
    CanRead$() {
        return this._hasMerchantRegUiPermission('read');
    }
    //add
    CanAdd$() {
        return this._hasMerchantRegUiPermission('create');
    }
    //update
    CanUpdate$() {
        return this._hasMerchantRegUiPermission('edit');
    }
    //delete
    CanDelete$() {
        return this._hasMerchantRegUiPermission('delete');
    }
    _hasMerchantRegUiPermission(actionName) {
        return this.store.pipe(select(UserPermissionStore)).pipe(map((permissionData) => {
            if (permissionData[0]) {
                let paymentPermissionData = permissionData.filter((x) => x.sectionId === "arc-permission-section-payments");
                if (paymentPermissionData[0]) {
                    let permissions = paymentPermissionData[0].permissions;
                    if (permissions.some(x => x.permissionId === "arc-payments-permission-gateways-view") &&
                        permissions.some(x => x.permissionId === "arc-payments-permission-cardmerchantaccountmanagement")) {
                        let gatewayRegPermission = permissions.filter(x => x.permissionId === "arc-payments-permission-gateways-view")[0];
                        let merchantAccountPermission = permissions.filter(x => x.permissionId === "arc-payments-permission-cardmerchantaccountmanagement")[0];
                        return (gatewayRegPermission.read && merchantAccountPermission[actionName]);
                    }
                }
            }
            return false;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantRegistrationPermissions_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantRegistrationPermissions)(i0.ɵɵinject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: MerchantRegistrationPermissions, factory: MerchantRegistrationPermissions.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantRegistrationPermissions, [{
        type: Injectable
    }], () => [{ type: i1$2.Store }], null); })();

class GatewayCredsStoreManagerService {
    constructor(store) {
        this.store = store;
        this.selectedMerchantAccount$ = this.store.pipe(select(SelectSingleMerchantAccount));
        this.selectConfigurationChanged$ = this.store.pipe(select(SelectConfigurationChanged));
        this.selectDeleteCredential$ = this.store.pipe(select(SelectDeleteCredential));
    }
    verifyCredential(credential) {
        this.store.dispatch(new VerifyGatewayCredentialAction(credential));
    }
    deleteGatewayCredential(gatewayCredential) {
        this.store.dispatch(new DeleteGateWayCredentialAction(gatewayCredential));
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayCredsStoreManagerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayCredsStoreManagerService)(i0.ɵɵinject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: GatewayCredsStoreManagerService, factory: GatewayCredsStoreManagerService.ɵfac, providedIn: "root" }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayCredsStoreManagerService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], () => [{ type: i1$2.Store }], null); })();

var SettingsAuditTypes;
(function (SettingsAuditTypes) {
    SettingsAuditTypes["FETCH_SETTING_AUDIT_DATA"] = "[CARD_MARS_SETTING_AUDIT] Load setting audit data";
    SettingsAuditTypes["FETCH_SETTING_AUDIT_SUCCESS"] = "[CARD_MARS_SETTING_AUDIT]  Load setting audit data Success";
    SettingsAuditTypes["FETCH_SETTING_AUDIT_ERROR"] = "[CARD_MARS_SETTING_AUDIT]  Load setting audit data Error";
    SettingsAuditTypes["SAVE_SETTING_AUDIT_DATA"] = "[CARD_MARS_SETTING_AUDIT]  Post setting audit data";
    SettingsAuditTypes["SAVE_SETTING_AUDIT_DATA_SUCCESS"] = "[CARD_MARS_SETTING_AUDIT]  Post setting audit data Success";
})(SettingsAuditTypes || (SettingsAuditTypes = {}));
const GetSettingAuditData = createAction(SettingsAuditTypes.FETCH_SETTING_AUDIT_DATA, props());
const GetSettingAuditDataSuccess = createAction(SettingsAuditTypes.FETCH_SETTING_AUDIT_SUCCESS, props());
const GetSettingAuditDataError = createAction(SettingsAuditTypes.FETCH_SETTING_AUDIT_ERROR, props());
const SaveSettingAuditData = createAction(SettingsAuditTypes.SAVE_SETTING_AUDIT_DATA, props());
const SaveSettingAuditDataSuccess = createAction(SettingsAuditTypes.SAVE_SETTING_AUDIT_DATA_SUCCESS);

const MERCHANT_ACCOUNT_TARGET_TYPE = "merchantAccountsListConfig";
const INTERCHANGE_DEFAULT_TARGET_TYPE = "interchangeDefaultConfig";

class AuditStoreManagerService {
    constructor() { }
    createSaveAuditAction(target, targetType, actionDescription, auditData) {
        return SaveSettingAuditData({
            payload: {
                target,
                targetType,
                configurationData: { actionDescription, auditData },
            },
        });
    }
    createMerchantAccountAuditAction(merchantAccountId, actionDescription, auditData) {
        return this.createSaveAuditAction(merchantAccountId.toString(), MERCHANT_ACCOUNT_TARGET_TYPE, actionDescription, auditData);
    }
    createInterchangeDefaultAuditAction(merchantAccountId, actionDescription, auditData) {
        return this.createSaveAuditAction(merchantAccountId.toString(), INTERCHANGE_DEFAULT_TARGET_TYPE, actionDescription, auditData);
    }
    /** @nocollapse */ static { this.ɵfac = function AuditStoreManagerService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AuditStoreManagerService)(); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: AuditStoreManagerService, factory: AuditStoreManagerService.ɵfac, providedIn: "root" }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuditStoreManagerService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], () => [], null); })();

class GatewayCredentialsEffects {
    constructor(actions$, merchantAccountService, store$, translateService, auditStoreManager) {
        this.actions$ = actions$;
        this.merchantAccountService = merchantAccountService;
        this.store$ = store$;
        this.translateService = translateService;
        this.auditStoreManager = auditStoreManager;
        // Gateway Credential Effects
        this.verifyGatewayCedential$ = createEffect(() => {
            return this.actions$.pipe(ofType(GatewayCredentialsActionTypes.VerifyGatewayCredential), map$1((action) => action.payload), withLatestFrom(this.store$.select(AuthUserStore), this.store$.select(SelectSingleMerchantAccount)), switchMap(([gatewayCredential, user, merchantAccount]) => {
                return this.merchantAccountService
                    .VerifyGateWayCredential(user.activeTenant.tenantId, merchantAccount.merchantAccountId, gatewayCredential)
                    .pipe(switchMap((response) => {
                    return of(new VerifyGatewayCredentialSuccessAction(response), new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_GATEWAY_CREDENTIAL')} \'${gatewayCredential.merchantId}\' ${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_VERIFY_SUCCESS')}`,
                    }), this.auditStoreManager.createMerchantAccountAuditAction(merchantAccount.merchantAccountId, `Gateway way credential ${gatewayCredential.merchantId} Verified`, gatewayCredential));
                }), catchError((err) => {
                    return of(new VerifyGatewayCredentialErrorAction(err), new UserNotificationAction({
                        type: 'error',
                        message: `${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_GATEWAY_CREDENTIAL')} \'${gatewayCredential.merchantId}\' ${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_VERIFY_ERROR')}`,
                    }));
                }));
            }));
        });
        this.deleteGatewayCredential$ = createEffect(() => {
            return this.actions$.pipe(ofType(GatewayCredentialsActionTypes.DeleteGateWayCredential), map$1((action) => action.payload), withLatestFrom(this.store$.select(AuthUserStore), this.store$.select(SelectSingleMerchantAccount)), switchMap(([gatewayCredential, user, merchantAccount]) => {
                return this.merchantAccountService
                    .DeleteGatewayCredential(user.activeTenant.tenantId, merchantAccount.merchantAccountId, gatewayCredential)
                    .pipe(switchMap((response) => {
                    return of(new LoadMerchantAccountAction(merchantAccount.merchantAccountId), new LoadMerchantAccountListAction({}), new DeleteGateWayCredentialSuccessAction(response), new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('DELETE_GATEWAY_CREDENTIAL_GATEWAY_CREDENTIAL')} \'${gatewayCredential.merchantId}\' ${this.translateService.instant('DELETE_GATEWAY_CREDENTIAL_DELETE_SUCCESS')}`,
                    }), this.auditStoreManager.createMerchantAccountAuditAction(merchantAccount.merchantAccountId, `Gateway Credential ${gatewayCredential.merchantId} Deleted`, gatewayCredential));
                }), catchError((err) => {
                    return of(new DeleteGateWayCredentialErrorAction(err), new UserNotificationAction({
                        type: 'error',
                        message: `${this.translateService.instant('DELETE_GATEWAY_CREDENTIAL_GATEWAY_CREDENTIAL')} \'${gatewayCredential.merchantId}\' ${this.translateService.instant('DELETE_GATEWAY_CREDENTIAL_DELETE_ERROR')}`,
                    }));
                }));
            }));
        });
        this.createUpdateGatewayCredential$ = createEffect(() => {
            return this.actions$.pipe(ofType(GatewayCredentialsActionTypes.CreateUpdateGatewayCredential), map$1((action) => action.payload), withLatestFrom(this.store$.select(AuthUserStore), this.store$.select(SelectSingleMerchantAccount)), switchMap(([payload, user, merchantAccount]) => {
                //don't call the api if the gatewayCredentials is empty
                if (payload.gatewayCredentials.length == 1 &&
                    isEmptyCreds(payload.gatewayCredentials[0])) {
                    return of(new LoadMerchantAccountListAction({}));
                }
                return this.merchantAccountService
                    .buildApiCalls(user.activeTenant.tenantId, payload.merchantAccountId, payload.gatewayCredentials)
                    .pipe(switchMap((response) => {
                    return of(new LoadMerchantAccountListAction({}), new GatewayCredentialCreatedOrUpdatedAction(response), new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_CREATE_UPDATE_SUCCESS')}`,
                    }), this.auditStoreManager.createMerchantAccountAuditAction(merchantAccount.merchantAccountId, `Gateway way credential ${payload.merchantAccountId} Created or updated`, payload));
                }), catchError((err) => {
                    return of(new GatewayCredentialCreatedOrUpdatedAction(err), new UserNotificationAction({
                        type: 'error',
                        message: `
                  ${this.translateService.instant('GATEWAY_CREDENTIALS_ACTIONS_CREATE_UPDATE_ERROR')}`,
                    }));
                }));
            }));
        });
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayCredentialsEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayCredentialsEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(MerchantAccountService), i0.ɵɵinject(i1$2.Store), i0.ɵɵinject(i1$1.TranslateService), i0.ɵɵinject(AuditStoreManagerService)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: GatewayCredentialsEffects, factory: GatewayCredentialsEffects.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayCredentialsEffects, [{
        type: Injectable
    }], () => [{ type: i1$3.Actions }, { type: MerchantAccountService }, { type: i1$2.Store }, { type: i1$1.TranslateService }, { type: AuditStoreManagerService }], null); })();

class GatewayEffects {
    constructor(actions$, GatewayService, store$, translateService) {
        this.actions$ = actions$;
        this.GatewayService = GatewayService;
        this.store$ = store$;
        this.translateService = translateService;
        this.getGateway$ = createEffect(() => {
            return this.actions$.pipe(ofType(GatewayActionTypes.LoadGateway), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.GatewayService.GetGateway(user.activeTenant.tenantId, payload).pipe(switchMap$1(gateway => [
                    new GatewayLoadedAction(gateway)
                ]), catchError$1(() => of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant('ARC_PAYMENTS_GATEWAY_EFFECTS_GET_GATEWAY_ERROR_MESSAGE')
                }))));
            }));
        });
        this.allGateways$ = createEffect(() => {
            return this.actions$.pipe(ofType(GatewayActionTypes.LoadGatewayList), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.GatewayService.GetGatewayList(user.activeTenant.tenantId).pipe(switchMap$1(gateways => [
                    new GatewayListLoadedAction(gateways)
                ]), catchError$1(() => of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant('ARC_PAYMENTS_GATEWAY_EFFECTS_GET_ALL_GATEWAY_ERROR_MESSAGE')
                }))));
            }));
        });
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(GatewayRegistrationV1Service), i0.ɵɵinject(i1$2.Store), i0.ɵɵinject(i1$1.TranslateService)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: GatewayEffects, factory: GatewayEffects.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayEffects, [{
        type: Injectable
    }], () => [{ type: i1$3.Actions }, { type: GatewayRegistrationV1Service }, { type: i1$2.Store }, { type: i1$1.TranslateService }], null); })();

class MerchantAccountEffects {
    constructor(actions$, merchantAccountService, store$, translateService, auditStoreManager) {
        this.actions$ = actions$;
        this.merchantAccountService = merchantAccountService;
        this.store$ = store$;
        this.translateService = translateService;
        this.auditStoreManager = auditStoreManager;
        this.loadMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.LoadMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.merchantAccountService
                    .GetMerchantAccount(user.activeTenant.tenantId, payload)
                    .pipe(map((accounts) => new MerchantAccountLoadedAction(accounts)));
            }));
        });
        this.allMerchantAccounts$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.LoadMerchantAccountList), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([, user]) => {
                return this.merchantAccountService
                    .GetMerchantAccountList(user.activeTenant.tenantId)
                    .pipe(map((accounts) => new MerchantAccountListLoadedAction(accounts)));
            }));
        });
        this.createMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.CreateMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                let newAccount = {
                    gatewayId: payload.gatewayId,
                    merchantUrl: payload.url,
                    name: payload.name,
                    settlementTime: payload.settlementTime,
                    fraudMonitoringDataTrackingEnabled: payload.fraudMonitoringDataTrackingEnabled,
                    maxPaymentThreshold: payload.maxPaymentThreshold,
                    allowableCardBrands: payload.allowableCardBrands,
                    isDefault: payload.isDefault,
                    email: payload.email,
                    branches: payload.branches,
                    paymentFacilitator: payload.paymentFacilitator,
                };
                return this.merchantAccountService
                    .CreateNewMerchantAccount(newAccount, user.activeTenant.tenantId)
                    .pipe(switchMap$1((result) => [
                    new NewMerchantAccountCreatedAction({
                        ...result,
                    }),
                    new CreateAndUpdateGatewayCredentialAction({
                        merchantAccountId: result.merchantAccountId,
                        gatewayCredentials: payload.gatewayCredentials,
                    }),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_CREATE_MERCHANT_ACCOUNT_SUCCESS_PREFIX')} \'${result.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_CREATE_MERCHANT_ACCOUNT_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createMerchantAccountAuditAction(result.merchantAccountId, `Merchant Account ${payload.name} Created`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_CREATE_MERCHANT_ACCOUNT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.updateMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.UpdateMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, currentUser]) => {
                let updateRequest = {
                    gatewayId: payload.gatewayId,
                    merchantId: null,
                    secondaryMerchantId: null,
                    merchantPassword: null,
                    merchantUrl: null,
                    name: payload.name,
                    settlementTime: payload.settlementTime,
                    fraudMonitoringDataTrackingEnabled: payload.fraudMonitoringDataTrackingEnabled,
                    maxPaymentThreshold: payload.maxPaymentThreshold,
                    allowableCardBrands: payload.allowableCardBrands,
                    isDefault: payload.isDefault,
                    email: payload.email,
                    branches: payload.branches,
                    paymentFacilitator: payload.paymentFacilitator,
                };
                return this.merchantAccountService
                    .UpdateMerchantAccount(updateRequest, currentUser.activeTenant.tenantId, payload.merchantAccountId)
                    .pipe(switchMap$1(() => [
                    new MerchantAccountUpdatedAction({
                        ...payload,
                    }),
                    new CreateAndUpdateGatewayCredentialAction({
                        merchantAccountId: payload.merchantAccountId,
                        gatewayCredentials: payload.gatewayCredentials,
                    }),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_UPDATE_MERCHANT_ACCOUNT_SUCCESS_PREFIX')} \'${updateRequest.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_UPDATE_MERCHANT_ACCOUNT_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createMerchantAccountAuditAction(payload.merchantAccountId, `Merchant Account ${payload.name} Updated`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_UPDATE_MERCHANT_ACCOUNT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.deleteMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.DeleteMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.merchantAccountService
                    .DeleteMerchantAccount(user.activeTenant.tenantId, payload.merchantAccountId)
                    .pipe(switchMap$1(() => [
                    new MerchantAccountDeletedAction(payload.merchantAccountId),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_MERCHANT_ACCOUNT_SUCCESS_PREFIX')} \'${payload.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_MERCHANT_ACCOUNT_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createMerchantAccountAuditAction(payload.merchantAccountId, `Merchant Account ${payload.name} Deleted`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_MERCHANT_ACCOUNT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.createInterchangeDefault$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.CreateInterchangeDefaults), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                let requestPayload = {
                    merchantAccountId: payload.merchantAccountId,
                    optimizationPreference: payload.optimizationPreference,
                    interchangeFieldDefaults: payload.defaultableFields,
                };
                return this.merchantAccountService
                    .CreateInterchangeDefaults(user.activeTenant.tenantId, requestPayload)
                    .pipe(switchMap$1((result) => [
                    new InterchangeDefaultsCreatedAction(result),
                    new UserNotificationAction({
                        type: 'success',
                        message: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_CREATE_INTERCHANGE_DEFAULT_SUCCESS_MESSAGE'),
                    }),
                    this.auditStoreManager.createInterchangeDefaultAuditAction(payload.merchantAccountId, `Interchange defaults set for merchant ${payload.name}`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_CREATE_INTERCHANGE_DEFAULT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.updateInterchangeDefault$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.UpdateInterchangeDefaults), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                let requestPayload = {
                    merchantAccountId: payload.merchantAccountId,
                    interchangeDefaultId: payload.id,
                    optimizationPreference: payload.optimizationPreference,
                    interchangeFieldDefaults: payload.defaultableFields,
                };
                return this.merchantAccountService
                    .UpdateInterchangeDefaults(user.activeTenant.tenantId, requestPayload)
                    .pipe(switchMap$1(() => [
                    new InterchangeDefaultsUpdatedAction(payload),
                    new UserNotificationAction({
                        type: 'success',
                        message: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_UPDATE_INTERCHANGE_DEFAULT_SUCCESS_MESSAGE'),
                    }),
                    this.auditStoreManager.createInterchangeDefaultAuditAction(payload.merchantAccountId, `Interchange defaults updated for merchant ${payload.name}`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_UPDATE_INTERCHANGE_DEFAULT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.deleteInterchangeDefaults$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.DeleteInterchangeDefaults), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.merchantAccountService
                    .DeleteInterchangeDefaults(user.activeTenant.tenantId, payload.merchantAccountId, payload.interchangeDefaultId)
                    .pipe(switchMap$1(() => [
                    new InterchangeDefaultsDeletedAction({
                        merchantAccountId: payload.merchantAccountId,
                    }),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_INTERCHANGE_DEFAULT_SUCCESS_PREFIX')} \'${payload.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_INTERCHANGE_DEFAULT_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createInterchangeDefaultAuditAction(payload.merchantAccountId, `Interchange defaults deleted for merchant ${payload.name}`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_DELETE_INTERCHANGE_DEFAULT_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.disableMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.DisableMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.merchantAccountService
                    .DisableMerchantAccount(user.activeTenant.tenantId, payload.merchantAccountId)
                    .pipe(switchMap$1(() => [
                    new MerchantAccountDisabledAction({}),
                    new LoadMerchantAccountListAction({}),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_DISABLE_SUCCESS_PREFIX')} \'${payload.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_DISABLE_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createMerchantAccountAuditAction(payload.merchantAccountId, `Merchant Account ${payload.name} Disabled`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_DISABLE_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
        this.enableMerchantAccount$ = createEffect(() => {
            return this.actions$.pipe(ofType(MerchantAccountActionTypes.EnableMerchantAccount), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([payload, user]) => {
                return this.merchantAccountService
                    .EnableMerchantAccount(user.activeTenant.tenantId, payload.merchantAccountId)
                    .pipe(switchMap$1(() => [
                    new MerchantAccountEnabledAction({}),
                    new LoadMerchantAccountListAction({}),
                    new UserNotificationAction({
                        type: 'success',
                        message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_ENABLE_SUCCESS_PREFIX')} \'${payload.name}\' ${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_ENABLE_SUCCESS_SUFFIX')}`,
                    }),
                    this.auditStoreManager.createMerchantAccountAuditAction(payload.merchantAccountId, `Merchant Account ${payload.name} Enabled`, payload),
                ]), catchError$1((error) => of(new UserNotificationAction({
                    type: 'error',
                    message: `${this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_EFFECTS_MERCHANT_ACCOUNT_ENABLE_ERROR_MESSAGE')} ${error.error.errormessage}`,
                }))));
            }));
        });
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantAccountEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantAccountEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(MerchantAccountService), i0.ɵɵinject(i1$2.Store), i0.ɵɵinject(i1$1.TranslateService), i0.ɵɵinject(AuditStoreManagerService)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: MerchantAccountEffects, factory: MerchantAccountEffects.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantAccountEffects, [{
        type: Injectable
    }], () => [{ type: i1$3.Actions }, { type: MerchantAccountService }, { type: i1$2.Store }, { type: i1$1.TranslateService }, { type: AuditStoreManagerService }], null); })();

class TenantUserEffects {
    constructor(actions$, userService, store$, translateService) {
        this.actions$ = actions$;
        this.userService = userService;
        this.store$ = store$;
        this.translateService = translateService;
        this.allTenantUsers$ = createEffect(() => {
            return this.actions$.pipe(ofType(TenantUserActionTypes.LoadTenantUserList), map((action) => action.payload), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([, user]) => {
                return this.userService.v1TenantsByTenantIdUsersGet(user.activeTenant.tenantId).pipe(switchMap$1(usersRaw => [
                    new TenantUserListLoadedAction(usersRaw)
                ]), catchError$1(() => of(new UserNotificationAction({
                    type: 'error',
                    message: this.translateService.instant('ARC_PAYMENTS_TENANT_USERS_EFFECTS_GET_TENANT_USER_LIST_ERROR_MESSAGE')
                }))));
            }));
        });
    }
    /** @nocollapse */ static { this.ɵfac = function TenantUserEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TenantUserEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i1$2.Store), i0.ɵɵinject(i1$1.TranslateService)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: TenantUserEffects, factory: TenantUserEffects.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TenantUserEffects, [{
        type: Injectable
    }], () => [{ type: i1$3.Actions }, { type: i2.UserService }, { type: i1$2.Store }, { type: i1$1.TranslateService }], null); })();

const effects$1 = [GatewayEffects, MerchantAccountEffects, TenantUserEffects, GatewayCredentialsEffects];

class MerchantAccountStoreModule {
    /** @nocollapse */ static { this.ɵfac = function MerchantAccountStoreModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantAccountStoreModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: MerchantAccountStoreModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            StoreModule.forFeature('merchantaccount', reducers),
            EffectsModule.forFeature(effects$1)] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantAccountStoreModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    StoreModule.forFeature('merchantaccount', reducers),
                    EffectsModule.forFeature(effects$1)
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MerchantAccountStoreModule, { imports: [CommonModule, i1$2.StoreFeatureModule, i1$3.EffectsFeatureModule] }); })();

class MerchantFilterPipe {
    transform(accounts, filter) {
        if (filter != null) {
            return accounts.filter(acc => acc.merchantAccountId !== filter.merchantAccountId);
        }
        else {
            return accounts;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantFilterPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantFilterPipe)(); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "merchantFilter", type: MerchantFilterPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantFilterPipe, [{
        type: Pipe,
        args: [{
                name: "merchantFilter"
            }]
    }], null, null); })();

class SortByNamePipe {
    transform(objects) {
        if (objects) {
            return [...objects].sort((a, b) => {
                let nameA = ((a.name == null) ? '' : a.name.toUpperCase());
                let nameB = ((b.name == null) ? '' : b.name.toUpperCase());
                return (nameA > nameB) ? 1 : -1;
            });
        }
        else {
            return objects;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function SortByNamePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SortByNamePipe)(); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "sortByName", type: SortByNamePipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortByNamePipe, [{
        type: Pipe,
        args: [{
                name: "sortByName"
            }]
    }], null, null); })();

class ToSelectItemPipe {
    transform(objects, nameProperty, valueProperty) {
        if (objects) {
            return objects.map((x) => {
                let selectItem = {
                    label: x[nameProperty],
                    value: x[valueProperty],
                    disabled: x['disabled'],
                };
                return selectItem;
            });
        }
        else {
            return [];
        }
    }
    /** @nocollapse */ static { this.ɵfac = function ToSelectItemPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToSelectItemPipe)(); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "toSelectItem", type: ToSelectItemPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToSelectItemPipe, [{
        type: Pipe,
        args: [{
                name: 'toSelectItem',
            }]
    }], null, null); })();

// Filters a list of merchant accounts and only return those who have interchange defaults.
class PresentInterchangePipe {
    transform(accounts) {
        return accounts.filter(acc => acc.interchangeDefaults !== null);
    }
    /** @nocollapse */ static { this.ɵfac = function PresentInterchangePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PresentInterchangePipe)(); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "presentInterchange", type: PresentInterchangePipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PresentInterchangePipe, [{
        type: Pipe,
        args: [{
                name: "presentInterchange"
            }]
    }], null, null); })();

class AddGlobalDefaultsOptionPipe {
    transform(objects) {
        if (objects) {
            let item;
            item = { label: "Global Defaults", value: -1 };
            objects.push(item);
            return objects;
        }
        else {
            return [];
        }
    }
    /** @nocollapse */ static { this.ɵfac = function AddGlobalDefaultsOptionPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddGlobalDefaultsOptionPipe)(); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "addGlobalDefaultsOption", type: AddGlobalDefaultsOptionPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddGlobalDefaultsOptionPipe, [{
        type: Pipe,
        args: [{
                name: "addGlobalDefaultsOption"
            }]
    }], null, null); })();

class TranslateStatusPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(status) {
        return this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_STATUS_' + status.toUpperCase());
    }
    /** @nocollapse */ static { this.ɵfac = function TranslateStatusPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TranslateStatusPipe)(i0.ɵɵdirectiveInject(i1$1.TranslateService, 16)); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "translateStatus", type: TranslateStatusPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateStatusPipe, [{
        type: Pipe,
        args: [{
                name: "translateStatus"
            }]
    }], () => [{ type: i1$1.TranslateService }], null); })();

class BuildActionMenuItemsPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(account, hasEditPermission, hasDeletePermission) {
        let items = [];
        items.push({
            label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_EDIT_MENU_ITEM'),
            icon: 'edit',
            disabled: !hasEditPermission,
            command: () => { account.displayEditMenu(); }
        });
        if (account.status.toLowerCase() === "autoregistered" && account.enabled) {
            items.push({
                label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_REGISTER_MENU_ITEM'),
                icon: 'verified',
                disabled: !hasEditPermission,
                command: () => { account.enableMerchantAccount(); }
            });
        }
        else if (account.enabled) {
            items.push({
                label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_DISABLE_MENU_ITEM'),
                icon: 'stop',
                disabled: !hasEditPermission,
                command: () => { account.displayDisableConfirmation(account.merchantAccountId); }
            });
            items.push({
                label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_VIEW_TOKEN_MENU_ITEM'),
                icon: 'remove_red_eye',
                command: () => { account.displayTokenView(); }
            });
        }
        else {
            items.push({
                label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_ENABLE_MENU_ITEM'),
                icon: 'play_arrow',
                disabled: !hasEditPermission,
                command: () => { account.enableMerchantAccount(); }
            });
        }
        if (!account.hasPayments)
            items.push({
                label: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_DELETE_MENU_ITEM'),
                icon: 'delete',
                disabled: !hasDeletePermission,
                command: () => { account.displayDeleteConfirmation(account.merchantAccountId); }
            });
        return items;
    }
    /** @nocollapse */ static { this.ɵfac = function BuildActionMenuItemsPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BuildActionMenuItemsPipe)(i0.ɵɵdirectiveInject(i1$1.TranslateService, 16)); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "buildActionMenuItems", type: BuildActionMenuItemsPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BuildActionMenuItemsPipe, [{
        type: Pipe,
        args: [{
                name: "buildActionMenuItems"
            }]
    }], () => [{ type: i1$1.TranslateService }], null); })();

class LastUpdatedByPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(record) {
        if (record == null || !Object.keys(record.auditEvent).length) {
            return "";
        }
        const dateTime = new Date(record.auditEvent.utcTimestamp);
        const formattedDate = ` ${dateTime.getDate()} ${dateTime.toLocaleString("default", { month: "short" })} ${dateTime.getFullYear()} `;
        const message = `${this.translateService.instant("COMMONS.LAST_UPDATED_ON")} ${formattedDate}  ${this.translateService.instant("COMMONS.LAST_UPDATED_BY")} ${record.auditEvent.initiator}`;
        return message;
    }
    /** @nocollapse */ static { this.ɵfac = function LastUpdatedByPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LastUpdatedByPipe)(i0.ɵɵdirectiveInject(i1$1.TranslateService, 16)); }; }
    /** @nocollapse */ static { this.ɵpipe = /** @pureOrBreakMyCode */ i0.ɵɵdefinePipe({ name: "formatAuditRecordInfo", type: LastUpdatedByPipe, pure: true }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LastUpdatedByPipe, [{
        type: Pipe,
        args: [{
                name: "formatAuditRecordInfo",
            }]
    }], () => [{ type: i1$1.TranslateService }], null); })();

class MerchantAccount {
}
class GatewayOption {
}
class InterchangeDefaults {
}
class DefaultableInterchangeFields {
}
class InterchangeFieldValue {
}
class OrderDate {
}

const _c0$6 = () => ({ width: "550px" });
function TokenViewComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 1);
    i0.ɵɵtwoWayListener("visibleChange", function TokenViewComponent_Conditional_0_Template_p_dialog_visibleChange_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.display, $event) || (ctx_r1.display = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(1, "p-header", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "strong", 3);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "div", 4)(8, "h3", 5);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 6)(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "p-footer")(15, "button", 7);
    i0.ɵɵlistener("click", function TokenViewComponent_Conditional_0_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.copyNotification()); });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 8);
    i0.ɵɵlistener("click", function TokenViewComponent_Conditional_0_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closed()); });
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(23, _c0$6));
    i0.ɵɵtwoWayProperty("visible", ctx_r1.display);
    i0.ɵɵproperty("modal", true)("closable", false)("resizable", false)("focusOnShow", false)("draggable", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 15, "ARC_PAYMENTS_TOKEN_VIEW_HEADER"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.merchantAccount.name);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.merchantAccount.token);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 17, "ARC_PAYMENTS_TOKEN_VIEW_MESSAGE"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cbContent", ctx_r1.merchantAccount.token);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 19, "ARC_PAYMENTS_TOKEN_VIEW_COPY_TOKEN_BUTTON"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 21, "ARC_PAYMENTS_TOKEN_VIEW_CLOSE_BUTTON"), " ");
} }
class TokenViewComponent {
    constructor(messageService) {
        this.messageService = messageService;
        this.close = new EventEmitter();
    }
    copyNotification() {
        this.messageService.open('Token has been copied to your clipboard.', null, { severity: "success", icon: "content_paste" });
    }
    closed() {
        this.close.emit();
    }
    /** @nocollapse */ static { this.ɵfac = function TokenViewComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TokenViewComponent)(i0.ɵɵdirectiveInject(i5.MessageService)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: TokenViewComponent, selectors: [["pay-token-view"]], inputs: { merchantAccount: "merchantAccount", display: "display" }, outputs: { close: "close" }, decls: 1, vars: 1, consts: [["appendTo", "body", 3, "visible", "modal", "closable", "resizable", "focusOnShow", "style", "draggable"], ["appendTo", "body", 3, "visibleChange", "visible", "modal", "closable", "resizable", "focusOnShow", "draggable"], ["id", "pay-token-view-header"], ["id", "pay-token-view-name"], [2, "text-align", "center"], ["id", "pay-token-view-meracct"], ["id", "pay-token-text-msg", 1, "justify"], ["id", "pay-token-copy-button", "aur-button", "", "importance", "secondary", "ngxClipboard", "", 3, "click", "cbContent"], ["id", "pay-token-close-button", "aur-button", "", "importance", "primary", 3, "click"]], template: function TokenViewComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, TokenViewComponent_Conditional_0_Template, 21, 24, "p-dialog", 0);
        } if (rf & 2) {
            i0.ɵɵconditional(ctx.merchantAccount ? 0 : -1);
        } }, dependencies: [i5.ButtonComponent, i2$1.Dialog, i2$2.Header, i2$2.Footer, i4.ClipboardDirective, i1$1.TranslatePipe], styles: [".justify[_ngcontent-%COMP%]{text-align:justify}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenViewComponent, [{
        type: Component,
        args: [{ selector: 'pay-token-view', template: "@if (merchantAccount) {\n  <p-dialog\n    [(visible)]=\"display\"\n    [modal]=\"true\"\n    appendTo=\"body\"\n    [closable]=\"false\"\n    [resizable]=\"false\"\n    [focusOnShow]=\"false\"\n    [style]=\"{ width: '550px' }\"\n    [draggable]=\"false\"\n    >\n    <p-header id=\"pay-token-view-header\">\n      {{ 'ARC_PAYMENTS_TOKEN_VIEW_HEADER' | translate }}:\n      <strong id=\"pay-token-view-name\">{{ merchantAccount.name }}</strong>\n    </p-header>\n    <div>\n      <div style=\"text-align: center\">\n        <h3 id=\"pay-token-view-meracct\">{{ merchantAccount.token }}</h3>\n      </div>\n      <div class=\"justify\" id=\"pay-token-text-msg\">\n        <p>{{ 'ARC_PAYMENTS_TOKEN_VIEW_MESSAGE' | translate }}</p>\n      </div>\n    </div>\n    <p-footer>\n      <button\n        id=\"pay-token-copy-button\"\n        aur-button\n        importance=\"secondary\"\n        ngxClipboard\n        [cbContent]=\"merchantAccount.token\"\n        (click)=\"copyNotification()\"\n        >\n        {{ 'ARC_PAYMENTS_TOKEN_VIEW_COPY_TOKEN_BUTTON' | translate }}\n      </button>\n      <button\n        id=\"pay-token-close-button\"\n        aur-button\n        importance=\"primary\"\n        (click)=\"closed()\"\n        >\n        {{ 'ARC_PAYMENTS_TOKEN_VIEW_CLOSE_BUTTON' | translate }}\n      </button>\n    </p-footer>\n  </p-dialog>\n}\n", styles: [".justify{text-align:justify}\n"] }]
    }], () => [{ type: i5.MessageService }], { merchantAccount: [{
            type: Input
        }], display: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(TokenViewComponent, { className: "TokenViewComponent", filePath: "lib/components/token-view/token-view.component.ts", lineNumber: 16 }); })();

var MerchantEditorMode;
(function (MerchantEditorMode) {
    MerchantEditorMode[MerchantEditorMode["Create"] = 0] = "Create";
    MerchantEditorMode[MerchantEditorMode["Edit"] = 1] = "Edit";
})(MerchantEditorMode || (MerchantEditorMode = {}));

var AuditEventStoreKeys;
(function (AuditEventStoreKeys) {
    AuditEventStoreKeys["merchantAccount"] = "merchantAccount";
    AuditEventStoreKeys["interChangeDefaults"] = "interChangeDefaults";
})(AuditEventStoreKeys || (AuditEventStoreKeys = {}));

const initialState = {
    auditData: null,
    loadingAuditData: null,
};
const settingsAuditFeature = createFeature({
    name: "cardMarsSettingsAuditFeature",
    reducer: createReducer(initialState, on(GetSettingAuditDataSuccess, (state, { payload }) => ({
        ...state,
        auditData: {
            ...state.auditData,
            [payload.auditEventStoreKey]: payload.auditData,
        },
        loadingAuditData: false,
    })), on(GetSettingAuditDataError, (state, { payload }) => ({
        ...state,
        loadingAuditData: false,
        auditData: {
            ...state.auditData,
            [payload.auditEventStoreKey]: null,
        },
    })), on(GetSettingAuditData, (state) => ({
        ...state,
        loadingAuditData: true,
    }))),
});
// Store Selectors
const { name, // feature name
reducer, // feature reducer
selectAuditData, // feature selector
selectCardMarsSettingsAuditFeatureState, selectLoadingAuditData, } = settingsAuditFeature;

function LastUpdatedByComponent_Conditional_0_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatAuditRecordInfo");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx), " ");
} }
function LastUpdatedByComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LastUpdatedByComponent_Conditional_0_Conditional_1_Template, 3, 3, "p");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_1_0 = i0.ɵɵpipeBind1(2, 1, ctx_r0.auditData)) ? 1 : -1, tmp_1_0);
} }
class LastUpdatedByComponent {
    constructor(store) {
        this.store = store;
        this.target = null;
        this.targetType = null;
        this.auditEventStoreKey = null;
        this.auditData = this.store
            .select(selectAuditData)
            .pipe(filter((data) => data != null), map$1((data) => data[this.auditEventStoreKey]));
        this.loadingAuditData = this.store.select(selectLoadingAuditData);
    }
    ngOnChanges(changes) {
        this.dispatchGetSettingAuditData();
    }
    dispatchGetSettingAuditData() {
        const { target, targetType, auditEventStoreKey } = this;
        this.store.dispatch(GetSettingAuditData({
            payload: { target, targetType, auditEventStoreKey },
        }));
    }
    /** @nocollapse */ static { this.ɵfac = function LastUpdatedByComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LastUpdatedByComponent)(i0.ɵɵdirectiveInject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: LastUpdatedByComponent, selectors: [["payments-last-updated-by"]], inputs: { target: "target", targetType: "targetType", auditEventStoreKey: "auditEventStoreKey" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, template: function LastUpdatedByComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LastUpdatedByComponent_Conditional_0_Template, 3, 3, "div");
            i0.ɵɵpipe(1, "async");
        } if (rf & 2) {
            i0.ɵɵconditional(!i0.ɵɵpipeBind1(1, 1, ctx.loadingAuditData) ? 0 : -1);
        } }, dependencies: [i1$4.AsyncPipe, LastUpdatedByPipe], styles: ["[_nghost-%COMP%]   p[_ngcontent-%COMP%]{color:#4d6069;font-size:12px;margin:0 auto}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LastUpdatedByComponent, [{
        type: Component,
        args: [{ selector: "payments-last-updated-by", template: "@if (!(loadingAuditData | async)) {\n  <div>\n    @if (auditData | async; as lastAuditRecord) {\n      <p>\n        {{ lastAuditRecord | formatAuditRecordInfo }}\n      </p>\n    }\n  </div>\n}\n", styles: [":host p{color:#4d6069;font-size:12px;margin:0 auto}\n"] }]
    }], () => [{ type: i1$2.Store }], { target: [{
            type: Input
        }], targetType: [{
            type: Input
        }], auditEventStoreKey: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LastUpdatedByComponent, { className: "LastUpdatedByComponent", filePath: "lib/shared/components/last-updated-by/last-updated-by.component.ts", lineNumber: 15 }); })();

const CyberSourceEnabledGatwayOption = {
    name: 'paysubscriptioncreateservice_run',
    value: 'true',
};
const GatwayUrlHeaderId = 'gateway-url';
const CybersourceUrlHeaderId = 'cybersource-enablement';
const PricingModels = [
    { label: 'Unidentified', id: 'Default', disabled: false },
    { label: 'Billtrust Surcharging', id: 'Surcharge', disabled: false },
    { label: 'Interchange Plus', id: 'InterchangePlus', disabled: false },
];
const CustomErrorMessages = {
    secondaryIDNotValid: 'Secondary ID must be one of the following: north_america, asia_pacific, europe',
    invalidUrl: 'Url must be a valid https URI. eg: https://www.SomeGatewayMerchantUrl.com/makeapayment.',
};
const ValidSecondaryIdsForTNSMerchant = [
    'north_america',
    'asia_pacific',
    'europe',
];
const TABLE_COLUMNS = () => {
    const translateService = inject(TranslateService);
    return [
        {
            header: translateService.instant('COMMONS.ID'),
            align: 'left',
            field: 'merchantId',
            headerId: 'gateway-id',
        },
        {
            header: translateService.instant('ARC_PAYMENTS_GATEWAY_CREDENTIALS_EDIT_SECONDARY_ID'),
            align: 'left',
            field: 'secondaryMerchantId',
            headerId: 'gateway-secondary-id',
        },
        {
            header: translateService.instant('COMMONS.PASSWORD'),
            align: 'left',
            field: 'password',
            headerId: 'gateway-password',
        },
        {
            header: translateService.instant('ARC_PAYMENTS_GATEWAY_CREDENTIALS_PRICING_MODEL'),
            align: 'left',
            field: 'role',
            headerId: 'gateway-pricing-model',
        },
        {
            header: '',
            align: 'left',
            field: 'actions',
            headerId: 'gateway-actions',
        },
    ];
};
const URL_TABLE_COLUMN = (header = null) => {
    return {
        header,
        align: 'left',
        field: 'url',
        headerId: GatwayUrlHeaderId,
    };
};
const CYBER_SOURCE_TABLE_COLUMN = () => {
    return {
        header: `CyberSource Tokenization`,
        align: 'left',
        field: 'url',
        headerId: CybersourceUrlHeaderId,
    };
};

class Gateway {
}
class GatewayCredentialField {
}

class TimeOfDay {
}

const urlValidator = () => {
    return (control) => {
        if (control?.value) {
            const utlInitialPattern = 'https://';
            const inputValue = control.value;
            return inputValue?.startsWith(utlInitialPattern) &&
                inputValue?.length >= utlInitialPattern.length + 1
                ? null
                : { invalidUrl: true };
        }
        return null;
    };
};

function LoadingButtonComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function LoadingButtonComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disabled)("id", ctx_r1.buttonId)("importance", ctx_r1.importance);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
} }
function LoadingButtonComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵelement(1, "aur-loading-spinner", 3);
    i0.ɵɵelementEnd();
} }
class LoadingButtonComponent {
    constructor() {
        this.loading = false;
        this.importance = 'primary';
        this.disabled = false;
        this.activeClick = new EventEmitter();
    }
    handleClick() {
        if (!this.loading && !this.disabled) {
            this.activeClick.emit();
        }
    }
    /** @nocollapse */ static { this.ɵfac = function LoadingButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingButtonComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: LoadingButtonComponent, selectors: [["loading-button"]], inputs: { loading: "loading", label: "label", importance: "importance", buttonId: "buttonId", disabled: "disabled" }, outputs: { activeClick: "activeClick" }, decls: 2, vars: 2, consts: [["aur-button", "", 3, "disabled", "id", "importance"], ["aur-button", "", "disabled", "", "importance", "secondary", 1, "loading-button"], ["aur-button", "", 3, "click", "disabled", "id", "importance"], ["context", "inline", "name", "loading-button", "id", "save-spinner"]], template: function LoadingButtonComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, LoadingButtonComponent_Conditional_0_Template, 2, 4, "button", 0)(1, LoadingButtonComponent_Conditional_1_Template, 2, 0, "button", 1);
        } if (rf & 2) {
            i0.ɵɵconditional(!ctx.loading ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 1 : -1);
        } }, dependencies: [i5.ButtonComponent, i5.LoadingSpinnerComponent], styles: ["[_nghost-%COMP%]   .loading-button[_ngcontent-%COMP%]{min-width:83px}[_ngcontent-%COMP%]:is()   aur-loading-spinner[_ngcontent-%COMP%]{display:flex;align-items:center}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoadingButtonComponent, [{
        type: Component,
        args: [{ selector: 'loading-button', template: "@if (!loading) {\n  <button\n    [disabled]=\"disabled\"\n    aur-button\n    [id]=\"buttonId\"\n    [importance]=\"importance\"\n    (click)=\"handleClick()\"\n    >\n    {{ label }}\n  </button>\n}\n\n@if (loading) {\n  <button\n    aur-button\n    disabled\n    importance=\"secondary\"\n    class=\"loading-button\"\n    >\n    <aur-loading-spinner context=\"inline\" name=\"loading-button\" id=\"save-spinner\">\n    </aur-loading-spinner>\n  </button>\n}\n", styles: [":host .loading-button{min-width:83px}:is() aur-loading-spinner{display:flex;align-items:center}\n"] }]
    }], null, { loading: [{
            type: Input
        }], label: [{
            type: Input
        }], importance: [{
            type: Input
        }], buttonId: [{
            type: Input
        }], disabled: [{
            type: Input
        }], activeClick: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(LoadingButtonComponent, { className: "LoadingButtonComponent", filePath: "lib/shared/components/loading-button/loading-button.component.ts", lineNumber: 8 }); })();

const _c0$5 = () => ({ width: "400px", height: "245px" });
function GatewayCredentialDeleteModalComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "DELETE_GATEWAY_CREDENTIAL_MODAL_HEADER"), " ");
} }
function GatewayCredentialDeleteModalComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 4);
    i0.ɵɵlistener("click", function GatewayCredentialDeleteModalComponent_ng_template_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.handleCancel()); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "loading-button", 5);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵlistener("click", function GatewayCredentialDeleteModalComponent_ng_template_5_Template_loading_button_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.deleteGatewayCredential()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "COMMONS.NO"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(5, 6, "COMMONS.YES"))("buttonId", "delete-gateway-credential-button")("loading", i0.ɵɵpipeBind1(6, 8, ctx_r1.storeManager.selectDeleteCredential$));
} }
class GatewayCredentialDeleteModalComponent {
    constructor() {
        this.showModal = false;
        this.closeModal = new EventEmitter();
        this.storeManager = inject(GatewayCredsStoreManagerService);
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.storeManager.selectDeleteCredential$
            .pipe(takeUntil(this.destroy$), filter((loading) => loading != null))
            .subscribe((loadingConfig) => {
            // If configuration is loading while modal is open we want to close it
            // This means that a credential was deleted successfully
            if (loadingConfig) {
                this.handleCancel();
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    handleCancel() {
        this.closeModal.emit();
    }
    deleteGatewayCredential() {
        this.storeManager.deleteGatewayCredential(this.gatewayCredential);
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayCredentialDeleteModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayCredentialDeleteModalComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: GatewayCredentialDeleteModalComponent, selectors: [["gateway-credential-delete-modal"]], inputs: { showModal: "showModal", gatewayCredential: "gatewayCredential" }, outputs: { closeModal: "closeModal" }, decls: 6, vars: 10, consts: [[3, "visibleChange", "onHide", "visible", "modal", "draggable", "resizable"], ["pTemplate", "header"], ["pTemplate", "footer"], [1, "buttons"], ["aur-button", "", "importance", "secondary", 1, "cancel-button", 3, "click"], ["importance", "primary", 3, "click", "label", "buttonId", "loading"]], template: function GatewayCredentialDeleteModalComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "p-dialog", 0);
            i0.ɵɵtwoWayListener("visibleChange", function GatewayCredentialDeleteModalComponent_Template_p_dialog_visibleChange_0_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.showModal, $event) || (ctx.showModal = $event); return $event; });
            i0.ɵɵlistener("onHide", function GatewayCredentialDeleteModalComponent_Template_p_dialog_onHide_0_listener() { return ctx.handleCancel(); });
            i0.ɵɵtemplate(1, GatewayCredentialDeleteModalComponent_ng_template_1_Template, 3, 3, "ng-template", 1);
            i0.ɵɵelementStart(2, "p");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, GatewayCredentialDeleteModalComponent_ng_template_5_Template, 7, 10, "ng-template", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(9, _c0$5));
            i0.ɵɵtwoWayProperty("visible", ctx.showModal);
            i0.ɵɵproperty("modal", true)("draggable", false)("resizable", false);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "DELETE_GATEWAY_CREDENTIAL_MODAL_MESSAGE"), " ");
        } }, dependencies: [i5.ButtonComponent, i2$1.Dialog, i2$2.PrimeTemplate, LoadingButtonComponent, i1$4.AsyncPipe, i1$1.TranslatePipe], styles: ["[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   aur-input[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:600;margin:0}[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{display:flex;flex-flow:row;align-items:center;justify-content:right;padding:12px;border-top:solid 1px #E4E7E8}[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .download-button[_ngcontent-%COMP%]{margin-right:auto}[_nghost-%COMP%]   p-dialog[_ngcontent-%COMP%]   .cancel-button[_ngcontent-%COMP%]{margin-right:5px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayCredentialDeleteModalComponent, [{
        type: Component,
        args: [{ selector: 'gateway-credential-delete-modal', template: "<p-dialog\n  [(visible)]=\"showModal\"\n  (onHide)=\"handleCancel()\"\n  [modal]=\"true\"\n  [draggable]=\"false\"\n  [resizable]=\"false\"\n  [style]=\"{ width: '400px', height: '245px' }\"\n>\n  <ng-template pTemplate=\"header\">\n    <h4>\n      {{ 'DELETE_GATEWAY_CREDENTIAL_MODAL_HEADER' | translate }}\n    </h4>\n  </ng-template>\n  <p>\n    {{ 'DELETE_GATEWAY_CREDENTIAL_MODAL_MESSAGE' | translate }}\n  </p>\n\n  <ng-template pTemplate=\"footer\">\n    <div class=\"buttons\">\n      <button\n        aur-button\n        class=\"cancel-button\"\n        importance=\"secondary\"\n        (click)=\"handleCancel()\"\n      >\n        {{ 'COMMONS.NO' | translate }}\n      </button>\n      <loading-button\n        [label]=\"'COMMONS.YES' | translate\"\n        [buttonId]=\"'delete-gateway-credential-button'\"\n        (click)=\"deleteGatewayCredential()\"\n        importance=\"primary\"\n        [loading]=\"storeManager.selectDeleteCredential$ | async\"\n      ></loading-button>\n    </div>\n  </ng-template>\n</p-dialog>\n", styles: [":host p-dialog p{margin-bottom:0}:host p-dialog aur-input{width:100%}:host p-dialog h4{font-weight:600;margin:0}:host p-dialog .buttons{display:flex;flex-flow:row;align-items:center;justify-content:right;padding:12px;border-top:solid 1px #E4E7E8}:host p-dialog .buttons .download-button{margin-right:auto}:host p-dialog .cancel-button{margin-right:5px}\n"] }]
    }], () => [], { showModal: [{
            type: Input
        }], gatewayCredential: [{
            type: Input
        }], closeModal: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GatewayCredentialDeleteModalComponent, { className: "GatewayCredentialDeleteModalComponent", filePath: "lib/components/gateway-credential-delete-modal/gateway-credential-delete-modal.component.ts", lineNumber: 11 }); })();

const _c0$4 = () => ({ "min-width": "50rem" });
function GatewayCredentialsEditTableComponent_ng_template_10_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r1 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "", col_r1.field, "-column-header");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", col_r1.header, " ");
} }
function GatewayCredentialsEditTableComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, GatewayCredentialsEditTableComponent_ng_template_10_For_2_Template, 2, 3, "th", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.columns);
} }
function GatewayCredentialsEditTableComponent_ng_template_11_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "aur-input", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowIndex_r4 = i0.ɵɵnextContext().rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", ctx_r1.merchantUrlLabel)("id", "gateway-url-" + rowIndex_r4)("errorMessages", ctx_r1.customErrorMessage);
} }
function GatewayCredentialsEditTableComponent_ng_template_11_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td")(1, "div");
    i0.ɵɵelement(2, "p-checkbox", 21, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const rowIndex_r4 = i0.ɵɵnextContext().rowIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "pay-chkbox-cybersourcetoken" + rowIndex_r4)("binary", true);
} }
function GatewayCredentialsEditTableComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 10)(1, "td");
    i0.ɵɵelement(2, "aur-input", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵelement(4, "aur-input", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelement(6, "aur-input", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, GatewayCredentialsEditTableComponent_ng_template_11_Conditional_7_Template, 2, 3, "td");
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵelement(9, "aur-dropdown", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, GatewayCredentialsEditTableComponent_ng_template_11_td_10_Template, 4, 2, "td", 15);
    i0.ɵɵelementStart(11, "td")(12, "div", 16);
    i0.ɵɵelement(13, "aur-toggle", 17);
    i0.ɵɵelementStart(14, "button", 18);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵlistener("click", function GatewayCredentialsEditTableComponent_ng_template_11_Template_button_click_14_listener() { const rowData_r5 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.verifyGatewayCredential(rowData_r5.getRawValue())); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 19);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵpipe(18, "async");
    i0.ɵɵpipe(19, "async");
    i0.ɵɵpipe(20, "async");
    i0.ɵɵlistener("click", function GatewayCredentialsEditTableComponent_ng_template_11_Template_button_click_16_listener() { const rowData_r5 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.deleteGatewayCredential(rowData_r5.value)); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const rowData_r5 = ctx.$implicit;
    const rowIndex_r4 = ctx.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", rowData_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", "Id")("id", "gateway-id-input-" + rowIndex_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", "Secondary Id")("id", "gateway-secondaryId-" + rowIndex_r4)("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", "Password")("id", "gateway-password-" + rowIndex_r4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.displayMerchantUrl ? 7 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r1.pricingMdelOptions)("id", "gateway-pricingModel-" + rowIndex_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedMerchantProvider.gatewayName === "CyberSource");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pTooltip", i0.ɵɵpipeBind1(15, 18, "COMMONS.VERIFY"))("id", "verify-button-" + rowIndex_r4)("disabled", rowData_r5.invalid || ctx_r1.merchantAccountEdited || ctx_r1.credentialValuesChanged(rowIndex_r4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pTooltip", i0.ɵɵpipeBind1(17, 20, "COMMONS.REMOVE"))("id", "delete-button-" + rowIndex_r4)("disabled", !i0.ɵɵpipeBind1(18, 22, ctx_r1.storeManager.selectedMerchantAccount$).merchantAccountId || !(rowData_r5 == null ? null : rowData_r5.value.gatewayCredentialId) || (rowData_r5 == null ? null : rowData_r5.value.hasPayments) || i0.ɵɵpipeBind1(19, 24, ctx_r1.storeManager.selectedMerchantAccount$).gatewayCredentials.length == 1 && i0.ɵɵpipeBind1(20, 26, ctx_r1.storeManager.selectedMerchantAccount$).enabled == true || ctx_r1.credentialValuesChanged(rowIndex_r4));
} }
class GatewayCredentialsEditTableComponent {
    constructor() {
        //CLASS ATTRIBUTES
        this.translateService = inject(TranslateService);
        this.formBuilder = inject(FormBuilder);
        this.storeManager = inject(GatewayCredsStoreManagerService);
        this.showDeleteGatewayCredentialModal = false;
        this.destroy$ = new Subject();
        this.customErrorMessage = {
            ...CustomErrorMessages,
        };
        this.form = this.formBuilder.group({
            gatewayCredentials: this.formBuilder.array([
                this.createGateWayCredentialsForm(),
            ]),
        });
        this.columns = [...TABLE_COLUMNS()];
        this.pricingMdelOptions = [...PricingModels];
    }
    get gatewayCredentialsFormArray() {
        return this.form.get('gatewayCredentials');
    }
    get cannotSaveCredentials() {
        //changes and fields are invalid - can not save
        return (this.gatewayCredentialsFormArray.dirty &&
            this.gatewayCredentialsFormArray.invalid);
    }
    //possibly rename
    get gatewayCredentialsMapping() {
        return this.form
            .get('gatewayCredentials')
            .getRawValue()
            .map((cred) => ({
            ...cred,
            role: cred?.role?.id || null,
            gatewayOptions: cred?.enableCyberSourceTokenization
                ? [{ ...CyberSourceEnabledGatwayOption }]
                : null,
            secondaryMerchantId: cred.secondaryMerchantId?.trim() || null,
        }));
    }
    get hasInvalidCredentials() {
        return this.gatewayCredentialsFormArray.controls.some((control) => control.invalid);
    }
    ngOnInit() {
        this.storeManager.selectedMerchantAccount$
            .pipe(takeUntil(this.destroy$))
            .subscribe(({ gatewayCredentials }) => {
            this.configurationChanged = false;
            if (this.activeFormSubsInstance) {
                this.activeFormSubsInstance.unsubscribe();
            }
            if (gatewayCredentials?.length > 0) {
                this.createSetFormGroupValueFromStoredCredentials(gatewayCredentials);
                this.disableMerchIdFieldForHasPaymentFlag();
                this.handleDisablePricingModelOptions(gatewayCredentials);
            }
            else {
                this.form = this.formBuilder.group({
                    gatewayCredentials: this.formBuilder.array([
                        this.createGateWayCredentialsForm(),
                    ]),
                });
                this.pricingMdelOptions.forEach((model) => (model.disabled = false));
            }
            this.activeFormSubsInstance = this.handleFormValueChanges();
        });
    }
    ngOnChanges(changes) {
        //Update secondaryMerchantId validation when selectedMerchantProvider changes
        if (changes.selectedMerchantProvider) {
            this.gatewayCredentialsFormArray.controls.forEach((control, idx) => {
                control.get('secondaryMerchantId').updateValueAndValidity();
            });
            this.handleDisplayCyberSourceColumn();
            this.handleSelectedMerchantProviderFormValidations();
        }
        if (changes.displayMerchantUrl || changes.merchantUrlLabel) {
            this.handleMerchantUrlInputEnablement();
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    createSetFormGroupValueFromStoredCredentials(storedGatewayCredentials) {
        const newFormArray = this.formBuilder.array([]);
        for (let i = 0; i < storedGatewayCredentials.length; i++) {
            newFormArray.push(this.createGateWayCredentialsForm());
        }
        const creds = storedGatewayCredentials.map((cred) => ({
            ...cred,
            role: this.pricingMdelOptions.find((x) => x.id === cred.role),
            enableCyberSourceTokenization: cred.gatewayOptions?.some((opt) => opt.name === CyberSourceEnabledGatwayOption.name &&
                opt.value === CyberSourceEnabledGatwayOption.value),
        }));
        this.form = this.formBuilder.group({
            gatewayCredentials: this.formBuilder.array(newFormArray.controls),
        });
        this.form.get('gatewayCredentials').patchValue(creds, {
            emitEvent: false,
        });
    }
    //ID can't be edited if hasPayments is true
    disableMerchIdFieldForHasPaymentFlag() {
        this.gatewayCredentialsFormArray.controls.forEach((control, idx) => {
            if (control.value.hasPayments) {
                control.get('merchantId').disable({ emitEvent: false });
            }
        });
    }
    createGateWayCredentialsForm() {
        return this.formBuilder.group({
            merchantId: ['', [Validators.required]],
            gatewayCredentialId: '',
            secondaryMerchantId: ['', [this.secondaryMerchantIdValidator()]],
            password: ['', [Validators.required]],
            role: ['', [Validators.required]],
            url: ['', [urlValidator()]],
            gatewayOptions: [''],
            enabled: [null],
            hasPayments: [''],
            createdBy: [''],
            createdOn: [''],
            lastModifiedOn: [''],
            lastModifiedBy: [''],
            enableCyberSourceTokenization: [false],
            active: [false],
        });
    }
    //disable pricing models that already have a gateway credential association
    handleDisablePricingModelOptions(credentials) {
        this.pricingMdelOptions.forEach((model) => {
            model.disabled = credentials.some((cred) => cred.role === model.id);
        });
    }
    handleFormValueChanges() {
        return this.form.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
            const gatewayCredentials = this.form
                .getRawValue()
                .gatewayCredentials.map((cred) => ({
                ...cred,
                role: cred?.role?.id,
            }));
            this.configurationChanged = true;
            this.handleDisablePricingModelOptions(gatewayCredentials);
        });
    }
    //Credential is considered 'changed' if any field other than active is changed
    //Allows user to still delete and verify credentials when changing active toggle
    credentialValuesChanged(index) {
        let credChanged = false;
        const formGroup = this.gatewayCredentialsFormArray.get(index.toString());
        const formGroupKeys = Object.keys(formGroup.getRawValue());
        formGroupKeys.forEach((key) => {
            if (key != 'active') {
                credChanged = credChanged || !formGroup.get(key).pristine;
            }
        });
        return credChanged;
    }
    addGatewayCredential() {
        this.gatewayCredentialsFormArray.push(this.createGateWayCredentialsForm());
        this.handleSelectedMerchantProviderFormValidations();
    }
    deleteGatewayCredential(gatewayCredential) {
        this.selectedGatewayCredential = {
            ...gatewayCredential,
            role: gatewayCredential?.role?.id,
        };
        this.showDeleteGatewayCredentialModal = true;
    }
    verifyGatewayCredential(gatewayCredential) {
        const credential = {
            ...gatewayCredential,
            role: gatewayCredential?.role?.id,
        };
        this.storeManager.verifyCredential(credential);
    }
    secondaryMerchantIdValidator() {
        return (control) => {
            if (control.value?.length &&
                this.selectedMerchantProvider.gatewayName === 'TNS') {
                return [...ValidSecondaryIdsForTNSMerchant].includes(control.value)
                    ? null
                    : { secondaryIDNotValid: true };
            }
        };
    }
    handleDisplayCyberSourceColumn() {
        const columnExists = this.columns.some((col) => col.headerId === CybersourceUrlHeaderId);
        // If the selected merchant provider is CyberSource, add the column
        if (this.selectedMerchantProvider.gatewayName === 'CyberSource') {
            if (!columnExists) {
                this.columns.splice(4, 0, CYBER_SOURCE_TABLE_COLUMN());
            }
        }
        else {
            if (columnExists) {
                this.removeCyberSourceColumnCleanFormControls();
            }
        }
    }
    removeCyberSourceColumnCleanFormControls() {
        this.columns.splice(4, 1);
        this.gatewayCredentialsFormArray.controls.forEach((control) => {
            control
                .get('enableCyberSourceTokenization')
                .setValue(false, { emitEvent: false });
            control.get('gatewayOptions').setValue(null), { emitEvent: false };
        });
    }
    // Handles whether to display the merchant URL column
    handleMerchantUrlInputEnablement() {
        const label = this.merchantUrlLabel ||
            this.translateService.instant('ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_URL_LABEL');
        const urlColumnExists = this.columns.some((col) => col.field === 'url');
        if (this.displayMerchantUrl) {
            // If the column does not exist, add it
            urlColumnExists
                ? (this.columns[3].header = label)
                : this.columns.splice(3, 0, URL_TABLE_COLUMN(label));
        }
        else {
            // If the column exists, remove it
            urlColumnExists
                ? (this.columns.splice(3, 1), this.cleanAllUrlControls())
                : null;
        }
    }
    cleanAllUrlControls() {
        this.gatewayCredentialsFormArray.controls.forEach((control) => {
            const urlControl = control.get('url');
            urlControl.setValue('', { emitEvent: false });
        });
    }
    // TOGGLE REQUIRED FIELDS BASED ON SELECTED MERCHANT PROVIDER
    handleSelectedMerchantProviderFormValidations() {
        if (!this.selectedMerchantProvider?.credentialFields?.length)
            return;
        //Merchant Cred Fields to controls array mapping
        //Defualt isRequired to false
        const fieldControlMap = [
            { field: 'MerchantId', control: 'merchantId', isRequired: false },
            {
                field: 'SecondaryMerchantId',
                control: 'secondaryMerchantId',
                isRequired: false,
            },
            { field: 'MerchantPassword', control: 'password', isRequired: false },
            { field: 'MerchantUrl', control: 'url', isRequired: false },
        ];
        //Set isRequired to true if field is required in credentialsfields array
        this.selectedMerchantProvider.credentialFields.forEach((credField) => {
            fieldControlMap.forEach((mapObejct) => {
                if (mapObejct.field === credField.standardizedFieldName) {
                    mapObejct.isRequired = credField.isRequired;
                }
            });
        });
        fieldControlMap.forEach((map) => {
            this.setRequiredFieldByControlName(map.control, map.isRequired);
        });
    }
    setRequiredFieldByControlName(controlName, isRequired) {
        this.gatewayCredentialsFormArray.controls.forEach((control) => {
            const gwControl = control.get(controlName);
            if (isRequired) {
                gwControl.addValidators(Validators.required);
                gwControl.updateValueAndValidity({ emitEvent: false });
            }
            else {
                gwControl.removeValidators(Validators.required);
                gwControl.updateValueAndValidity({ emitEvent: false });
            }
        });
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayCredentialsEditTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayCredentialsEditTableComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: GatewayCredentialsEditTableComponent, selectors: [["app-gateway-credentials-edit-table"]], inputs: { merchantAccountEdited: "merchantAccountEdited", selectedMerchantProvider: "selectedMerchantProvider", merchantUrlLabel: "merchantUrlLabel", displayMerchantUrl: "displayMerchantUrl" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 16, consts: [["checkbox", ""], [1, "heading"], ["aur-button", "", "icon", "add", "importance", "secondary", "size", "sm", "name", "verify", 3, "click", "pTooltip", "disabled"], ["autocomplete", "off", 3, "formGroup"], ["formArrayName", "gatewayCredentials"], ["aurCompactTable", "", 3, "value", "tableStyle", "columns"], ["pTemplate", "header"], ["pTemplate", "body"], [3, "closeModal", "showModal", "gatewayCredential"], [3, "id"], [3, "formGroup"], ["formControlName", "merchantId", "name", "credMerchantId", "autocomplete", "\n              off\n            ", 3, "placeholder", "id"], ["formControlName", "secondaryMerchantId", "name", "secondaryMerchantId", "autocomplete", "off", 3, "placeholder", "id", "errorMessages"], ["formControlName", "password", "name", "credPassword", "type", "password", "autocomplete", "new-password", "maxlength", "512", 3, "placeholder", "id"], ["formControlName", "role", "label", "", "placeholder", "Select Pricing Model", "name", "pricingModel", "optionLabel", "label", 3, "options", "id"], [4, "ngIf"], [1, "actions"], ["formControlName", "active", 1, "active-toggle"], ["aur-button", "", "icon", "verified_user", "importance", "secondary", "size", "sm", "name", "verify", 1, "action-button", 3, "click", "pTooltip", "id", "disabled"], ["aur-button", "", "icon", "delete", "importance", "secondary", "size", "sm", "name", "delete-button", 1, "action-button", 3, "click", "pTooltip", "id", "disabled"], ["formControlName", "url", "name", "credUrl", "type", "text", "autocomplete", "off", "maxlength", "512", 3, "placeholder", "id", "errorMessages"], ["formControlName", "enableCyberSourceTokenization", "label", "Use\u00A0CyberSource\u00A0Tokens", 1, "formCheckbox", 3, "id", "binary"]], template: function GatewayCredentialsEditTableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "h2");
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 2);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "async");
            i0.ɵɵlistener("click", function GatewayCredentialsEditTableComponent_Template_button_click_4_listener() { return ctx.addGatewayCredential(); });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "form", 3);
            i0.ɵɵelementContainerStart(8, 4);
            i0.ɵɵelementStart(9, "p-table", 5);
            i0.ɵɵtemplate(10, GatewayCredentialsEditTableComponent_ng_template_10_Template, 3, 0, "ng-template", 6)(11, GatewayCredentialsEditTableComponent_ng_template_11_Template, 21, 28, "ng-template", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "gateway-credential-delete-modal", 8);
            i0.ɵɵlistener("closeModal", function GatewayCredentialsEditTableComponent_Template_gateway_credential_delete_modal_closeModal_12_listener() { return ctx.showDeleteGatewayCredentialModal = false; });
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 9, "ARC_PAYMENTS_GATEWAY_CREDENTIALS_EDIT_HEADER"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("pTooltip", i0.ɵɵpipeBind1(5, 11, "ARC_PAYMENTS_GATEWAY_CREDENTIALS_ADD_CREDENTIAL"))("disabled", !i0.ɵɵpipeBind1(6, 13, ctx.storeManager.selectedMerchantAccount$).merchantAccountId || ctx.hasInvalidCredentials || ctx.gatewayCredentialsFormArray.value.length === ctx.pricingMdelOptions.length);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.gatewayCredentialsFormArray.controls)("tableStyle", i0.ɵɵpureFunction0(15, _c0$4))("columns", ctx.columns);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("showModal", ctx.showDeleteGatewayCredentialModal)("gatewayCredential", ctx.selectedGatewayCredential);
        } }, dependencies: [i1$4.NgIf, i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.MaxLengthValidator, i4$1.FormGroupDirective, i4$1.FormControlName, i4$1.FormArrayName, i5.ButtonComponent, i5.CompactTableDirective, i5.DropdownComponent, i5.InputComponent, i5.ToggleComponent, i2$2.PrimeTemplate, i5$1.Tooltip, i6.Checkbox, i7.Table, GatewayCredentialDeleteModalComponent, i1$4.AsyncPipe, i1$1.TranslatePipe], styles: ["[_nghost-%COMP%]   .heading[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline}[_nghost-%COMP%]   .actions[_ngcontent-%COMP%]{display:flex;justify-content:space-evenly;align-items:flex-end;height:48px}[_nghost-%COMP%]   .active-toggle[_ngcontent-%COMP%]{margin-right:10px}[_nghost-%COMP%]   aur-input[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   aur-dropdown[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]   .action-button[_ngcontent-%COMP%]{padding:7px 8px!important}[_nghost-%COMP%]   h2[_ngcontent-%COMP%]{margin-top:0}[_nghost-%COMP%]   .hidePassword[_ngcontent-%COMP%]{-webkit-text-security:disc}[_nghost-%COMP%]   p-checkbox[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:0}"], changeDetection: 0 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayCredentialsEditTableComponent, [{
        type: Component,
        args: [{ selector: 'app-gateway-credentials-edit-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"heading\">\n  <h2>{{ 'ARC_PAYMENTS_GATEWAY_CREDENTIALS_EDIT_HEADER' | translate }}</h2>\n  <button\n    aur-button\n    icon=\"add\"\n    importance=\"secondary\"\n    size=\"sm\"\n    name=\"verify\"\n    [pTooltip]=\"'ARC_PAYMENTS_GATEWAY_CREDENTIALS_ADD_CREDENTIAL' | translate\"\n    (click)=\"addGatewayCredential()\"\n    [disabled]=\"\n      !(storeManager.selectedMerchantAccount$ | async).merchantAccountId ||\n      hasInvalidCredentials ||\n      gatewayCredentialsFormArray.value.length === pricingMdelOptions.length\n    \"\n  ></button>\n</div>\n\n<form [formGroup]=\"form\" autocomplete=\"off\">\n  <ng-container formArrayName=\"gatewayCredentials\">\n    <p-table\n      [value]=\"gatewayCredentialsFormArray.controls\"\n      [tableStyle]=\"{ 'min-width': '50rem' }\"\n      [columns]=\"columns\"\n      aurCompactTable\n    >\n      <ng-template pTemplate=\"header\">\n        <tr>\n          @for (col of columns; track col) {\n          <th id=\"{{ col.field }}-column-header\">\n            {{ col.header }}\n          </th>\n          }\n        </tr>\n      </ng-template>\n      <ng-template pTemplate=\"body\" let-rowData let-rowIndex=\"rowIndex\">\n        <tr [formGroup]=\"rowData\">\n          <td>\n            <aur-input\n              formControlName=\"merchantId\"\n              [placeholder]=\"'Id'\"\n              [id]=\"'gateway-id-input-' + rowIndex\"\n              name=\"credMerchantId\"\n              autocomplete=\"\n              off\n            \"\n            ></aur-input>\n          </td>\n          <td>\n            <aur-input\n              formControlName=\"secondaryMerchantId\"\n              [placeholder]=\"'Secondary Id'\"\n              [id]=\"'gateway-secondaryId-' + rowIndex\"\n              name=\"secondaryMerchantId\"\n              autocomplete=\"off\"\n              [errorMessages]=\"customErrorMessage\"\n            ></aur-input>\n          </td>\n          <td>\n            <aur-input\n              formControlName=\"password\"\n              [placeholder]=\"'Password'\"\n              [id]=\"'gateway-password-' + rowIndex\"\n              name=\"credPassword\"\n              type=\"password\"\n              autocomplete=\"new-password\"\n              maxlength=\"512\"\n            ></aur-input>\n          </td>\n          @if (displayMerchantUrl) {\n          <td>\n            <aur-input\n              formControlName=\"url\"\n              [placeholder]=\"merchantUrlLabel\"\n              [id]=\"'gateway-url-' + rowIndex\"\n              name=\"credUrl\"\n              type=\"text\"\n              autocomplete=\"off\"\n              maxlength=\"512\"\n              [errorMessages]=\"customErrorMessage\"\n            ></aur-input>\n          </td>\n          }\n          <td>\n            <aur-dropdown\n              formControlName=\"role\"\n              label=\"\"\n              [options]=\"pricingMdelOptions\"\n              placeholder=\"Select Pricing Model\"\n              [id]=\"'gateway-pricingModel-' + rowIndex\"\n              name=\"pricingModel\"\n              optionLabel=\"label\"\n            >\n            </aur-dropdown>\n          </td>\n          <td *ngIf=\"selectedMerchantProvider.gatewayName === 'CyberSource'\">\n            <div>\n              <p-checkbox\n                #checkbox\n                class=\"formCheckbox\"\n                [id]=\"'pay-chkbox-cybersourcetoken' + rowIndex\"\n                formControlName=\"enableCyberSourceTokenization\"\n                [binary]=\"true\"\n                label=\"Use&nbsp;CyberSource&nbsp;Tokens\"\n              ></p-checkbox>\n            </div>\n          </td>\n          <td>\n            <div class=\"actions\">\n              <aur-toggle\n                class=\"active-toggle\"\n                formControlName=\"active\"\n              ></aur-toggle>\n\n              <button\n                class=\"action-button\"\n                aur-button\n                icon=\"verified_user\"\n                importance=\"secondary\"\n                size=\"sm\"\n                name=\"verify\"\n                [pTooltip]=\"'COMMONS.VERIFY' | translate\"\n                (click)=\"verifyGatewayCredential(rowData.getRawValue())\"\n                [id]=\"'verify-button-' + rowIndex\"\n                [disabled]=\"\n                  rowData.invalid ||\n                  merchantAccountEdited ||\n                  credentialValuesChanged(rowIndex)\n                \"\n              ></button>\n\n              <button\n                class=\"action-button\"\n                aur-button\n                icon=\"delete\"\n                importance=\"secondary\"\n                size=\"sm\"\n                name=\"delete-button\"\n                [pTooltip]=\"'COMMONS.REMOVE' | translate\"\n                (click)=\"deleteGatewayCredential(rowData.value)\"\n                [id]=\"'delete-button-' + rowIndex\"\n                [disabled]=\"\n                  !(storeManager.selectedMerchantAccount$ | async)\n                    .merchantAccountId ||\n                  !rowData?.value.gatewayCredentialId ||\n                  rowData?.value.hasPayments ||\n                  ((storeManager.selectedMerchantAccount$ | async)\n                    .gatewayCredentials.length == 1 &&\n                    (storeManager.selectedMerchantAccount$ | async).enabled ==\n                      true) ||\n                  credentialValuesChanged(rowIndex)\n                \"\n              ></button>\n            </div>\n          </td>\n        </tr>\n      </ng-template>\n    </p-table>\n  </ng-container>\n</form>\n<gateway-credential-delete-modal\n  [showModal]=\"showDeleteGatewayCredentialModal\"\n  [gatewayCredential]=\"selectedGatewayCredential\"\n  (closeModal)=\"showDeleteGatewayCredentialModal = false\"\n></gateway-credential-delete-modal>\n", styles: [":host .heading{display:flex;justify-content:space-between;align-items:baseline}:host .actions{display:flex;justify-content:space-evenly;align-items:flex-end;height:48px}:host .active-toggle{margin-right:10px}:host aur-input{width:100%}:host aur-dropdown{width:100%}:host .action-button{padding:7px 8px!important}:host h2{margin-top:0}:host .hidePassword{-webkit-text-security:disc}:host p-checkbox{margin-top:15px;margin-bottom:0}\n"] }]
    }], null, { merchantAccountEdited: [{
            type: Input
        }], selectedMerchantProvider: [{
            type: Input
        }], merchantUrlLabel: [{
            type: Input
        }], displayMerchantUrl: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GatewayCredentialsEditTableComponent, { className: "GatewayCredentialsEditTableComponent", filePath: "lib/components/gateway-credentials-edit-table/gateway-credentials-edit-table.component.ts", lineNumber: 42 }); })();

const _c0$3 = () => ({ width: "95%", minWidth: "800px", maxWidth: "1500px" });
const _c1$2 = () => ({ width: "100%" });
function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "label", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 36);
    i0.ɵɵtwoWayListener("ngModelChange", function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Conditional_5_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(4); i0.ɵɵtwoWayBindingSet(ctx_r1.displayProviderNames, $event) || (ctx_r1.displayProviderNames = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Conditional_5_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.toggleGatewayFieldNames()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Display ", ctx_r1.selectedMerchantProvider.gatewayName, " Field Names ");
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.displayProviderNames);
} }
function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Conditional_5_Template, 4, 2, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "ARC_PAYMENTS_MERCHANT_EDITOR_EDIT_HEADER"), ": ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.merchantAccount.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.displayUseProviderNamesOption ? 5 : -1);
} }
function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "label", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 36);
    i0.ɵɵtwoWayListener("ngModelChange", function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Conditional_3_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); i0.ɵɵtwoWayBindingSet(ctx_r1.displayProviderNames, $event) || (ctx_r1.displayProviderNames = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Conditional_3_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.toggleGatewayFieldNames()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" Display ", ctx_r1.selectedMerchantProvider.gatewayName, " Field Names ");
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.displayProviderNames);
} }
function MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Conditional_3_Template, 4, 2, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "ARC_PAYMENTS_MERCHANT_EDITOR_CREATE_HEADER"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.displayUseProviderNamesOption ? 3 : -1);
} }
function MerchantEditorComponent_Conditional_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_0_Template, 6, 5, "div", 33)(1, MerchantEditorComponent_Conditional_0_ng_template_1_Conditional_1_Template, 4, 4, "div", 33);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.operation === 1 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.operation === 0 ? 1 : -1);
} }
function MerchantEditorComponent_Conditional_0_div_34_p_messages_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-messages", 38);
} if (rf & 2) {
    i0.ɵɵproperty("closable", false);
} }
function MerchantEditorComponent_Conditional_0_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MerchantEditorComponent_Conditional_0_div_34_p_messages_1_Template, 1, 1, "p-messages", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.displayDefaultMerchantAccountWarning);
} }
function MerchantEditorComponent_Conditional_0_Conditional_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "payments-last-updated-by", 29);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("target", ctx_r1.merchantAccount.merchantAccountId)("targetType", ctx_r1.auditTargetType)("auditEventStoreKey", ctx_r1.auditStoreKey);
} }
function MerchantEditorComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 2);
    i0.ɵɵtwoWayListener("visibleChange", function MerchantEditorComponent_Conditional_0_Template_p_dialog_visibleChange_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.display, $event) || (ctx_r1.display = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵtemplate(1, MerchantEditorComponent_Conditional_0_ng_template_1_Template, 2, 2, "ng-template", 3);
    i0.ɵɵelementStart(2, "form", 4)(3, "div", 5)(4, "div", 6);
    i0.ɵɵelement(5, "aur-input", 7);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6)(8, "aur-dropdown", 8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵpipe(10, "sortByName");
    i0.ɵɵpipe(11, "toSelectItem");
    i0.ɵɵlistener("valueChange", function MerchantEditorComponent_Conditional_0_Template_aur_dropdown_valueChange_8_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectMerchantProvider($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵelement(13, "aur-input", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵelement(15, "aur-dropdown", 11);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 6);
    i0.ɵɵelement(18, "aur-currency-input", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 6);
    i0.ɵɵelement(20, "aur-input", 13);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 6);
    i0.ɵɵelement(23, "aur-input", 14);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 6);
    i0.ɵɵelement(27, "aur-dropdown", 15);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 16)(30, "label", 17);
    i0.ɵɵtext(31, "Default\u00A0Account");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div");
    i0.ɵɵelement(33, "p-checkbox", 18);
    i0.ɵɵtemplate(34, MerchantEditorComponent_Conditional_0_div_34_Template, 2, 1, "div", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 20)(36, "div")(37, "label", 17);
    i0.ɵɵtext(38, "Accepted\u00A0Card\u00A0Brands");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 5)(40, "div", 21);
    i0.ɵɵelement(41, "p-checkbox", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 21);
    i0.ɵɵelement(43, "p-checkbox", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "div", 21);
    i0.ɵɵelement(45, "p-checkbox", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(46, "div", 21);
    i0.ɵɵelement(47, "p-checkbox", 25);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelement(48, "app-gateway-credentials-edit-table", 26, 0);
    i0.ɵɵelementStart(50, "p-footer")(51, "div", 27)(52, "div", 28);
    i0.ɵɵtemplate(53, MerchantEditorComponent_Conditional_0_Conditional_53_Template, 1, 3, "payments-last-updated-by", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 30)(55, "button", 31);
    i0.ɵɵlistener("click", function MerchantEditorComponent_Conditional_0_Template_button_click_55_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeMerchantEditor()); });
    i0.ɵɵtext(56, " Cancel ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "div", 30)(58, "button", 32);
    i0.ɵɵlistener("click", function MerchantEditorComponent_Conditional_0_Template_button_click_58_listener() { i0.ɵɵrestoreView(_r1); const gatewayCredentialEditorComponent_r5 = i0.ɵɵreference(49); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveMerchantAccount(gatewayCredentialEditorComponent_r5 == null ? null : gatewayCredentialEditorComponent_r5.gatewayCredentialsMapping)); });
    i0.ɵɵtext(59, " Save ");
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const gatewayCredentialEditorComponent_r5 = i0.ɵɵreference(49);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(63, _c0$3));
    i0.ɵɵtwoWayProperty("visible", ctx_r1.display);
    i0.ɵɵproperty("modal", true)("closable", false)("draggable", false)("focusOnShow", false)("resizable", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.merchantDetailsForm);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(6, 43, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_NAME_LABEL"));
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(64, _c1$2));
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 45, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_PROVIDER_LABEL"));
    i0.ɵɵproperty("options", i0.ɵɵpipeBind3(11, 49, i0.ɵɵpipeBind1(10, 47, ctx_r1.merchantProviders), "displayName", "gatewayId"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("label", ctx_r1.merchantSettlementTimeLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(65, _c1$2));
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(16, 53, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_FRAUD_DETECTION_LABEL"));
    i0.ɵɵproperty("options", ctx_r1.fraudOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formGroup", ctx_r1.merchantDetailsForm.controls["maxPaymentThreshold"])("showCurrency", false);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(21, 55, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_EMAIL_LABEL"));
    i0.ɵɵproperty("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(24, 57, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_BRANCHES_LABEL"));
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(25, 59, "ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_BRANCHES_PLACEHOLDER"));
    i0.ɵɵproperty("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(66, _c1$2));
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(28, 61, "ARC_PAYMENTS_MERCHANT_EDITOR_PAYMENT_FACILITATOR_LABEL"));
    i0.ɵɵproperty("options", ctx_r1.paymentFacilitatorOptions);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("formControl", ctx_r1.merchantDetailsForm.controls["isDefault"])("binary", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.displayDefaultMerchantAccountWarning);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("formControl", ctx_r1.merchantDetailsForm.controls["allowableCardBrands"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.merchantDetailsForm.controls["allowableCardBrands"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.merchantDetailsForm.controls["allowableCardBrands"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.merchantDetailsForm.controls["allowableCardBrands"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("merchantAccountEdited", !ctx_r1.merchantDetailsForm.pristine)("selectedMerchantProvider", ctx_r1.selectedMerchantProvider)("displayMerchantUrl", ctx_r1.displayMerchantUrl)("merchantUrlLabel", ctx_r1.merchantUrlLabel);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r1.merchantAccount.merchantAccountId ? 53 : -1);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r1.operation === ctx_r1.merchantEditorMode.Edit && gatewayCredentialEditorComponent_r5.gatewayCredentialsFormArray.pristine && ctx_r1.merchantDetailsForm.pristine || ctx_r1.cannotSaveAccount() || gatewayCredentialEditorComponent_r5.cannotSaveCredentials);
} }
class MerchantEditorComponent {
    selectedGatewayIdValidator(control) {
        const selectedGatewayId = control.value;
        if (selectedGatewayId === 0) {
            return { invalidGatewayId: true };
        }
        return null;
    }
    constructor(translateService, messageService) {
        this.translateService = translateService;
        this.messageService = messageService;
        this.close = new EventEmitter();
        this.save = new EventEmitter();
        this.auditTargetType = MERCHANT_ACCOUNT_TARGET_TYPE;
        this.auditStoreKey = AuditEventStoreKeys.merchantAccount;
        this.merchantDetailsForm = new FormGroup({
            selectedGatewayId: new FormControl(0, [
                Validators.required,
                this.selectedGatewayIdValidator,
            ]),
            merchantAccountName: new FormControl('', Validators.required),
            merchantSettlementTime: new FormControl(),
            merchantAccountFraudFlag: new FormControl(false),
            maxPaymentThreshold: new FormGroup({
                amount: new FormControl(),
                currency: new FormControl('USD'),
            }),
            allowableCardBrands: new FormControl([]),
            branches: new FormControl('', [
                this.branchNamesMustBeUnique(),
                this.disallowDoNotUse(),
                Validators.maxLength(3000),
            ]),
            isDefault: new FormControl(false),
            email: new FormControl('', {
                validators: [
                    this.emailsValidator(),
                    this.emailsNamesMustBeUnique(),
                    Validators.maxLength(1024),
                ],
                updateOn: 'blur',
            }),
            paymentFacilitator: new FormControl(''),
        });
        this.customErrorMessage = {
            uniqueBranch: 'Branch names must be unique.',
            disallowDoNotUse: 'DO NOT USE, is an obsolete way to disable an account in legacy systems. Disable the account instead.',
            emailsNotValid: 'One or more of the provided emails are not valid email addresses.',
            uniqueEmails: 'Email Addresses must be unique.',
        };
    }
    ngOnInit() {
        this.selectedMerchantProvider = {
            gatewayId: 0,
        };
        this.paymentFacilitatorOptions = [
            { label: 'None', value: 'None' },
            { label: 'WPEcomm', value: 'WPEcomm' },
            { label: 'WPCore', value: 'WPCore' },
            { label: 'CardConnect', value: 'CardConnect' },
            { label: 'commerceSTP', value: 'commerceSTP' },
        ];
        this.fraudOptions = [
            { label: 'Enabled', value: true },
            { label: 'Disabled', value: false },
        ];
        this.displayDefaultMerchantAccountWarning =
            !this.doesGlobalDefaultExist && !this.merchantAccount.isDefault;
        this.merchantDetailsForm.controls.merchantAccountFraudFlag.setValue(false);
        this.merchantUrlLabel = 'Merchant Url';
        this.merchantSettlementTimeLabel = 'Settlement Time';
        this.displayMerchantUrl = false;
        this.displayProviderNames = true;
        this.displayUseProviderNamesOption = false;
    }
    ngOnChanges(changes) {
        if (changes.merchantAccount) {
            this.applyMerchantAccountValuesToForm(this.merchantAccount);
            this.applyGatewayFieldNames(this.merchantAccount.gatewayId);
        }
    }
    applyMerchantAccountValuesToForm(account) {
        if (this.merchantAccount.gatewayId != 0) {
            if (this.merchantProviders.some((x) => x.gatewayId == account.gatewayId)) {
                this.selectedMerchantProvider = this.merchantProviders.filter((x) => x.gatewayId == account.gatewayId)[0];
            }
            this.merchantDetailsForm.controls.selectedGatewayId.setValue(account.gatewayId);
            this.displayUseProviderNamesOption = true;
        }
        if (account.hasPayments || account.status !== null) {
            this.merchantDetailsForm.controls.selectedGatewayId.disable();
        }
        this.merchantDetailsForm.controls.merchantAccountName.setValue(account.name);
        this.merchantDetailsForm.controls.merchantAccountFraudFlag.setValue(account.fraudMonitoringDataTrackingEnabled);
        this.merchantDetailsForm.controls['maxPaymentThreshold'].patchValue({
            amount: account.maxPaymentThreshold,
            currency: 'USD',
        });
        this.merchantDetailsForm.controls['allowableCardBrands'].setValue(account.allowableCardBrands);
        this.merchantDetailsForm.controls['isDefault'].setValue(account.isDefault);
        this.merchantDetailsForm.controls['branches'].setValue(account.branches?.filter((e) => e) ? account.branches.join(', ') : '');
        this.merchantDetailsForm.controls['email'].setValue(account.email);
        this.merchantDetailsForm.controls['paymentFacilitator'].setValue(account.paymentFacilitator);
        if (account.isDefault) {
            this.merchantDetailsForm.controls.isDefault.disable();
            this.displayDefaultMerchantAccountWarning = false;
        }
        else {
            this.merchantDetailsForm.controls.isDefault.enable();
            if (this.doesGlobalDefaultExist === false) {
                this.displayDefaultMerchantAccountWarning = true;
            }
            else {
                this.displayDefaultMerchantAccountWarning = false;
            }
        }
        if (this.displayDefaultMerchantAccountWarning) {
            this.showDefaultMerchantAccountWarning();
        }
        if (!account.settlementTime) {
            if (this.selectedMerchantProvider) {
                this.merchantDetailsForm.controls.merchantSettlementTime.setValue(this.selectedMerchantProvider.settlementTime);
            }
            else {
                this.merchantDetailsForm.controls.merchantSettlementTime.setValue('00:00');
            }
        }
        else {
            this.merchantDetailsForm.controls.merchantSettlementTime.setValue(account.settlementTime.value);
        }
        this.merchantDetailsForm.markAsPristine();
    }
    toggleGatewayFieldNames() {
        this.applyGatewayFieldNames(this.selectedMerchantProvider.gatewayId);
    }
    get merchantEditorMode() {
        return MerchantEditorMode;
    }
    cannotSaveAccount() {
        if (this.operation == MerchantEditorMode.Edit &&
            this.merchantDetailsForm.pristine)
            return false;
        //changes and all fields are valid - can save
        if (!this.merchantDetailsForm.pristine && !this.merchantDetailsForm.invalid)
            return false;
        else
            return true;
    }
    showDefaultMerchantAccountWarning() {
        const messageKey = 'default-account-warning';
        this.messageService.clear(messageKey);
        this.messageService.add({
            severity: 'warn',
            key: messageKey,
            detail: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_DEFAULT_NOT_SET_WARNING'),
        });
    }
    applyGatewayFieldNames(gatewayId) {
        if (this.merchantProviders.some((x) => x.gatewayId == gatewayId)) {
            let gateway = this.merchantProviders.filter((x) => x.gatewayId == gatewayId)[0];
            if (gateway?.credentialFields?.length && this.displayProviderNames) {
                // MerchantId
                if (gateway.credentialFields.some((x) => x.standardizedFieldName.toLowerCase() === 'merchantid'))
                    // Merchant Url
                    this.displayMerchantUrl = gateway.credentialFields.some((x) => x.standardizedFieldName.toLowerCase() === 'merchanturl');
                if (this.displayMerchantUrl)
                    this.merchantUrlLabel = gateway.credentialFields.filter((x) => x.standardizedFieldName.toLowerCase() === 'merchanturl')[0]?.gatewayFieldName;
                else {
                    this.merchantUrlLabel = this.translateService.instant('ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_URL_LABEL');
                }
            }
            else {
                this.merchantUrlLabel = this.translateService.instant('ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_URL_LABEL');
            }
        }
    }
    selectMerchantProvider(select) {
        this.displayUseProviderNamesOption = true;
        this.selectedMerchantProvider = this.merchantProviders.filter((x) => x.gatewayId == select)[0];
        this.applyGatewayFieldNames(select);
        this.merchantDetailsForm.controls.merchantSettlementTime.setValue(this.selectedMerchantProvider.settlementTime.value);
    }
    closeMerchantEditor() {
        this.close.emit();
    }
    saveMerchantAccount(gatewayCredentials) {
        if (!this.merchantDetailsForm.valid) {
            this.merchantDetailsForm.markAllAsTouched();
            return;
        }
        let payload = { ...this.merchantAccount };
        payload.gatewayId =
            this.merchantDetailsForm.controls.selectedGatewayId.value;
        payload.name = this.merchantDetailsForm.controls.merchantAccountName.value;
        payload.url = null;
        payload.settlementTime = this.merchantSettlementTimeIsDifferentFromGateway(this.merchantDetailsForm.controls.merchantSettlementTime.value)
            ? {
                value: this.merchantDetailsForm.controls.merchantSettlementTime.value,
                timeZoneId: this.selectedMerchantProvider?.settlementTime?.timeZoneId,
            }
            : null;
        payload.fraudMonitoringDataTrackingEnabled =
            this.merchantDetailsForm.controls.merchantAccountFraudFlag.value;
        payload.branches = this.merchantDetailsForm.controls['branches'].value
            ?.split(',')
            .map((x) => x.trim())
            .filter((e) => e);
        payload.email = this.merchantDetailsForm.controls['email'].value;
        payload.paymentFacilitator =
            this.merchantDetailsForm.controls['paymentFacilitator'].value;
        payload.isDefault = this.merchantDetailsForm.controls['isDefault'].value;
        // Max Payment Threshold
        if (this.merchantDetailsForm.controls['maxPaymentThreshold'].value.amount !==
            null &&
            this.merchantDetailsForm.controls['maxPaymentThreshold'].value.amount > 0)
            payload.maxPaymentThreshold =
                this.merchantDetailsForm.controls['maxPaymentThreshold'].value.amount;
        else
            payload.maxPaymentThreshold = null;
        // Allowable Card Brands
        if (this.merchantDetailsForm.controls['allowableCardBrands'].value &&
            this.merchantDetailsForm.controls['allowableCardBrands'].value.length !==
                0)
            payload.allowableCardBrands =
                this.merchantDetailsForm.controls['allowableCardBrands'].value;
        else
            payload.allowableCardBrands = null;
        //gateway credentials logic
        payload.gatewayCredentials = gatewayCredentials;
        this.save.emit(payload);
    }
    branchNamesMustBeUnique() {
        return (control) => {
            if (control.value) {
                let arr = control.value.split(',').map((x) => x.trim());
                arr = arr.map((x) => x.toLowerCase());
                let result = arr.filter((item, index) => arr.indexOf(item) != index);
                return result.length > 0
                    ? { uniqueBranch: { value: control.value } }
                    : null;
            }
        };
    }
    disallowDoNotUse() {
        return (control) => {
            if (control.value) {
                let arr = control.value.split(',').map((x) => x.trim());
                let doNotUseFound = arr.some((x) => x.toLowerCase().replace(/\s/g, '') === 'donotuse');
                return doNotUseFound
                    ? { disallowDoNotUse: { value: control.value } }
                    : null;
            }
        };
    }
    merchantSettlementTimeIsDifferentFromGateway(value) {
        if (!value)
            return false;
        if (value.length == 5)
            value += ':00';
        if (this.selectedMerchantProvider.settlementTime?.value != value)
            return true;
        return false;
    }
    emailsValidator() {
        return (control) => {
            if (control.value) {
                const emails = control.value.split(',').map((e) => e.trim());
                const forbidden = emails.some((email) => Validators.email(new FormControl(email)));
                return forbidden ? { emailsNotValid: { value: control.value } } : null;
            }
        };
    }
    emailsNamesMustBeUnique() {
        return (control) => {
            if (control.value) {
                let arr = control.value.split(',').map((x) => x.trim());
                arr = arr.map((x) => x.toLowerCase());
                let result = arr.filter((item, index) => arr.indexOf(item) != index);
                return result.length > 0
                    ? { uniqueEmails: { value: control.value } }
                    : null;
            }
        };
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantEditorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantEditorComponent)(i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(i2$2.MessageService)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MerchantEditorComponent, selectors: [["pay-merchant-editor"]], inputs: { merchantAccount: "merchantAccount", display: "display", operation: "operation", merchantProviders: "merchantProviders", doesGlobalDefaultExist: "doesGlobalDefaultExist" }, outputs: { close: "close", save: "save" }, features: [i0.ɵɵProvidersFeature([MessageService]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["gatewayCredentialEditorComponent", ""], ["id", "pay-merchant-editor-dialog", "appendTo", "body", 3, "visible", "modal", "closable", "draggable", "style", "focusOnShow", "resizable"], ["id", "pay-merchant-editor-dialog", "appendTo", "body", 3, "visibleChange", "visible", "modal", "closable", "draggable", "focusOnShow", "resizable"], ["pTemplate", "header"], ["autocomplete", "off", 3, "formGroup"], [1, "p-grid"], [1, "p-col-4", "merchant-input-container"], ["id", "pay-merchant-edit-name-text", "formControlName", "merchantAccountName", "name", "name", 3, "label"], ["id", "pay-merchant-edit-provider-dropdown", "appendTo", "body", "placeholder", "Select your merchant provider", "formControlName", "selectedGatewayId", 3, "valueChange", "label", "options"], [1, "p-col-4", "merchant-input-container-time"], ["id", "pay-merchant-settlement-time-text", "type", "time", "formControlName", "merchantSettlementTime", "autocomplete", "off", 3, "label"], ["id", "pay-merchant-edit-fraud-detection-dropdown", "appendTo", "body", "formControlName", "merchantAccountFraudFlag", 3, "label", "options"], ["label", "Max Transaction Amount", 3, "formGroup", "showCurrency"], ["id", "pay-merchant-edit-email-text", "formControlName", "email", "autocomplete", "off", 3, "label", "errorMessages"], ["id", "pay-merchant-edit-branches-text", "formControlName", "branches", "autocomplete", "off", 3, "label", "placeholder", "errorMessages"], ["id", "pay-payment-facilitator-dropdown", "appendTo", "body", "formControlName", "paymentFacilitator", 3, "label", "options"], ["id", "pay-isdefault-control-container", 1, "p-col-4"], [2, "color", "#4d6069"], ["id", "pay-chkbox-isdefault", "label", "Is Default Account?", 1, "formCheckbox", 3, "formControl", "binary"], [4, "ngIf"], ["id", "pay-card-brand-control-container", 1, "p-col-4", "card-brand-checkbox-group"], [1, "p-col-3", "card-brand-checkbox-wrapper"], ["id", "pay-chkbox-visa", "name", "cardBrands", "value", "Visa", "label", "VISA", 1, "formCheckbox", 3, "formControl"], ["id", "pay-chkbox-mastercard", "name", "cardBrands", "value", "MasterCard", "label", "MasterCard", 1, "formCheckbox", 3, "formControl"], ["id", "pay-chkbox-discover", "name", "cardBrands", "value", "Discover", "label", "Discover", 1, "formCheckbox", 3, "formControl"], ["id", "pay-chkbox-amex", "name", "cardBrands", "value", "American Express", "label", "AMEX", 1, "formCheckbox", 3, "formControl"], [3, "merchantAccountEdited", "selectedMerchantProvider", "displayMerchantUrl", "merchantUrlLabel"], [1, "p-grid", 2, "width", "100%", "margin", "0px"], [1, "p-col", "audit-col"], [3, "target", "targetType", "auditEventStoreKey"], [1, "p-col-fixed"], ["aur-button", "", "importance", "secondary", "id", "pay-merchant-edit-cancel-button", 3, "click"], ["aur-button", "", "importance", "primary", "id", "pay-merchant-edit-save-button", 3, "click", "disabled"], [2, "width", "100%"], [2, "float", "right"], [2, "font-size", "0.6em", "margin-right", "6px", "vertical-align", "middle"], ["type", "checkbox", 2, "vertical-align", "middle", 3, "ngModelChange", "change", "ngModel"], ["key", "default-account-warning", 3, "closable", 4, "ngIf"], ["key", "default-account-warning", 3, "closable"]], template: function MerchantEditorComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MerchantEditorComponent_Conditional_0_Template, 60, 67, "p-dialog", 1);
        } if (rf & 2) {
            i0.ɵɵconditional(ctx.merchantAccount ? 0 : -1);
        } }, dependencies: [i1$4.NgIf, i4$1.ɵNgNoValidate, i4$1.CheckboxControlValueAccessor, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.NgModel, i4$1.FormControlDirective, i4$1.FormGroupDirective, i4$1.FormControlName, i5.ButtonComponent, i5.CurrencyInputComponent, i5.DropdownComponent, i5.InputComponent, i2$1.Dialog, i2$2.Footer, i2$2.PrimeTemplate, i6.Checkbox, i8.Messages, LastUpdatedByComponent, GatewayCredentialsEditTableComponent, i1$1.TranslatePipe, SortByNamePipe, ToSelectItemPipe], styles: [".merchant-input-container[_ngcontent-%COMP%]   aur-input[_ngcontent-%COMP%]{width:100%;margin-top:0}.merchant-input-container[_ngcontent-%COMP%]   aur-input[_ngcontent-%COMP%]   .bt-input-group[_ngcontent-%COMP%]{padding:2px}.merchant-input-container-time[_ngcontent-%COMP%]   aur-input[_ngcontent-%COMP%]{width:100%;margin-top:0}.merchant-input-container[_ngcontent-%COMP%]   aur-dropdown[_ngcontent-%COMP%]{width:100%;margin-top:0}.merchant-input-container[_ngcontent-%COMP%]   aur-dropdown[_ngcontent-%COMP%]   .bt-input-group[_ngcontent-%COMP%]{padding:2px}.merchant-input-container[_ngcontent-%COMP%]   aur-currency-input[_ngcontent-%COMP%]{width:100%;margin-top:0}.merchant-input-container[_ngcontent-%COMP%]   aur-currency-input[_ngcontent-%COMP%]   .bt-input-group[_ngcontent-%COMP%]{padding:2px}.card-brand-checkbox-wrapper[_ngcontent-%COMP%]{display:inline-block;width:fit-content}.formCheckbox[_ngcontent-%COMP%]{margin-top:12px}#pay-card-brand-control-container[_ngcontent-%COMP%], #pay-isdefault-control-container[_ngcontent-%COMP%], #pay-cybersourcetoken-control-container[_ngcontent-%COMP%]{padding-top:0}.audit-col[_ngcontent-%COMP%]{align-self:center;text-align:left}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantEditorComponent, [{
        type: Component,
        args: [{ selector: 'pay-merchant-editor', providers: [MessageService], template: "@if (merchantAccount) {\n<p-dialog\n  id=\"pay-merchant-editor-dialog\"\n  [(visible)]=\"display\"\n  [modal]=\"true\"\n  [closable]=\"false\"\n  appendTo=\"body\"\n  [draggable]=\"false\"\n  [style]=\"{ width: '95%', minWidth: '800px', maxWidth: '1500px' }\"\n  [focusOnShow]=\"false\"\n  [resizable]=\"false\"\n>\n  <ng-template pTemplate=\"header\">\n    @if (operation === 1) {\n    <div style=\"width: 100%\">\n      {{ 'ARC_PAYMENTS_MERCHANT_EDITOR_EDIT_HEADER' | translate }}:\n      <strong>{{ merchantAccount.name }}</strong>\n      @if (displayUseProviderNamesOption) {\n      <div style=\"float: right\">\n        <label\n          style=\"font-size: 0.6em; margin-right: 6px; vertical-align: middle\"\n        >\n          Display {{ selectedMerchantProvider.gatewayName }} Field Names\n        </label>\n        <input\n          type=\"checkbox\"\n          [(ngModel)]=\"displayProviderNames\"\n          style=\"vertical-align: middle\"\n          (change)=\"toggleGatewayFieldNames()\"\n        />\n      </div>\n      }\n    </div>\n    } @if (operation === 0) {\n    <div style=\"width: 100%\">\n      {{ 'ARC_PAYMENTS_MERCHANT_EDITOR_CREATE_HEADER' | translate }}\n      @if (displayUseProviderNamesOption) {\n      <div style=\"float: right\">\n        <label\n          style=\"font-size: 0.6em; margin-right: 6px; vertical-align: middle\"\n        >\n          Display {{ selectedMerchantProvider.gatewayName }} Field Names\n        </label>\n        <input\n          type=\"checkbox\"\n          [(ngModel)]=\"displayProviderNames\"\n          style=\"vertical-align: middle\"\n          (change)=\"toggleGatewayFieldNames()\"\n        />\n      </div>\n      }\n    </div>\n    }\n  </ng-template>\n  <form [formGroup]=\"merchantDetailsForm\" autocomplete=\"off\">\n    <div class=\"p-grid\">\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-input\n          id=\"pay-merchant-edit-name-text\"\n          formControlName=\"merchantAccountName\"\n          name=\"name\"\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_NAME_LABEL'\n              | translate\n          }}\"\n        ></aur-input>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-dropdown\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_PROVIDER_LABEL'\n              | translate\n          }}\"\n          id=\"pay-merchant-edit-provider-dropdown\"\n          [style]=\"{ width: '100%' }\"\n          [options]=\"\n            merchantProviders\n              | sortByName\n              | toSelectItem : 'displayName' : 'gatewayId'\n          \"\n          appendTo=\"body\"\n          placeholder=\"Select your merchant provider\"\n          formControlName=\"selectedGatewayId\"\n          (valueChange)=\"selectMerchantProvider($event)\"\n        >\n        </aur-dropdown>\n      </div>\n      <div class=\"p-col-4 merchant-input-container-time\">\n        <aur-input\n          id=\"pay-merchant-settlement-time-text\"\n          type=\"time\"\n          formControlName=\"merchantSettlementTime\"\n          [label]=\"merchantSettlementTimeLabel\"\n          autocomplete=\"off\"\n        >\n        </aur-input>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-dropdown\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_FRAUD_DETECTION_LABEL'\n              | translate\n          }}\"\n          id=\"pay-merchant-edit-fraud-detection-dropdown\"\n          [style]=\"{ width: '100%' }\"\n          [options]=\"fraudOptions\"\n          appendTo=\"body\"\n          formControlName=\"merchantAccountFraudFlag\"\n        >\n        </aur-dropdown>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-currency-input\n          [formGroup]=\"merchantDetailsForm.controls['maxPaymentThreshold']\"\n          label=\"Max Transaction Amount\"\n          [showCurrency]=\"false\"\n        >\n        </aur-currency-input>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-input\n          id=\"pay-merchant-edit-email-text\"\n          formControlName=\"email\"\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_EMAIL_LABEL'\n              | translate\n          }}\"\n          [errorMessages]=\"customErrorMessage\"\n          autocomplete=\"off\"\n        >\n        </aur-input>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-input\n          id=\"pay-merchant-edit-branches-text\"\n          formControlName=\"branches\"\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_BRANCHES_LABEL'\n              | translate\n          }}\"\n          placeholder=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_MERCHANT_ACCOUNT_BRANCHES_PLACEHOLDER'\n              | translate\n          }}\"\n          [errorMessages]=\"customErrorMessage\"\n          autocomplete=\"off\"\n        >\n        </aur-input>\n      </div>\n      <div class=\"p-col-4 merchant-input-container\">\n        <aur-dropdown\n          label=\"{{\n            'ARC_PAYMENTS_MERCHANT_EDITOR_PAYMENT_FACILITATOR_LABEL' | translate\n          }}\"\n          id=\"pay-payment-facilitator-dropdown\"\n          [style]=\"{ width: '100%' }\"\n          [options]=\"paymentFacilitatorOptions\"\n          appendTo=\"body\"\n          formControlName=\"paymentFacilitator\"\n        >\n        </aur-dropdown>\n      </div>\n      <div class=\"p-col-4\" id=\"pay-isdefault-control-container\">\n        <label style=\"color: #4d6069\">Default&nbsp;Account</label>\n        <div>\n          <p-checkbox\n            class=\"formCheckbox\"\n            id=\"pay-chkbox-isdefault\"\n            [formControl]=\"merchantDetailsForm.controls['isDefault']\"\n            label=\"Is Default Account?\"\n            [binary]=\"true\"\n          >\n          </p-checkbox>\n          <div *ngIf=\"displayDefaultMerchantAccountWarning\">\n            <p-messages key=\"default-account-warning\" *ngIf=\"displayDefaultMerchantAccountWarning\" [closable]=\"false\"/>\n          </div>\n        </div>\n      </div>\n      <div\n        class=\"p-col-4 card-brand-checkbox-group\"\n        id=\"pay-card-brand-control-container\"\n      >\n        <div>\n          <label style=\"color: #4d6069\">Accepted&nbsp;Card&nbsp;Brands</label>\n          <div class=\"p-grid\">\n            <div class=\"p-col-3 card-brand-checkbox-wrapper\">\n              <p-checkbox\n                class=\"formCheckbox\"\n                id=\"pay-chkbox-visa\"\n                [formControl]=\"\n                  merchantDetailsForm.controls['allowableCardBrands']\n                \"\n                name=\"cardBrands\"\n                value=\"Visa\"\n                label=\"VISA\"\n              ></p-checkbox>\n            </div>\n            <div class=\"p-col-3 card-brand-checkbox-wrapper\">\n              <p-checkbox\n                class=\"formCheckbox\"\n                id=\"pay-chkbox-mastercard\"\n                [formControl]=\"\n                  merchantDetailsForm.controls['allowableCardBrands']\n                \"\n                name=\"cardBrands\"\n                value=\"MasterCard\"\n                label=\"MasterCard\"\n              ></p-checkbox>\n            </div>\n            <div class=\"p-col-3 card-brand-checkbox-wrapper\">\n              <p-checkbox\n                class=\"formCheckbox\"\n                id=\"pay-chkbox-discover\"\n                [formControl]=\"\n                  merchantDetailsForm.controls['allowableCardBrands']\n                \"\n                name=\"cardBrands\"\n                value=\"Discover\"\n                label=\"Discover\"\n              ></p-checkbox>\n            </div>\n            <div class=\"p-col-3 card-brand-checkbox-wrapper\">\n              <p-checkbox\n                class=\"formCheckbox\"\n                id=\"pay-chkbox-amex\"\n                [formControl]=\"\n                  merchantDetailsForm.controls['allowableCardBrands']\n                \"\n                name=\"cardBrands\"\n                value=\"American Express\"\n                label=\"AMEX\"\n              ></p-checkbox>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n  <app-gateway-credentials-edit-table\n    [merchantAccountEdited]=\"!merchantDetailsForm.pristine\"\n    [selectedMerchantProvider]=\"selectedMerchantProvider\"\n    [displayMerchantUrl]=\"displayMerchantUrl\"\n    [merchantUrlLabel]=\"merchantUrlLabel\"\n    #gatewayCredentialEditorComponent\n  ></app-gateway-credentials-edit-table>\n  <p-footer>\n    <div class=\"p-grid\" style=\"width: 100%; margin: 0px\">\n      <div class=\"p-col audit-col\">\n        @if (merchantAccount.merchantAccountId) {\n        <payments-last-updated-by\n          [target]=\"merchantAccount.merchantAccountId\"\n          [targetType]=\"auditTargetType\"\n          [auditEventStoreKey]=\"auditStoreKey\"\n        >\n        </payments-last-updated-by>\n        }\n      </div>\n      <div class=\"p-col-fixed\">\n        <button\n          aur-button\n          importance=\"secondary\"\n          id=\"pay-merchant-edit-cancel-button\"\n          (click)=\"closeMerchantEditor()\"\n        >\n          Cancel\n        </button>\n      </div>\n      <div class=\"p-col-fixed\">\n        <button\n          aur-button\n          importance=\"primary\"\n          id=\"pay-merchant-edit-save-button\"\n          (click)=\"\n            saveMerchantAccount(\n              gatewayCredentialEditorComponent?.gatewayCredentialsMapping\n            )\n          \"\n          [disabled]=\"\n            (this.operation === merchantEditorMode.Edit &&\n              gatewayCredentialEditorComponent.gatewayCredentialsFormArray\n                .pristine &&\n              merchantDetailsForm.pristine) ||\n            cannotSaveAccount() ||\n            gatewayCredentialEditorComponent.cannotSaveCredentials\n          \"\n        >\n          Save\n        </button>\n      </div>\n    </div>\n  </p-footer>\n</p-dialog>\n}\n", styles: [".merchant-input-container aur-input{width:100%;margin-top:0}.merchant-input-container aur-input .bt-input-group{padding:2px}.merchant-input-container-time aur-input{width:100%;margin-top:0}.merchant-input-container aur-dropdown{width:100%;margin-top:0}.merchant-input-container aur-dropdown .bt-input-group{padding:2px}.merchant-input-container aur-currency-input{width:100%;margin-top:0}.merchant-input-container aur-currency-input .bt-input-group{padding:2px}.card-brand-checkbox-wrapper{display:inline-block;width:fit-content}.formCheckbox{margin-top:12px}#pay-card-brand-control-container,#pay-isdefault-control-container,#pay-cybersourcetoken-control-container{padding-top:0}.audit-col{align-self:center;text-align:left}\n"] }]
    }], () => [{ type: i1$1.TranslateService }, { type: i2$2.MessageService }], { merchantAccount: [{
            type: Input
        }], display: [{
            type: Input
        }], operation: [{
            type: Input
        }], merchantProviders: [{
            type: Input
        }], doesGlobalDefaultExist: [{
            type: Input
        }], close: [{
            type: Output
        }], save: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MerchantEditorComponent, { className: "MerchantEditorComponent", filePath: "lib/components/merchant-editor/merchant-editor.component.ts", lineNumber: 33 }); })();

function MerchantConfirmationComponent_Conditional_0_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_DEFAULT_MERCHANT_ACCOUNT_MESSAGE"));
} }
function MerchantConfirmationComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dialog", 1);
    i0.ɵɵtwoWayListener("visibleChange", function MerchantConfirmationComponent_Conditional_0_Template_p_dialog_visibleChange_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.display, $event) || (ctx_r1.display = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(1, "p-header")(2, "span", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u00A0:\u00A0 ");
    i0.ɵɵelementStart(5, "strong", 3);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, MerchantConfirmationComponent_Conditional_0_p_8_Template, 3, 3, "p", 4);
    i0.ɵɵelementStart(9, "p", 5);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "p-footer")(12, "button", 6);
    i0.ɵɵlistener("click", function MerchantConfirmationComponent_Conditional_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.confirmAcceptance()); });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 7);
    i0.ɵɵlistener("click", function MerchantConfirmationComponent_Conditional_0_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.confirmRejection()); });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("visible", ctx_r1.display);
    i0.ɵɵproperty("focusOnShow", false)("modal", true)("closable", false)("draggable", false)("resizable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.header);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.merchantAccount.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.merchantAccount.isDefault && ctx_r1.isDelete);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.message);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 12, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_CONFIRM_BUTTON"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 14, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_CANCEL_BUTTON"), " ");
} }
class MerchantConfirmationComponent {
    constructor() {
        this.accept = new EventEmitter();
        this.reject = new EventEmitter();
    }
    ngOnInit() {
    }
    confirmRejection() {
        this.reject.emit();
    }
    confirmAcceptance() {
        this.accept.emit(this.merchantAccount);
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantConfirmationComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantConfirmationComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MerchantConfirmationComponent, selectors: [["pay-merchant-confirmation"]], inputs: { merchantAccount: "merchantAccount", display: "display", isDelete: "isDelete", message: "message", header: "header" }, outputs: { accept: "accept", reject: "reject" }, decls: 1, vars: 1, consts: [["appendTo", "body", 3, "visible", "focusOnShow", "modal", "closable", "draggable", "resizable"], ["appendTo", "body", 3, "visibleChange", "visible", "focusOnShow", "modal", "closable", "draggable", "resizable"], ["id", "pay-merchant-confirmation-header"], ["id", "pay-merchant-confirmation-name"], [4, "ngIf"], ["id", "pay-merchant-confirmation-message"], ["id", "pay-confirmation-accept-button", "aur-button", "", "importance", "primary", 3, "click"], ["id", "pay-confirmation-reject-button", "aur-button", "", "importance", "secondary", 3, "click"]], template: function MerchantConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, MerchantConfirmationComponent_Conditional_0_Template, 18, 16, "p-dialog", 0);
        } if (rf & 2) {
            i0.ɵɵconditional(ctx.merchantAccount ? 0 : -1);
        } }, dependencies: [i1$4.NgIf, i5.ButtonComponent, i2$1.Dialog, i2$2.Header, i2$2.Footer, i1$1.TranslatePipe], styles: ["#pay-merchant-confirmation-message[_ngcontent-%COMP%]{margin:10px 10px 0 0}#pay-confirmation-accept-button[_ngcontent-%COMP%]{margin-bottom:4px}#pay-confirmation-reject-button[_ngcontent-%COMP%]{margin-bottom:4px;margin-right:4px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'pay-merchant-confirmation', template: "<!-- USING P-DIALOG INSTEAD OF CONFIRMATION DUE TO STYLING ISSUES WITH BOTH AUREUS AND PRIMENG CONFIRMATION SOLUTIONS -->\n@if (merchantAccount) {\n  <p-dialog\n    [(visible)]=\"display\"\n    [focusOnShow]=\"false\"\n    [modal]=\"true\"\n    [closable]=\"false\"\n    appendTo=\"body\"\n    [draggable]=\"false\"\n    [resizable]=\"false\"\n    >\n    <p-header>\n      <span id=\"pay-merchant-confirmation-header\">{{ header }}</span\n        >&nbsp;:&nbsp;\n        <strong id=\"pay-merchant-confirmation-name\">{{\n          merchantAccount.name\n        }}</strong>\n      </p-header>\n      <div>\n        <p *ngIf=\"merchantAccount.isDefault && isDelete\">{{'ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_DEFAULT_MERCHANT_ACCOUNT_MESSAGE' | translate}}</p>\n        <p id=\"pay-merchant-confirmation-message\">{{ message }}</p>\n      </div>\n      <p-footer>\n        <button\n          id=\"pay-confirmation-accept-button\"\n          aur-button\n          importance=\"primary\"\n          (click)=\"confirmAcceptance()\"\n          >\n          {{ 'ARC_PAYMENTS_MERCHANT_CONFIRMATION_CONFIRM_BUTTON' | translate }}\n        </button>\n        <button\n          id=\"pay-confirmation-reject-button\"\n          aur-button\n          importance=\"secondary\"\n          (click)=\"confirmRejection()\"\n          >\n          {{ 'ARC_PAYMENTS_MERCHANT_CONFIRMATION_CANCEL_BUTTON' | translate }}\n        </button>\n      </p-footer>\n    </p-dialog>\n  }\n", styles: ["#pay-merchant-confirmation-message{margin:10px 10px 0 0}#pay-confirmation-accept-button{margin-bottom:4px}#pay-confirmation-reject-button{margin-bottom:4px;margin-right:4px}\n"] }]
    }], () => [], { merchantAccount: [{
            type: Input
        }], display: [{
            type: Input
        }], isDelete: [{
            type: Input
        }], message: [{
            type: Input
        }], header: [{
            type: Input
        }], accept: [{
            type: Output
        }], reject: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MerchantConfirmationComponent, { className: "MerchantConfirmationComponent", filePath: "lib/components/merchant-confirmation/merchant-confirmation.component.ts", lineNumber: 15 }); })();

const _c0$2 = () => ["gatewayCredentialId"];
const _c1$1 = () => ["createdOn"];
const _c2$1 = () => ["createdBy"];
const _c3$1 = () => ["hasPayments"];
const _c4$1 = () => ["role"];
function GatewayCredentialsDetailsComponent_ng_template_5_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 7)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r1 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "", col_r1.field, "-column-header");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", col_r1.header, " ");
} }
function GatewayCredentialsDetailsComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 6);
    i0.ɵɵrepeaterCreate(1, GatewayCredentialsDetailsComponent_ng_template_5_For_2_Template, 3, 3, "th", 7, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r2 = ctx.$implicit;
    const columns_r3 = ctx.$implicit;
    i0.ɵɵproperty("pSelectableRow", rowData_r2);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(columns_r3);
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const rowData_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", rowData_r5[col_r4.field], " ");
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span", 9);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const rowData_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 2, rowData_r5.createdOn, "dd MMMM"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(7, 5, rowData_r5.createdOn, "yyyy - h:mm a"));
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_3_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1, "-");
    i0.ɵɵelementEnd();
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_3_Conditional_2_Template, 2, 0, "p", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const rowData_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", rowData_r5[col_r4.field], " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowData_r5[col_r4.field] == null ? 2 : -1);
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 10);
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Conditional_1_Template, 2, 0, "i", 10)(2, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Conditional_2_Template, 2, 0, "i", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const rowData_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowData_r5[col_r4.field] ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!rowData_r5[col_r4.field] ? 2 : -1);
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r4 = i0.ɵɵnextContext().$implicit;
    const rowData_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", rowData_r5[col_r4.field], " ");
} }
function GatewayCredentialsDetailsComponent_ng_template_6_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_1_Template, 2, 1, "div", 8)(2, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_2_Template, 8, 8, "div", 8)(3, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_3_Template, 3, 2, "div", 8)(4, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_4_Template, 3, 2, "div", 8)(5, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Conditional_5_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(5, _c0$2).indexOf(col_r4.field) > -1 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(6, _c1$1).indexOf(col_r4.field) > -1 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(7, _c2$1).indexOf(col_r4.field) > -1 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(8, _c3$1).indexOf(col_r4.field) > -1 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(9, _c4$1).indexOf(col_r4.field) > -1 ? 5 : -1);
} }
function GatewayCredentialsDetailsComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, GatewayCredentialsDetailsComponent_ng_template_6_For_2_Template, 6, 10, "td", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const gatewayCredentialsDetailsTable_r6 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(gatewayCredentialsDetailsTable_r6.columns);
} }
class GatewayCredentialsDetailsComponent {
    constructor() {
        this.translateService = inject(TranslateService);
        this.columns = [
            {
                header: this.translateService.instant('GATEWAY_CREDENTIALS_DETAILS_TABLE_HEADER_ID'),
                align: 'left',
                field: 'gatewayCredentialId',
                headerId: 'gatewayid-column-header',
                sortable: false,
                width: 300,
            },
            {
                header: this.translateService.instant('GATEWAY_CREDENTIALS_DETAILS_TABLE_CREATION_DATE'),
                align: 'left',
                field: 'createdOn',
                headerId: 'gateway-createdon-column-header',
                sortable: false,
                width: 300,
            },
            {
                header: this.translateService.instant('GATEWAY_CREDENTIALS_DETAILS_TABLE_CREATED_BY'),
                align: 'left',
                field: 'createdBy',
                headerId: 'gateway-createdby-column-header',
                sortable: false,
                width: 300,
            },
            {
                header: this.translateService.instant('GATEWAY_CREDENTIALS_DETAILS_TABLE_HAS_PAYMENTS'),
                align: 'left',
                field: 'hasPayments',
                headerId: 'gateway-hasPayments-column-header',
                sortable: false,
                width: 300,
            },
            {
                header: this.translateService.instant('GATEWAY_CREDENTIALS_DETAILS_TABLE_PRICING_MODEL'),
                align: 'left',
                field: 'role',
                headerId: 'gateway-role-column-header',
                sortable: false,
                width: 300,
            },
        ];
    }
    /** @nocollapse */ static { this.ɵfac = function GatewayCredentialsDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GatewayCredentialsDetailsComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: GatewayCredentialsDetailsComponent, selectors: [["pay-gateway-credentials-details"]], inputs: { gatewayCredentialsDetailsData: "gatewayCredentialsDetailsData" }, decls: 7, vars: 2, consts: [["gatewayCredentialsDetailsTable", ""], [1, "popover-header"], [1, "gateway-credentials-details-body"], ["aurCompactTable", "", 3, "columns", "value"], ["pTemplate", "header"], ["pTemplate", "body"], [3, "pSelectableRow"], [3, "id"], [1, "center"], [2, "color", "#898989"], [1, "material-icons"]], template: function GatewayCredentialsDetailsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtext(1, "Gateway Credentials");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2)(3, "p-table", 3, 0);
            i0.ɵɵtemplate(5, GatewayCredentialsDetailsComponent_ng_template_5_Template, 3, 1, "ng-template", 4)(6, GatewayCredentialsDetailsComponent_ng_template_6_Template, 3, 0, "ng-template", 5);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("columns", ctx.columns)("value", ctx.gatewayCredentialsDetailsData);
        } }, dependencies: [i5.CompactTableDirective, i2$2.PrimeTemplate, i7.Table, i7.SelectableRow, i1$4.DatePipe], styles: [".gateway-credentials-details-body[_ngcontent-%COMP%]{padding:0 16px 16px;color:#001821;font-size:14px}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GatewayCredentialsDetailsComponent, [{
        type: Component,
        args: [{ selector: 'pay-gateway-credentials-details', template: "<div class=\"popover-header\">Gateway Credentials</div>\n<div class=\"gateway-credentials-details-body\">\n  <p-table\n    aurCompactTable\n    #gatewayCredentialsDetailsTable\n    [columns]=\"columns\"\n    [value]=\"gatewayCredentialsDetailsData\"\n    >\n    <ng-template pTemplate=\"header\" let-rowData let-columns>\n      <tr [pSelectableRow]=\"rowData\">\n        @for (col of columns; track col) {\n          <th id=\"{{ col.field }}-column-header\">\n            <div>\n              {{ col.header }}\n            </div>\n          </th>\n        }\n      </tr>\n    </ng-template>\n    <ng-template pTemplate=\"body\" let-rowData>\n      <tr>\n        @for (col of gatewayCredentialsDetailsTable.columns; track col) {\n          <td>\n            @if (['gatewayCredentialId'].indexOf(col.field) > -1) {\n              <div\n                class=\"center\"\n                >\n                {{ rowData[col.field] }}\n              </div>\n            }\n            @if (['createdOn'].indexOf(col.field) > -1) {\n              <div class=\"center\">\n                <p>\n                  {{ rowData.createdOn | date : 'dd MMMM' }}\n                  <br />\n                  <span style=\"color: #898989\">{{\n                    rowData.createdOn | date : 'yyyy - h:mm a'\n                  }}</span>\n                </p>\n              </div>\n            }\n            @if (['createdBy'].indexOf(col.field) > -1) {\n              <div class=\"center\">\n                {{ rowData[col.field] }}\n                @if (rowData[col.field] == null) {\n                  <p class=\"center\">-</p>\n                }\n              </div>\n            }\n            @if (['hasPayments'].indexOf(col.field) > -1) {\n              <div class=\"center\">\n                @if (rowData[col.field]) {\n                  <i class=\"material-icons\">check</i>\n                }\n                @if (!rowData[col.field]) {\n                  <i class=\"material-icons\">close</i>\n                }\n              </div>\n            }\n            @if (['role'].indexOf(col.field) > -1) {\n              <div>\n                {{ rowData[col.field] }}\n              </div>\n            }\n          </td>\n        }\n      </tr>\n    </ng-template>\n  </p-table>\n</div>\n", styles: [".gateway-credentials-details-body{padding:0 16px 16px;color:#001821;font-size:14px}\n"] }]
    }], null, { gatewayCredentialsDetailsData: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(GatewayCredentialsDetailsComponent, { className: "GatewayCredentialsDetailsComponent", filePath: "lib/components/gateway-credentials-details/gateway-credentials-details.component.ts", lineNumber: 11 }); })();

const _c0$1 = () => ["status"];
const _c1 = () => ["actions"];
const _c2 = () => ["name", "merchantProvider", "createdBy"];
const _c3 = () => ["creationDate"];
const _c4 = () => ["enabled"];
const _c5 = () => ["hasPayments"];
const _c6 = () => ["gatewayCredentials"];
function MerchantAccountTableComponent_ng_template_13_For_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", col_r2.header, " ");
} }
function MerchantAccountTableComponent_ng_template_13_For_2_Conditional_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-sortIcon", 16);
} if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("field", col_r2.field);
} }
function MerchantAccountTableComponent_ng_template_13_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, MerchantAccountTableComponent_ng_template_13_For_2_Conditional_2_Conditional_2_Template, 1, 1, "p-sortIcon", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", col_r2.header, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.sortable ? 2 : -1);
} }
function MerchantAccountTableComponent_ng_template_13_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵtemplate(1, MerchantAccountTableComponent_ng_template_13_For_2_Conditional_1_Template, 2, 1, "div", 14)(2, MerchantAccountTableComponent_ng_template_13_For_2_Conditional_2_Template, 3, 2, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r2 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate1("id", "", col_r2.field, "-column-header");
    i0.ɵɵproperty("pSortableColumn", col_r2.sortable ? col_r2.field : "")("pSortableColumnDisabled", !col_r2.sortable);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!col_r2.sortable ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.sortable ? 2 : -1);
} }
function MerchantAccountTableComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 12);
    i0.ɵɵrepeaterCreate(1, MerchantAccountTableComponent_ng_template_13_For_2_Template, 3, 6, "th", 13, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    const columns_r4 = ctx.$implicit;
    i0.ɵɵproperty("pSelectableRow", rowData_r3);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(columns_r4);
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "aur-status-badge", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translateStatus");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext().$implicit;
    const rowData_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r6.getSeverity(rowData_r6[col_r5.field]));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, rowData_r6[col_r5.field]));
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "aur-popup-menu", 20);
    i0.ɵɵpipe(2, "buildActionMenuItems");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    const rowData_r6 = ctx_r7.$implicit;
    const rowIndex_r9 = ctx_r7.rowIndex;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "pay-account-table-popupmenu_" + rowIndex_r9)("items", i0.ɵɵpipeBind3(2, 2, rowData_r6, ctx_r6.hasEditPermission, ctx_r6.hasDeletePermission));
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext().$implicit;
    const rowData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r6[col_r5.field], " ");
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "date");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const rowData_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 2, rowData_r6.creationDate, "dd MMMM"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(7, 5, rowData_r6.creationDate, "yyyy - h:mm a"));
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 22);
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 22);
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Conditional_1_Template, 2, 0, "i", 22)(2, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Conditional_2_Template, 2, 0, "i", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext().$implicit;
    const rowData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowData_r6[col_r5.field] ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!rowData_r6[col_r5.field] ? 2 : -1);
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 22);
    i0.ɵɵtext(1, "check");
    i0.ɵɵelementEnd();
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 22);
    i0.ɵɵtext(1, "close");
    i0.ɵɵelementEnd();
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Conditional_1_Template, 2, 0, "i", 22)(2, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Conditional_2_Template, 2, 0, "i", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext().$implicit;
    const rowData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowData_r6[col_r5.field] ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!rowData_r6[col_r5.field] ? 2 : -1);
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_7_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "a", 23);
    i0.ɵɵlistener("click", function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_7_Conditional_1_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r10); const gatewayCredentialsPopover_r11 = i0.ɵɵreference(4); return i0.ɵɵresetView(gatewayCredentialsPopover_r11.toggle($event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-overlayPanel", 24, 1);
    i0.ɵɵelement(5, "pay-gateway-credentials-details", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    const rowData_r6 = ctx_r7.$implicit;
    const rowIndex_r9 = ctx_r7.rowIndex;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(rowData_r6[col_r5.field].length);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "pay-gatewayCredentials-popover_", rowIndex_r9, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("gatewayCredentialsDetailsData", rowData_r6[col_r5.field]);
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_7_Conditional_1_Template, 6, 4, "div");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = i0.ɵɵnextContext().$implicit;
    const rowData_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(rowData_r6[col_r5.field] != null ? 1 : -1);
} }
function MerchantAccountTableComponent_ng_template_14_For_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_1_Template, 3, 4, "aur-status-badge", 18)(2, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_2_Template, 3, 6, "div", 19)(3, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_3_Template, 3, 1, "div", 19)(4, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_4_Template, 8, 8, "div", 19)(5, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_5_Template, 3, 2, "div", 19)(6, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_6_Template, 3, 2, "div", 19)(7, MerchantAccountTableComponent_ng_template_14_For_2_Conditional_7_Template, 2, 1, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r5 = ctx.$implicit;
    i0.ɵɵclassProp("aur-sorted", col_r5.sorted);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(9, _c0$1).indexOf(col_r5.field) > -1 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(10, _c1).indexOf(col_r5.field) > -1 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(11, _c2).indexOf(col_r5.field) > -1 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(12, _c3).indexOf(col_r5.field) > -1 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(13, _c4).indexOf(col_r5.field) > -1 ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(14, _c5).indexOf(col_r5.field) > -1 ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpureFunction0(15, _c6).indexOf(col_r5.field) > -1 ? 7 : -1);
} }
function MerchantAccountTableComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵrepeaterCreate(1, MerchantAccountTableComponent_ng_template_14_For_2_Template, 8, 16, "td", 17, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const merchantAccountTable_r12 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(merchantAccountTable_r12.columns);
} }
function MerchantAccountTableComponent_Conditional_15_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pay-merchant-confirmation", 26);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("accept", function MerchantAccountTableComponent_Conditional_15_Template_pay_merchant_confirmation_accept_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.deleteMerchantAccount($event)); })("reject", function MerchantAccountTableComponent_Conditional_15_Template_pay_merchant_confirmation_reject_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.closeDeleteMenu()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("display", ctx_r6.showDeleteConfirmation)("isDelete", true)("message", i0.ɵɵpipeBind1(1, 5, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_MERCHANT_ACCOUNT_MESSAGE"))("header", i0.ɵɵpipeBind1(2, 7, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_MERCHANT_ACCOUNT_HEADER"))("merchantAccount", i0.ɵɵpipeBind1(3, 9, ctx_r6.selectedMerchantAccount$));
} }
function MerchantAccountTableComponent_Conditional_16_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pay-merchant-confirmation", 26);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("accept", function MerchantAccountTableComponent_Conditional_16_Template_pay_merchant_confirmation_accept_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.disableMerchantAccount($event)); })("reject", function MerchantAccountTableComponent_Conditional_16_Template_pay_merchant_confirmation_reject_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.closeDisableMenu()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(1, 5, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_DISABLE_MERCHANT_ACCOUNT_MESSAGE"));
    i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(2, 7, "ARC_PAYMENTS_MERCHANT_CONFIRMATION_DISABLE_MERCHANT_ACCOUNT_HEADER"));
    i0.ɵɵproperty("display", ctx_r6.showDisableConfirmation)("isDelete", false)("merchantAccount", i0.ɵɵpipeBind1(3, 9, ctx_r6.selectedMerchantAccount$));
} }
function MerchantAccountTableComponent_Conditional_17_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "pay-merchant-editor", 27);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("close", function MerchantAccountTableComponent_Conditional_17_Template_pay_merchant_editor_close_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.closeEditMenu()); })("save", function MerchantAccountTableComponent_Conditional_17_Template_pay_merchant_editor_save_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.saveMerchantAccount($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("merchantAccount", i0.ɵɵpipeBind1(1, 5, ctx_r6.selectedMerchantAccount$))("merchantProviders", ctx_r6.gateways)("doesGlobalDefaultExist", ctx_r6.doesDefaultMerchantAcctExist)("display", ctx_r6.showMerchantEditor)("operation", ctx_r6.editorMode);
} }
class MerchantAccountTableComponent {
    constructor(store, actions$, translateService, merchantRegPermissions, messageService) {
        this.store = store;
        this.actions$ = actions$;
        this.translateService = translateService;
        this.merchantRegPermissions = merchantRegPermissions;
        this.messageService = messageService;
        this.recordsPerPage = [5, 10, 15, 25];
    }
    ngOnInit() {
        if (!this.viewModels)
            this.viewModels = [];
        this.columns = [
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_NAME_COLUMN_HEADER'),
                align: 'center',
                field: 'name',
                headerId: 'pay-name-column-header',
                fieldType: 'translateString',
                sortType: 'string',
                sortable: true,
                sorted: true,
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_STATUS_COLUMN_HEADER'),
                align: 'center',
                field: 'status',
                headerId: 'pay-status-column-header',
                fieldType: 'translateString',
                sortable: false,
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_GATEWAY_COLUMN_HEADER'),
                align: 'center',
                field: 'merchantProvider',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-merchantProvider-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ENABLED_COLUMN_HEADER'),
                align: 'center',
                field: 'enabled',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-enabled-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_HAS_PAYMENTS_COLUMN_HEADER'),
                align: 'center',
                field: 'hasPayments',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-hasPayments-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_CREDENTIALS_COLUMN_HEADER'),
                align: 'center',
                field: 'gatewayCredentials',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-credentials-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_CREATION_DATE_COLUMN_HEADER'),
                align: 'center',
                field: 'creationDate',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-creationDate-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_CREATED_BY_COLUMN_HEADER'),
                align: 'center',
                field: 'createdBy',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-createdBy-column-header',
            },
            {
                header: this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_MERCHANT_ACCOUNT_ACTIONS_COLUMN_HEADER'),
                align: 'center',
                field: 'actions',
                sortable: false,
                fieldType: 'translateString',
                headerId: 'pay-actions-column-header',
            },
        ];
        this.hasAddPermission$ = this.merchantRegPermissions.CanAdd$();
        this.editPermissionSubscription = this.merchantRegPermissions
            .CanUpdate$()
            .subscribe((canUpdate) => {
            this.hasEditPermission = canUpdate;
        });
        this.deletePermissionSubscription = this.merchantRegPermissions
            .CanDelete$()
            .subscribe((canDelete) => {
            this.hasDeletePermission = canDelete;
        });
        this.actionsSubscription = this.actions$
            .pipe(ofType(...[
            MerchantAccountActionTypes.MerchantAccountUpdated,
            MerchantAccountActionTypes.NewMerchantAccountCreated,
            MerchantAccountActionTypes.MerchantAccountDeleted,
            MerchantAccountActionTypes.MerchantAccountDisabled,
        ]))
            .subscribe((action) => {
            switch (action.type) {
                case MerchantAccountActionTypes.MerchantAccountUpdated: {
                    if (this.showMerchantEditor) {
                        this.closeEditMenu();
                    }
                    break;
                }
                case MerchantAccountActionTypes.NewMerchantAccountCreated: {
                    if (this.showMerchantEditor) {
                        this.closeEditMenu();
                    }
                    break;
                }
                case MerchantAccountActionTypes.MerchantAccountDeleted: {
                    if (this.showDeleteConfirmation) {
                        this.closeDeleteMenu();
                    }
                    break;
                }
                case MerchantAccountActionTypes.MerchantAccountDisabled: {
                    if (this.showDisableConfirmation) {
                        this.closeDisableMenu();
                    }
                    break;
                }
            }
        });
    }
    ngOnChanges(changes) {
        if (changes.gateways || changes.merchantAccounts || changes.tenantUsers) {
            if (this.gateways && this.merchantAccounts && this.tenantUsers) {
                if (changes.merchantAccounts && changes.merchantAccounts.currentValue.length > 0) {
                    if (changes.merchantAccounts?.currentValue?.find((x) => x.isDefault === true) === undefined) {
                        this.doesDefaultMerchantAcctExist = false;
                        // To avoid duplicate messages
                        this.messageService.dismissChannel('default-acct-warning');
                        this.messageService.open(this.translateService.instant('ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_DEFAULT_NOT_SET_WARNING'), null, { severity: 'danger', dismissOnNavigate: true, duration: 10000, channel: 'default-acct-warning' });
                    }
                    else {
                        this.doesDefaultMerchantAcctExist = true;
                    }
                }
                this.viewModels = this.merchantAccounts.map((account) => {
                    let gateway = this.gateways.filter((g) => g.gatewayId === account.gatewayId)[0];
                    let accountViewModel = {
                        name: account.name,
                        merchantAccountId: account.merchantAccountId,
                        merchantProvider: gateway ? gateway.gatewayName : '',
                        url: account.url,
                        gatewayId: account.gatewayId,
                        hasPayments: account.hasPayments,
                        gatewayCredentials: account.gatewayCredentials,
                        createdBy: this.getName(account.createdBy, this.tenantUsers),
                        creationDate: account.createdOn,
                        status: account.status,
                        token: account.token,
                        enabled: account.enabled,
                        displayEditMenu: () => {
                            this.displayEditMenu(account.merchantAccountId);
                        },
                        displayDisableConfirmation: () => {
                            this.displayDisableConfirmation(account.merchantAccountId);
                        },
                        displayTokenView: () => {
                            this.displayTokenView(account.merchantAccountId);
                        },
                        enableMerchantAccount: () => {
                            this.enableMerchantAccount(account);
                        },
                        displayDeleteConfirmation: () => {
                            this.displayDeleteConfirmation(account.merchantAccountId);
                        },
                    };
                    return accountViewModel;
                });
            }
        }
    }
    ngOnDestroy() {
        if (this.actionsSubscription && !this.actionsSubscription.closed)
            this.actionsSubscription.unsubscribe();
        if (this.editPermissionSubscription &&
            !this.editPermissionSubscription.closed)
            this.editPermissionSubscription.unsubscribe();
        if (this.deletePermissionSubscription &&
            !this.deletePermissionSubscription.closed)
            this.deletePermissionSubscription.unsubscribe();
    }
    // Display Component Methods
    displayDeleteConfirmation(merchantAccountId) {
        this.selectedMerchantAccount$ = of(this.merchantAccounts.filter((x) => x.merchantAccountId == merchantAccountId)[0]);
        this.showDeleteConfirmation = true;
    }
    displayDisableConfirmation(merchantAccountId) {
        this.selectedMerchantAccount$ = of(this.merchantAccounts.filter((x) => x.merchantAccountId == merchantAccountId)[0]);
        this.showDisableConfirmation = true;
    }
    displayAddMenu() {
        this.selectedMerchantAccount$ = of({
            merchantAccountId: 0,
            url: null,
            createdBy: null,
            enabled: false,
            tenantId: null,
            createdOn: null,
            name: null,
            token: null,
            gatewayId: 0,
            hasPayments: null,
            status: null,
            interchangeDefaults: null,
            isDefault: false,
            branches: [],
            email: null,
        });
        this.displayMerchantEditor(MerchantEditorMode.Create);
    }
    displayEditMenu(merchantAccountId) {
        this.store.dispatch(new LoadMerchantAccountAction(merchantAccountId));
        this.selectedMerchantAccount$ = this.store.pipe(select(SelectSingleMerchantAccount));
        this.displayMerchantEditor(MerchantEditorMode.Edit);
    }
    displayTokenView(merchantAccountId) {
        this.selectedMerchantAccount$ = of(this.merchantAccounts.filter((x) => x.merchantAccountId == merchantAccountId)[0]);
        this.showTokenView = true;
    }
    closeTokenView() {
        this.showTokenView = false;
    }
    closeEditMenu() {
        this.store.dispatch(new ResetMerchantAccountAction({}));
        this.showMerchantEditor = false;
        // this.branches = [];
    }
    closeDeleteMenu() {
        this.showDeleteConfirmation = false;
    }
    closeDisableMenu() {
        this.showDisableConfirmation = false;
    }
    // Action methods
    saveMerchantAccount(account) {
        //Add
        if (account.merchantAccountId === 0) {
            this.store.dispatch(new CreateMerchantAccountAction(account));
            //this.store.dispatch(new Add)
        }
        //Update
        else {
            this.store.dispatch(new UpdateMerchantAccountAction(account));
        }
    }
    deleteMerchantAccount(account) {
        this.store.dispatch(new DeleteMerchantAccountAction(account));
    }
    disableMerchantAccount(account) {
        this.store.dispatch(new DisableMerchantAccountAction(account));
    }
    enableMerchantAccount(account) {
        this.store.dispatch(new EnableMerchantAccountAction(account));
    }
    //Helper methods
    displayMerchantEditor(mode) {
        this.showMerchantEditor = true;
        this.editorMode = mode;
    }
    getSeverity(status) {
        switch (status.toLowerCase()) {
            case 'autoregistered':
                return 'warning';
            case 'onboarding':
                return 'info';
            case 'registered':
                return 'success';
            default:
                return 'info';
        }
    }
    getName(userId, users) {
        let user = users.filter((x) => x.userId == userId)[0];
        if (user) {
            if (user.firstName && user.lastName) {
                return `${user.firstName} ${user.lastName}`;
            }
            else if (user.email) {
                return user.email;
            }
            else {
                return '-';
            }
        }
        else {
            return '-';
        }
    }
    /** @nocollapse */ static { this.ɵfac = function MerchantAccountTableComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MerchantAccountTableComponent)(i0.ɵɵdirectiveInject(i1$2.Store), i0.ɵɵdirectiveInject(i1$3.Actions), i0.ɵɵdirectiveInject(i1$1.TranslateService), i0.ɵɵdirectiveInject(MerchantRegistrationPermissions), i0.ɵɵdirectiveInject(i5.MessageService)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: MerchantAccountTableComponent, selectors: [["pay-merchant-account-table"]], inputs: { merchantAccounts: "merchantAccounts", gateways: "gateways", tenantUsers: "tenantUsers" }, features: [i0.ɵɵProvidersFeature([MessageService$1]), i0.ɵɵNgOnChangesFeature], decls: 20, vars: 18, consts: [["merchantAccountTable", ""], ["gatewayCredentialsPopover", ""], [1, "p-grid"], [1, "p-col-9"], [1, "p-col-3", "right"], ["aur-button", "", "importance", "secondary", "icon", "add", "id", "add-merchant-button", 3, "click", "disabled"], ["aurCompactTable", "", "sortField", "name", 3, "columns", "value"], ["pTemplate", "header"], ["pTemplate", "body"], [3, "display", "isDelete", "message", "header", "merchantAccount"], [3, "merchantAccount", "merchantProviders", "doesGlobalDefaultExist", "display", "operation"], [3, "close", "merchantAccount", "display"], [3, "pSelectableRow"], [3, "id", "pSortableColumn", "pSortableColumnDisabled"], [2, "text-align", "center"], [1, "table-header"], [3, "field"], [3, "aur-sorted"], [3, "color"], [1, "center"], [3, "id", "items"], [2, "color", "#898989"], [1, "material-icons"], [3, "click"], ["aurPopover", "", 3, "id"], [3, "gatewayCredentialsDetailsData"], [3, "accept", "reject", "display", "isDelete", "message", "header", "merchantAccount"], [3, "close", "save", "merchantAccount", "merchantProviders", "doesGlobalDefaultExist", "display", "operation"]], template: function MerchantAccountTableComponent_Template(rf, ctx) { if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div")(1, "h2");
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵelement(5, "div", 3);
            i0.ɵɵelementStart(6, "div", 4)(7, "button", 5);
            i0.ɵɵpipe(8, "async");
            i0.ɵɵlistener("click", function MerchantAccountTableComponent_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAddMenu()); });
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(11, "p-table", 6, 0);
            i0.ɵɵtemplate(13, MerchantAccountTableComponent_ng_template_13_Template, 3, 1, "ng-template", 7)(14, MerchantAccountTableComponent_ng_template_14_Template, 3, 0, "ng-template", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, MerchantAccountTableComponent_Conditional_15_Template, 4, 11, "pay-merchant-confirmation", 9)(16, MerchantAccountTableComponent_Conditional_16_Template, 4, 11, "pay-merchant-confirmation", 9)(17, MerchantAccountTableComponent_Conditional_17_Template, 2, 7, "pay-merchant-editor", 10);
            i0.ɵɵelementStart(18, "pay-token-view", 11);
            i0.ɵɵpipe(19, "async");
            i0.ɵɵlistener("close", function MerchantAccountTableComponent_Template_pay_token_view_close_18_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeTokenView()); });
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 10, "ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_HEADER"));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind1(8, 12, ctx.hasAddPermission$));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 14, "ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_ADD_MERCHANT_BUTTON"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("columns", ctx.columns)("value", ctx.viewModels);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.showDeleteConfirmation ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showDisableConfirmation ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showMerchantEditor ? 17 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("merchantAccount", i0.ɵɵpipeBind1(19, 16, ctx.selectedMerchantAccount$))("display", ctx.showTokenView);
        } }, dependencies: [i5.ButtonComponent, i5.PopupMenuComponent, i5.PopoverDirective, i5.StatusBadgeComponent, i5.CompactTableDirective, i2$2.PrimeTemplate, i7.Table, i7.SortableColumn, i7.SelectableRow, i7.SortIcon, i8$1.OverlayPanel, MerchantEditorComponent, TokenViewComponent, MerchantConfirmationComponent, GatewayCredentialsDetailsComponent, i1$4.AsyncPipe, i1$4.DatePipe, i1$1.TranslatePipe, TranslateStatusPipe, BuildActionMenuItemsPipe], styles: [".center[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.center[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0}.column-header[_ngcontent-%COMP%]{margin:auto!important}.right[_ngcontent-%COMP%]{text-align:right;margin-top:auto}header[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin:auto}.table-header[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MerchantAccountTableComponent, [{
        type: Component,
        args: [{ selector: 'pay-merchant-account-table', providers: [MessageService$1], template: "<div>\n  <h2>{{ 'ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_HEADER' | translate }}</h2>\n  <div class=\"p-grid\">\n    <div class=\"p-col-9\"></div>\n    <div class=\"p-col-3 right\">\n      <button\n        aur-button\n        importance=\"secondary\"\n        icon=\"add\"\n        [disabled]=\"!(hasAddPermission$ | async)\"\n        id=\"add-merchant-button\"\n        (click)=\"displayAddMenu()\"\n        >\n        {{\n        'ARC_PAYMENTS_MERCHANT_ACCOUNT_TABLE_ADD_MERCHANT_BUTTON' | translate\n        }}\n      </button>\n    </div>\n  </div>\n  <p-table\n    aurCompactTable\n    #merchantAccountTable\n    [columns]=\"columns\"\n    [value]=\"viewModels\"\n    sortField=\"name\"\n    >\n    <ng-template pTemplate=\"header\" let-rowData let-columns>\n      <tr [pSelectableRow]=\"rowData\">\n        @for (col of columns; track col) {\n          <th\n            id=\"{{ col.field }}-column-header\"\n            [pSortableColumn]=\"col.sortable ? col.field : ''\"\n            [pSortableColumnDisabled]=\"!col.sortable\"\n            >\n            @if (!col.sortable) {\n              <div style=\"text-align: center\">\n                {{ col.header }}\n              </div>\n            }\n            @if (col.sortable) {\n              <div class=\"table-header\">\n                {{ col.header }}\n                @if (col.sortable) {\n                  <p-sortIcon [field]=\"col.field\"></p-sortIcon>\n                }\n              </div>\n            }\n          </th>\n        }\n      </tr>\n    </ng-template>\n\n    <ng-template pTemplate=\"body\" let-rowData let-rowIndex=\"rowIndex\">\n      <tr>\n        @for (col of merchantAccountTable.columns; track col) {\n          <td\n            [class.aur-sorted]=\"col.sorted\"\n            >\n            @if (['status'].indexOf(col.field) > -1) {\n              <aur-status-badge\n                [color]=\"getSeverity(rowData[col.field])\"\n                >{{ rowData[col.field] | translateStatus }}</aur-status-badge\n                >\n              }\n              @if (['actions'].indexOf(col.field) > -1) {\n                <div class=\"center\">\n                  <aur-popup-menu\n                    [id]=\"'pay-account-table-popupmenu_' + rowIndex\"\n              [items]=\"\n                rowData\n                  | buildActionMenuItems\n                    : hasEditPermission\n                    : hasDeletePermission\n              \"\n                    >\n                  </aur-popup-menu>\n                </div>\n              }\n              @if (\n                ['name', 'merchantProvider', 'createdBy'].indexOf(col.field) > -1\n                ) {\n                <div\n                  class=\"center\"\n                  >\n                  <p>\n                    {{ rowData[col.field] }}\n                  </p>\n                </div>\n              }\n              @if (['creationDate'].indexOf(col.field) > -1) {\n                <div class=\"center\">\n                  <p>\n                    {{ rowData.creationDate | date : 'dd MMMM' }}\n                    <br />\n                    <span style=\"color: #898989\">{{\n                      rowData.creationDate | date : 'yyyy - h:mm a'\n                    }}</span>\n                  </p>\n                </div>\n              }\n              @if (['enabled'].indexOf(col.field) > -1) {\n                <div class=\"center\">\n                  @if (rowData[col.field]) {\n                    <i class=\"material-icons\">check</i>\n                  }\n                  @if (!rowData[col.field]) {\n                    <i class=\"material-icons\">close</i>\n                  }\n                </div>\n              }\n              @if (['hasPayments'].indexOf(col.field) > -1) {\n                <div class=\"center\">\n                  @if (rowData[col.field]) {\n                    <i class=\"material-icons\">check</i>\n                  }\n                  @if (!rowData[col.field]) {\n                    <i class=\"material-icons\">close</i>\n                  }\n                </div>\n              }\n              @if (['gatewayCredentials'].indexOf(col.field) > -1) {\n                <div\n                  class=\"center\"\n                  >\n                  @if (rowData[col.field] != null) {\n                    <div>\n                      <a (click)=\"gatewayCredentialsPopover.toggle($event)\">{{\n                        rowData[col.field].length\n                      }}</a>\n                      <p-overlayPanel\n                        aurPopover\n                        #gatewayCredentialsPopover\n                        id=\"pay-gatewayCredentials-popover_{{ rowIndex }}\"\n                        >\n                        <pay-gateway-credentials-details\n                          [gatewayCredentialsDetailsData]=\"rowData[col.field]\"\n                        ></pay-gateway-credentials-details>\n                      </p-overlayPanel>\n                    </div>\n                  }\n                </div>\n              }\n            </td>\n          }\n        </tr>\n      </ng-template>\n    </p-table>\n    @if (showDeleteConfirmation) {\n      <pay-merchant-confirmation\n        [display]=\"showDeleteConfirmation\"\n        [isDelete]=\"true\"\n        [message]=\"\n          ('ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_MERCHANT_ACCOUNT_MESSAGE' | translate)\n        \"\n        [header]=\"\n          'ARC_PAYMENTS_MERCHANT_CONFIRMATION_DELETE_MERCHANT_ACCOUNT_HEADER'\n            | translate\n        \"\n        [merchantAccount]=\"selectedMerchantAccount$ | async\"\n        (accept)=\"deleteMerchantAccount($event)\"\n        (reject)=\"closeDeleteMenu()\"\n    >\n    </pay-merchant-confirmation>\n    }\n    @if (showDisableConfirmation) {\n      <pay-merchant-confirmation\n        [display]=\"showDisableConfirmation\"\n        [isDelete]=\"false\"\n    message=\"{{\n      'ARC_PAYMENTS_MERCHANT_CONFIRMATION_DISABLE_MERCHANT_ACCOUNT_MESSAGE'\n        | translate\n    }}\"\n    header=\"{{\n      'ARC_PAYMENTS_MERCHANT_CONFIRMATION_DISABLE_MERCHANT_ACCOUNT_HEADER'\n        | translate\n    }}\"\n        [merchantAccount]=\"selectedMerchantAccount$ | async\"\n        (accept)=\"disableMerchantAccount($event)\"\n        (reject)=\"closeDisableMenu()\"\n        >\n      </pay-merchant-confirmation>\n    }\n    @if (showMerchantEditor) {\n      <pay-merchant-editor\n        [merchantAccount]=\"selectedMerchantAccount$ | async\"\n        [merchantProviders]=\"gateways\"\n        [doesGlobalDefaultExist]=\"doesDefaultMerchantAcctExist\"\n        [display]=\"showMerchantEditor\"\n        (close)=\"closeEditMenu()\"\n        (save)=\"saveMerchantAccount($event)\"\n        [operation]=\"editorMode\"\n      ></pay-merchant-editor>\n    }\n    <pay-token-view\n      [merchantAccount]=\"selectedMerchantAccount$ | async\"\n      [display]=\"showTokenView\"\n      (close)=\"closeTokenView()\"\n      >\n    </pay-token-view>\n  </div>\n", styles: [".center{display:flex;justify-content:center;align-items:center}.center p{margin:0}.column-header{margin:auto!important}.right{text-align:right;margin-top:auto}header>span{margin:auto}.table-header{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between}\n"] }]
    }], () => [{ type: i1$2.Store }, { type: i1$3.Actions }, { type: i1$1.TranslateService }, { type: MerchantRegistrationPermissions }, { type: i5.MessageService }], { merchantAccounts: [{
            type: Input
        }], gateways: [{
            type: Input
        }], tenantUsers: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(MerchantAccountTableComponent, { className: "MerchantAccountTableComponent", filePath: "lib/components/merchant-account-table/merchant-account-table.component.ts", lineNumber: 38 }); })();

const _c0 = () => ({ width: "100%" });
function InterchangeDetailComponent_Conditional_21_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 12)(2, "aur-dropdown", 13);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "merchantFilter");
    i0.ɵɵpipe(5, "presentInterchange");
    i0.ɵɵpipe(6, "sortByName");
    i0.ɵɵpipe(7, "toSelectItem");
    i0.ɵɵpipe(8, "addGlobalDefaultsOption");
    i0.ɵɵlistener("valueChange", function InterchangeDetailComponent_Conditional_21_Template_aur_dropdown_valueChange_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setCopyFromMerchantAccount($event)); });
    i0.ɵɵtwoWayListener("ngModelChange", function InterchangeDetailComponent_Conditional_21_Template_aur_dropdown_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.copyFromId, $event) || (ctx_r1.copyFromId = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 14)(10, "button", 15);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵlistener("click", function InterchangeDetailComponent_Conditional_21_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.loadCopyFromMerchantAccount()); });
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(14, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(26, _c0));
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(3, 7, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COPY_FROM_SETTINGS_LABEL"));
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(8, 20, i0.ɵɵpipeBind3(7, 16, i0.ɵɵpipeBind1(6, 14, i0.ɵɵpipeBind1(5, 12, i0.ɵɵpipeBind2(4, 9, ctx_r1.merchantAccounts, ctx_r1.selectedMerchantAccount))), "name", "merchantAccountId")));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.copyFromId);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("disabled", !ctx_r1.readyToCopy || !i0.ɵɵpipeBind1(11, 22, ctx_r1.hasPermissionToSave$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 24, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COPY_FROM_SETTINGS_APPLY_BUTTON"), " ");
} }
function InterchangeDetailComponent_Conditional_23_Conditional_98_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "payments-last-updated-by", 43);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("target", ctx_r1.selectedMerchantAccount.merchantAccountId)("targetType", ctx_r1.auditTargetType)("auditEventStoreKey", ctx_r1.auditStoreKey);
} }
function InterchangeDetailComponent_Conditional_23_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "aur-card", 11)(1, "div")(2, "div", 16)(3, "div", 12);
    i0.ɵɵelement(4, "aur-dropdown", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 18)(7, "div", 19);
    i0.ɵɵelement(8, "aur-input", 20);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 4)(11, "div", 21)(12, "div", 22)(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 23)(17, "aur-toggle", 24);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵlistener("valueChange", function InterchangeDetailComponent_Conditional_23_Template_aur_toggle_valueChange_17_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.togglePoFixed()); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(19, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 16)(21, "div", 19);
    i0.ɵɵelement(22, "aur-input", 25);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 16)(27, "div", 19);
    i0.ɵɵelement(28, "aur-input", 26);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 16)(32, "div", 19);
    i0.ɵɵelement(33, "aur-input", 27);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 18)(37, "div", 19);
    i0.ɵɵelement(38, "aur-input", 28);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 4)(41, "div", 21)(42, "div", 22)(43, "span");
    i0.ɵɵtext(44);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(46, "div", 23)(47, "aur-toggle", 29);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵlistener("valueChange", function InterchangeDetailComponent_Conditional_23_Template_aur_toggle_valueChange_47_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleShipToZipFixed()); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(49, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "div", 18)(51, "div", 19);
    i0.ɵɵelement(52, "aur-input", 30);
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(54, "div", 4)(55, "div", 21)(56, "div", 22)(57, "span");
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(60, "div", 23)(61, "aur-toggle", 31);
    i0.ɵɵpipe(62, "translate");
    i0.ɵɵlistener("valueChange", function InterchangeDetailComponent_Conditional_23_Template_aur_toggle_valueChange_61_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleshipToCountryFixed()); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(63, "div", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(64, "div")(65, "div", 16)(66, "div", 2)(67, "h3", 32);
    i0.ɵɵtext(68);
    i0.ɵɵpipe(69, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(70, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(71, "div", 16)(72, "div", 19);
    i0.ɵɵelement(73, "aur-input", 33);
    i0.ɵɵpipe(74, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "div", 19);
    i0.ɵɵelement(76, "aur-input", 34);
    i0.ɵɵpipe(77, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(78, "div", 19);
    i0.ɵɵelement(79, "aur-input", 35);
    i0.ɵɵpipe(80, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(81, "div", 16)(82, "div", 19);
    i0.ɵɵelement(83, "aur-input", 36);
    i0.ɵɵpipe(84, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(85, "div", 19);
    i0.ɵɵelement(86, "aur-input", 37);
    i0.ɵɵpipe(87, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "div", 19);
    i0.ɵɵelement(89, "aur-input", 38);
    i0.ɵɵpipe(90, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(91, "div", 39)(92, "div", 40)(93, "button", 41);
    i0.ɵɵpipe(94, "async");
    i0.ɵɵlistener("click", function InterchangeDetailComponent_Conditional_23_Template_button_click_93_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clearFields()); });
    i0.ɵɵtext(95);
    i0.ɵɵpipe(96, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(97, "div", 42);
    i0.ɵɵtemplate(98, InterchangeDetailComponent_Conditional_23_Conditional_98_Template, 1, 3, "payments-last-updated-by", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(99, "div", 44)(100, "button", 45);
    i0.ɵɵlistener("click", function InterchangeDetailComponent_Conditional_23_Template_button_click_100_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.resetToSelectedMerchantAccount()); });
    i0.ɵɵtext(101);
    i0.ɵɵpipe(102, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(103, "button", 46);
    i0.ɵɵpipe(104, "async");
    i0.ɵɵtext(105);
    i0.ɵɵpipe(106, "translate");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(82, _c0));
    i0.ɵɵproperty("options", ctx_r1.optimizationPreferenceOptions);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 32, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_PO_NUMBER_LABEL"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 34, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(18, 36, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_USE_MERCHANT_REF_CODE_TOGGLE_INDICATOR"));
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(23, 38, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_ORDER_DATE_LABEL"));
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(24, 40, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_ORDER_DATE_TOOLTIP"));
    i0.ɵɵproperty("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(6);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(29, 42, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIPPING_AMOUNT_LABEL"));
    i0.ɵɵproperty("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(34, 44, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_FROM_ZIP_LABEL"));
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(39, 46, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_TO_ZIP_LABEL"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(45, 48, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(48, 50, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_BILLING_ZIP_TOGGLE_INDICATOR"));
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(53, 52, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_TO_COUNTRY_LABEL"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(59, 54, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(62, 56, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_BILLING_COUNTRY_TOGGLE_INDICATOR"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(69, 58, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEMS_HEADER"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(74, 60, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_DESCRIPTION_LABEL"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(77, 62, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COMMODITY_CODE_TOOLTIP"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(80, 64, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_UNITS_LABEL"));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(84, 66, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_NAME_LABEL"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(87, 68, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_TAX_RATE_LABEL"));
    i0.ɵɵproperty("errorMessages", ctx_r1.customErrorMessage);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(90, 70, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_PART_NUMBER_LABEL"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind1(94, 72, ctx_r1.hasPermissionToSave$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(96, 74, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_CLEAR_FIELDS_BUTTON"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.selectedMerchantAccount.merchantAccountId ? 98 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(102, 76, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_CANCEL_BUTTON"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.interchangeDefaultsForm.dirty || !i0.ɵɵpipeBind1(104, 78, ctx_r1.hasPermissionToSave$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(106, 80, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SAVE_BUTTON"), " ");
} }
class InterchangeDetailComponent {
    constructor(store, merchantRegPermissions) {
        this.store = store;
        this.merchantRegPermissions = merchantRegPermissions;
        this.auditTargetType = INTERCHANGE_DEFAULT_TARGET_TYPE;
        this.auditStoreKey = AuditEventStoreKeys.interChangeDefaults;
        this.interchangeDefaultsForm = new FormGroup({
            poNumberIsReferential: new FormControl(false),
            poNumber: new FormControl(""),
            orderDate: new FormControl(0, this.isNumericValidator()),
            shippingAmount: new FormControl(0, this.isNumericValidator()),
            shipFromPostalCode: new FormControl(""),
            shipToCountry: new FormControl(""),
            shipToCountryIsReferential: new FormControl(false),
            shipToPostalCode: new FormControl(""),
            shipToPostalCodeIsReferential: new FormControl(false),
            lineItemDescription: new FormControl(""),
            lineItemName: new FormControl(""),
            lineItemCommodityCode: new FormControl(""),
            lineItemUnits: new FormControl(""),
            lineItemPartNumber: new FormControl(""),
            lineItemTaxRate: new FormControl(0, this.isValidTaxRateValidator()),
            optimizationPreference: new FormControl("", Validators.required),
        });
        this.customErrorMessage = {
            numeric: "Value must be numeric",
            taxRate: "Valid tax rate: 0.0 - 1.0",
        };
    }
    ngOnInit() {
        this.hasPermissionToSave$ = combineLatest([
            this.merchantRegPermissions.CanAdd$(),
            this.merchantRegPermissions.CanUpdate$(),
            this.merchantRegPermissions.CanDelete$(),
        ]).pipe(map((items) => {
            return items[0] && items[1] && items[2];
        }));
        this.optimizationPreferenceOptions = [
            { label: "Maximum Optimization", value: "Full" },
            {
                label: "Basic Optimization, use fields identified below only",
                value: "Merchant",
            },
            { label: "No Optimization", value: "None" },
        ];
        this.permissionSubscription = this.hasPermissionToSave$.subscribe((canSave) => {
            this.hasPermissionToSave = canSave;
        });
        this.readyToCopy = false;
        this.selectedMerchantAccount = null;
        this.copyFromMerchantAccount = null;
    }
    ngOnDestroy() {
        if (this.permissionSubscription && !this.permissionSubscription.closed)
            this.permissionSubscription.unsubscribe();
    }
    togglePoFixed() {
        if (!this.interchangeDefaultsForm.value.poNumberIsReferential) {
            this.interchangeDefaultsForm.controls.poNumber.enable();
            let value = this.selectedMerchantAccount?.interchangeDefaults?.defaultableFields
                ?.poNumber?.fixedValue ?? "";
            this.interchangeDefaultsForm.patchValue({ poNumber: value });
        }
        else {
            this.interchangeDefaultsForm.patchValue({ poNumber: "" });
            this.interchangeDefaultsForm.controls.poNumber.disable();
        }
    }
    toggleShipToZipFixed() {
        if (!this.interchangeDefaultsForm.value.shipToPostalCodeIsReferential) {
            this.interchangeDefaultsForm.controls.shipToPostalCode.enable();
            let value = this.selectedMerchantAccount?.interchangeDefaults?.defaultableFields
                ?.shipToPostalCode?.fixedValue ?? "";
            this.interchangeDefaultsForm.patchValue({ shipToPostalCode: value });
        }
        else {
            this.interchangeDefaultsForm.controls.shipToPostalCode.disable();
            this.interchangeDefaultsForm.patchValue({ shipToPostalCode: "" });
        }
    }
    toggleshipToCountryFixed() {
        if (!this.interchangeDefaultsForm.value.shipToCountryIsReferential) {
            this.interchangeDefaultsForm.controls.shipToCountry.enable();
            let value = this.selectedMerchantAccount?.interchangeDefaults?.defaultableFields
                ?.shipToCountry?.fixedValue ?? "";
            this.interchangeDefaultsForm.patchValue({ shipToCountry: value });
        }
        else {
            this.interchangeDefaultsForm.controls.shipToCountry.disable();
            this.interchangeDefaultsForm.patchValue({ shipToCountry: "" });
        }
    }
    setCopyFromMerchantAccount(selection) {
        // If global defaults are not selected
        if (this.copyFromId !== -1) {
            this.copyFromMerchantAccount = this.merchantAccounts.filter((x) => x.merchantAccountId == selection)[0];
        }
        this.readyToCopy = true;
    }
    loadCopyFromMerchantAccount() {
        if (this.copyFromId === -1) {
            this.mapGlobalDefaultsToForm();
        }
        else if (this.copyFromMerchantAccount != null) {
            this.mapMerchantAccountToForm(this.copyFromMerchantAccount);
        }
    }
    clearFields() {
        this.copyFromMerchantAccount = null;
        this.copyFromId = null;
        this.readyToCopy = false;
        if (this.hasPermissionToSave) {
            this.interchangeDefaultsForm.controls.poNumber.enable();
            this.interchangeDefaultsForm.controls.shipToPostalCode.enable();
            this.interchangeDefaultsForm.controls.shipToCountry.enable();
        }
        //Initialize empty form.
        this.interchangeDefaultsForm.patchValue({
            orderDate: null,
            lineItemCommodityCode: null,
            lineItemDescription: null,
            lineItemName: null,
            lineItemTaxRate: null,
            lineItemUnits: null,
            lineItemPartNumber: null,
            shipFromPostalCode: null,
            shipToPostalCodeIsReferential: false,
            poNumber: null,
            poNumberIsReferential: false,
            shipToCountry: null,
            shipToCountryIsReferential: false,
            shipToPostalCode: null,
            shippingAmount: null,
            optimizationPreference: null,
        });
    }
    resetToSelectedMerchantAccount() {
        this.copyFromMerchantAccount = null;
        this.readyToCopy = false;
        this.copyFromId = null;
        this.mapMerchantAccountToForm(this.selectedMerchantAccount);
        this.interchangeDefaultsForm.markAsPristine();
        this.interchangeDefaultsForm.markAsUntouched();
    }
    // Loads the selected merchant account and it makes it ready to configure by the user
    loadSelectedMerchantAccount(selection) {
        this.selectedMerchantAccount = this.merchantAccounts.filter((x) => x.merchantAccountId == selection)[0];
        this.copyFromMerchantAccount = null;
        this.readyToCopy = false;
        this.copyFromId = null;
        this.mapMerchantAccountToForm(this.selectedMerchantAccount);
        this.interchangeDefaultsForm.markAsPristine();
        this.interchangeDefaultsForm.markAsUntouched();
    }
    // Maps the given merchant account to the form
    mapGlobalDefaultsToForm() {
        this.interchangeDefaultsForm.patchValue({
            orderDate: 1,
            lineItemCommodityCode: "2020",
            lineItemDescription: "Product",
            lineItemName: "Material",
            shipToPostalCodeIsReferential: false,
            poNumberIsReferential: false,
            shipToCountryIsReferential: false,
            lineItemTaxRate: 0.002,
            lineItemUnits: "EA",
            lineItemPartNumber: "UPC",
            shipFromPostalCode: "08648",
            poNumber: "89898989",
            shipToCountry: "840",
            shipToPostalCode: "55555",
            shippingAmount: 0,
        });
    }
    // Maps the given merchant account to the form
    mapMerchantAccountToForm(mercAccount) {
        if (mercAccount.interchangeDefaults != null) {
            let poIsReferential = false;
            if (mercAccount.interchangeDefaults.defaultableFields.poNumber)
                poIsReferential =
                    mercAccount.interchangeDefaults.defaultableFields.poNumber
                        .referentialRule !== "UseFixedValue";
            let shipToZipIsReferential = false;
            if (mercAccount.interchangeDefaults.defaultableFields.shipToPostalCode)
                shipToZipIsReferential =
                    mercAccount.interchangeDefaults.defaultableFields.shipToPostalCode
                        .referentialRule !== "UseFixedValue";
            let shipToCountryIsReferential = false;
            if (mercAccount.interchangeDefaults.defaultableFields.shipToCountry)
                shipToCountryIsReferential =
                    mercAccount.interchangeDefaults.defaultableFields.shipToCountry
                        .referentialRule !== "UseFixedValue";
            //PO Number
            this.interchangeDefaultsForm.controls.poNumberIsReferential.setValue(poIsReferential);
            if (!poIsReferential)
                this.interchangeDefaultsForm.controls.poNumber.enable();
            else
                this.interchangeDefaultsForm.controls.poNumber.disable();
            //Ship To Zip
            this.interchangeDefaultsForm.controls.shipToPostalCodeIsReferential.setValue(shipToZipIsReferential);
            if (!shipToZipIsReferential)
                this.interchangeDefaultsForm.controls.shipToPostalCode.enable();
            else
                this.interchangeDefaultsForm.controls.shipToPostalCode.disable();
            //Ship To Country
            this.interchangeDefaultsForm.controls.shipToCountryIsReferential.setValue(shipToCountryIsReferential);
            if (!shipToCountryIsReferential)
                this.interchangeDefaultsForm.controls.shipToCountry.enable();
            else
                this.interchangeDefaultsForm.controls.shipToCountry.disable();
            this.interchangeDefaultsForm.patchValue({
                optimizationPreference: mercAccount.interchangeDefaults
                    .optimizationPreference
                    ? mercAccount.interchangeDefaults.optimizationPreference
                    : null,
                orderDate: mercAccount.interchangeDefaults.defaultableFields.orderDate
                    ? mercAccount.interchangeDefaults.defaultableFields.orderDate
                        .daysBeforePaymentDate
                    : null,
                lineItemCommodityCode: mercAccount.interchangeDefaults.defaultableFields.commodityCode,
                lineItemDescription: mercAccount.interchangeDefaults.defaultableFields.description,
                lineItemName: mercAccount.interchangeDefaults.defaultableFields.name,
                lineItemTaxRate: mercAccount.interchangeDefaults.defaultableFields.taxRate,
                lineItemUnits: mercAccount.interchangeDefaults.defaultableFields.units,
                lineItemPartNumber: mercAccount.interchangeDefaults.defaultableFields.partNumber,
                shipFromPostalCode: mercAccount.interchangeDefaults.defaultableFields.shipFromPostalCode,
                poNumber: mercAccount.interchangeDefaults.defaultableFields.poNumber
                    ? mercAccount.interchangeDefaults.defaultableFields.poNumber
                        .fixedValue
                    : null,
                shipToCountry: mercAccount.interchangeDefaults.defaultableFields
                    .shipToCountry
                    ? mercAccount.interchangeDefaults.defaultableFields.shipToCountry
                        .fixedValue
                    : null,
                shipToPostalCode: mercAccount.interchangeDefaults.defaultableFields
                    .shipToPostalCode
                    ? mercAccount.interchangeDefaults.defaultableFields.shipToPostalCode
                        .fixedValue
                    : null,
                shippingAmount: mercAccount.interchangeDefaults.defaultableFields.shippingAmount,
            });
        }
        else {
            this.clearFields();
        }
        if (this.hasPermissionToSave)
            this.interchangeDefaultsForm.enable();
        else
            this.interchangeDefaultsForm.disable();
    }
    // Triggers the saving of an interchange default object to the merchant registration service.
    saveInterchangeDefaults() {
        if (!this.interchangeDefaultsForm.valid) {
            this.interchangeDefaultsForm.markAllAsTouched();
            return;
        }
        if (this.shouldDefaultsBeDeleted()) {
            this.store.dispatch(new DeleteInterchangeDefaultsAction({
                name: this.selectedMerchantAccount.name,
                merchantAccountId: this.selectedMerchantAccount.merchantAccountId,
                interchangeDefaultId: this.selectedMerchantAccount.interchangeDefaults.id,
            }));
        }
        else {
            let payload = {
                merchantAccountId: this.selectedMerchantAccount.merchantAccountId,
                optimizationPreference: this.interchangeDefaultsForm.value
                    .optimizationPreference
                    ? this.interchangeDefaultsForm.value.optimizationPreference
                    : "Full",
                id: this.selectedMerchantAccount.interchangeDefaults != null
                    ? this.selectedMerchantAccount.interchangeDefaults.id
                    : null,
                defaultableFields: {
                    description: this.interchangeDefaultsForm.value.lineItemDescription,
                    name: this.interchangeDefaultsForm.value.lineItemName
                        ? this.interchangeDefaultsForm.value.lineItemName
                        : null,
                    commodityCode: this.interchangeDefaultsForm.value
                        .lineItemCommodityCode
                        ? this.interchangeDefaultsForm.value.lineItemCommodityCode
                        : null,
                    units: this.interchangeDefaultsForm.value.lineItemUnits
                        ? this.interchangeDefaultsForm.value.lineItemUnits
                        : null,
                    partNumber: this.interchangeDefaultsForm.value.lineItemPartNumber
                        ? this.interchangeDefaultsForm.value.lineItemPartNumber
                        : null,
                    taxRate: this.interchangeDefaultsForm.value.lineItemTaxRate
                        ? this.interchangeDefaultsForm.value.lineItemTaxRate
                        : null,
                    shipFromPostalCode: this.interchangeDefaultsForm.value
                        .shipFromPostalCode
                        ? this.interchangeDefaultsForm.value.shipFromPostalCode
                        : null,
                    shippingAmount: this.interchangeDefaultsForm.value.shippingAmount
                        ? this.interchangeDefaultsForm.value.shippingAmount
                        : null,
                    poNumber: !this.interchangeDefaultsForm.value.poNumberIsReferential &&
                        !this.interchangeDefaultsForm.value.poNumber
                        ? null
                        : {
                            fixedValue: !this.interchangeDefaultsForm.value
                                .poNumberIsReferential
                                ? this.interchangeDefaultsForm.value.poNumber
                                : null,
                            referentialRule: !this.interchangeDefaultsForm.value
                                .poNumberIsReferential
                                ? "UseFixedValue"
                                : "UseOrderDetailsMerchantReferenceCode",
                        },
                    shipToPostalCode: !this.interchangeDefaultsForm.value.shipToPostalCodeIsReferential &&
                        !this.interchangeDefaultsForm.value.shipToPostalCode
                        ? null
                        : {
                            fixedValue: !this.interchangeDefaultsForm.value
                                .shipToPostalCodeIsReferential
                                ? this.interchangeDefaultsForm.value.shipToPostalCode
                                : null,
                            referentialRule: !this.interchangeDefaultsForm.value
                                .shipToPostalCodeIsReferential
                                ? "UseFixedValue"
                                : "UseBillingInfo",
                        },
                    shipToCountry: !this.interchangeDefaultsForm.value.shipToCountryIsReferential &&
                        !this.interchangeDefaultsForm.value.shipToCountry
                        ? null
                        : {
                            fixedValue: !this.interchangeDefaultsForm.value
                                .shipToCountryIsReferential
                                ? this.interchangeDefaultsForm.value.shipToCountry
                                : null,
                            referentialRule: !this.interchangeDefaultsForm.value
                                .shipToCountryIsReferential
                                ? "UseFixedValue"
                                : "UseBillingInfo",
                        },
                    orderDate: this.interchangeDefaultsForm.value.orderDate
                        ? {
                            daysBeforePaymentDate: this.interchangeDefaultsForm.value.orderDate,
                        }
                        : null,
                },
            };
            if (payload.id !== null)
                this.store.dispatch(new UpdateInterchangeDefaultsAction(payload));
            else
                this.store.dispatch(new CreateInterchangeDefaultsAction(payload));
        }
    }
    // Determine whether the Interchange Defaults should be deleted based upon the form values and whether the Interchange Defaults currently exist.
    shouldDefaultsBeDeleted() {
        if (!this.interchangeDefaultsForm.controls.orderDate.value &&
            !this.interchangeDefaultsForm.controls.optimizationPreference.value &&
            this.interchangeDefaultsForm.controls.poNumberIsReferential.value ==
                false &&
            !this.interchangeDefaultsForm.controls.poNumber.value &&
            !this.interchangeDefaultsForm.controls.shippingAmount.value &&
            !this.interchangeDefaultsForm.controls.shipFromPostalCode.value &&
            !this.interchangeDefaultsForm.controls.shipToCountry.value &&
            this.interchangeDefaultsForm.controls.shipToCountryIsReferential.value ==
                false &&
            this.interchangeDefaultsForm.controls.shipToPostalCodeIsReferential
                .value == false &&
            !this.interchangeDefaultsForm.controls.shipToPostalCode.value &&
            !this.interchangeDefaultsForm.controls.lineItemDescription.value &&
            !this.interchangeDefaultsForm.controls.lineItemName.value &&
            !this.interchangeDefaultsForm.controls.lineItemCommodityCode.value &&
            !this.interchangeDefaultsForm.controls.lineItemUnits.value &&
            !this.interchangeDefaultsForm.controls.lineItemPartNumber.value &&
            !this.interchangeDefaultsForm.controls.lineItemTaxRate.value &&
            this.selectedMerchantAccount.interchangeDefaults !== null
            ? true
            : false) {
            return true;
        }
        return false;
    }
    isNumericValidator() {
        return (control) => {
            let isNotANumber = isNaN(control.value) && control.value;
            return isNotANumber ? { numeric: { value: control.value } } : null;
        };
    }
    isValidTaxRateValidator() {
        return (control) => {
            if (control.value) {
                if (isNaN(control.value)) {
                    return { taxRate: { value: control.value } };
                }
                else {
                    let taxRate = parseFloat(control.value);
                    return taxRate >= 0.0 && taxRate <= 1.0
                        ? null
                        : { taxRate: { value: control.value } };
                }
            }
            else {
                return null;
            }
        };
    }
    /** @nocollapse */ static { this.ɵfac = function InterchangeDetailComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InterchangeDetailComponent)(i0.ɵɵdirectiveInject(i1$2.Store), i0.ɵɵdirectiveInject(MerchantRegistrationPermissions)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: InterchangeDetailComponent, selectors: [["pay-interchange-detail"]], inputs: { merchantAccounts: "merchantAccounts" }, decls: 24, vars: 22, consts: [[1, "indent"], [1, "p-grid"], [1, "p-col-4"], [1, "p-col-8"], [1, "p-lg-3", "p-md-4"], [1, "interchange-dropdown-field"], ["placeholder", "Select a Merchant", "id", "pay-select-merchant-dropdown", 3, "valueChange", "options", "label"], [1, "p-col"], [1, "p-col-12"], [2, "font-size", "0.8em"], [3, "ngSubmit", "keydown.enter", "formGroup"], ["emphasis", "subdued", 2, "margin-top", "15px"], [1, "interchange-dropdown-field", "p-lg-3", "p-md-4"], ["placeholder", "Copy From Merchant", "id", "pay-copy-settingfrom-dropdown", 3, "valueChange", "ngModelChange", "options", "label", "ngModel"], [1, "p-lg-1", "p-md-2", "center"], ["aur-button", "", "importance", "secondary", "id", "pay-apply-button", 3, "click", "disabled"], [1, "p-grid", "row"], ["formControlName", "optimizationPreference", "label", "Optimization Preference", "placeholder", "Select Optimization Preference", "id", "pay-copy-optimizationpref-dropdown", 3, "options"], [1, "p-grid", "row", "center-vertical"], [1, "p-lg-3", "p-md-4", "interchange-text-field"], ["id", "pay-level23-po-text", "formControlName", "poNumber", 3, "label"], [1, "p-grid", 2, "margin", "auto"], [1, "p-col-2", "center"], [1, "p-col-10", "indent"], ["id", "pay-level23-po-toggle", "checkedLabel", "", "uncheckedLabel", "", "labelPosition", "right", "formControlName", "poNumberIsReferential", 3, "valueChange", "label"], ["id", "pay-level23-orderdate-text", "formControlName", "orderDate", "tooltipPosition", "bottom", 3, "label", "pTooltip", "errorMessages"], ["id", "pay-level23-shipamt-text", "formControlName", "shippingAmount", 3, "label", "errorMessages"], ["id", "pay-level23-fromzip-text", "formControlName", "shipFromPostalCode", 3, "label"], ["id", "pay-level23-tozip-text", "formControlName", "shipToPostalCode", 3, "label"], ["id", "pay-level23-tozip-toggle", "checkedLabel", "", "uncheckedLabel", "", "labelPosition", "right", "formControlName", "shipToPostalCodeIsReferential", 3, "valueChange", "label"], ["id", "pay-level23-tocountry-text", "formControlName", "shipToCountry", 3, "label"], ["id", "pay-level23-tocountry-toggle", "checkedLabel", "", "uncheckedLabel", "", "labelPosition", "right", "formControlName", "shipToCountryIsReferential", 3, "valueChange", "label"], [2, "margin-bottom", "0px"], ["id", "pay-level23-description-text", "formControlName", "lineItemDescription", 3, "label"], ["id", "pay-level23-commoditycode-text", "label", "Commodity Code", "formControlName", "lineItemCommodityCode", 3, "pTooltip"], ["id", "pay-level23-unit-text", "formControlName", "lineItemUnits", 3, "label"], ["id", "pay-level23-name-text", "formControlName", "lineItemName", 3, "label"], ["id", "pay-level23-taxrate-text", "formControlName", "lineItemTaxRate", 3, "label", "errorMessages"], ["id", "pay-level23-partnum-text", "formControlName", "lineItemPartNumber", 3, "label"], [1, "p-grid", 2, "margin-top", "20px"], [1, "col-2"], ["aur-button", "", "importance", "secondary", "id", "pay-level23-clear-button", "type", "button", 3, "click", "disabled"], [1, "p-col", "audit-col"], [3, "target", "targetType", "auditEventStoreKey"], [1, "p-justify-end"], ["aur-button", "", "importance", "secondary", "id", "pay-level23-cancel-button", "type", "button", 3, "click"], ["aur-button", "", "id", "pay-level23-save-button", "importance", "primary", 3, "disabled"]], template: function InterchangeDetailComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1)(3, "div", 2)(4, "h3");
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(7, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 1)(9, "div", 4)(10, "div", 5)(11, "aur-dropdown", 6);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵpipe(13, "sortByName");
            i0.ɵɵpipe(14, "toSelectItem");
            i0.ɵɵlistener("valueChange", function InterchangeDetailComponent_Template_aur_dropdown_valueChange_11_listener($event) { return ctx.loadSelectedMerchantAccount($event); });
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(15, "div", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 1)(17, "div", 8)(18, "p", 9);
            i0.ɵɵtext(19);
            i0.ɵɵpipe(20, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(21, InterchangeDetailComponent_Conditional_21_Template, 15, 27, "div", 1);
            i0.ɵɵelementStart(22, "form", 10);
            i0.ɵɵlistener("ngSubmit", function InterchangeDetailComponent_Template_form_ngSubmit_22_listener() { return ctx.saveInterchangeDefaults(); })("keydown.enter", function InterchangeDetailComponent_Template_form_keydown_enter_22_listener($event) { return $event.preventDefault(); });
            i0.ɵɵtemplate(23, InterchangeDetailComponent_Conditional_23_Template, 107, 83, "aur-card", 11);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_HEADER"));
            i0.ɵɵadvance(6);
            i0.ɵɵstyleMap(i0.ɵɵpureFunction0(21, _c0));
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(12, 11, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_MERCHANT_LABEL"));
            i0.ɵɵproperty("options", i0.ɵɵpipeBind3(14, 15, i0.ɵɵpipeBind1(13, 13, ctx.merchantAccounts), "name", "merchantAccountId"));
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 19, "ARC_PAYMENTS_INTERCHANGE_DEFAULTS_DESCRIPTIVE_EXPLAINATION"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.selectedMerchantAccount ? 21 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.interchangeDefaultsForm);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.selectedMerchantAccount ? 23 : -1);
        } }, dependencies: [i4$1.ɵNgNoValidate, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.NgModel, i4$1.FormGroupDirective, i4$1.FormControlName, i5.ButtonComponent, i5.CardComponent, i5.DropdownComponent, i5.InputComponent, i5.ToggleComponent, i5$1.Tooltip, LastUpdatedByComponent, i1$4.AsyncPipe, i1$1.TranslatePipe, MerchantFilterPipe, SortByNamePipe, ToSelectItemPipe, PresentInterchangePipe, AddGlobalDefaultsOptionPipe], styles: [".row[_ngcontent-%COMP%]{margin:0}.interchange-label-field[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{width:100%;padding-left:5px}.interchange-text-field[_ngcontent-%COMP%]   aur-input[_ngcontent-%COMP%]{width:100%;margin-top:0}.interchange-dropdown-field[_ngcontent-%COMP%]   aur-dropdown[_ngcontent-%COMP%]{width:100%;margin-top:0}.center[_ngcontent-%COMP%]{text-align:center;margin:auto}.center-vertical[_ngcontent-%COMP%]{align-items:center}.indent[_ngcontent-%COMP%]{padding-left:12px}.audit-col[_ngcontent-%COMP%]{align-self:center;text-align:right}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InterchangeDetailComponent, [{
        type: Component,
        args: [{ selector: "pay-interchange-detail", template: "<div class=\"indent\">\n  <div>\n    <div class=\"p-grid\">\n      <div class=\"p-col-4\">\n        <h3>{{ 'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_HEADER' | translate }}</h3>\n      </div>\n      <div class=\"p-col-8\"></div>\n    </div>\n    <div class=\"p-grid\">\n      <div class=\"p-lg-3 p-md-4\">\n        <div class=\"interchange-dropdown-field\">\n          <aur-dropdown\n            [options]=\"\n              merchantAccounts\n                | sortByName\n                | toSelectItem : 'name' : 'merchantAccountId'\n            \"\n            (valueChange)=\"loadSelectedMerchantAccount($event)\"\n            [style]=\"{ width: '100%' }\"\n            label=\"{{\n              'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_MERCHANT_LABEL' | translate\n            }}\"\n            placeholder=\"Select a Merchant\"\n            id=\"pay-select-merchant-dropdown\"\n            >\n          </aur-dropdown>\n        </div>\n      </div>\n      <div class=\"p-col\"></div>\n    </div>\n  </div>\n  <div class=\"p-grid\">\n    <div class=\"p-col-12\">\n      <p style=\"font-size: 0.8em\">\n        {{\n        'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_DESCRIPTIVE_EXPLAINATION'\n        | translate\n        }}\n      </p>\n    </div>\n  </div>\n  @if (selectedMerchantAccount) {\n    <div class=\"p-grid\">\n      <div class=\"interchange-dropdown-field p-lg-3 p-md-4\">\n        <aur-dropdown\n        [options]=\"\n          merchantAccounts\n            | merchantFilter : selectedMerchantAccount\n            | presentInterchange\n            | sortByName\n            | toSelectItem : 'name' : 'merchantAccountId'\n            | addGlobalDefaultsOption\n        \"\n          (valueChange)=\"setCopyFromMerchantAccount($event)\"\n        label=\"{{\n          'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COPY_FROM_SETTINGS_LABEL'\n            | translate\n        }}\"\n          placeholder=\"Copy From Merchant\"\n          [style]=\"{ width: '100%' }\"\n          [(ngModel)]=\"copyFromId\"\n          id=\"pay-copy-settingfrom-dropdown\"\n          >\n        </aur-dropdown>\n      </div>\n      <div class=\"p-lg-1 p-md-2 center\">\n        <button\n          aur-button\n          importance=\"secondary\"\n          [disabled]=\"!readyToCopy || !(hasPermissionToSave$ | async)\"\n          id=\"pay-apply-button\"\n          (click)=\"loadCopyFromMerchantAccount()\"\n          >\n          {{\n          'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COPY_FROM_SETTINGS_APPLY_BUTTON'\n          | translate\n          }}\n        </button>\n      </div>\n      <div class=\"p-col\"></div>\n    </div>\n  }\n  <form\n    [formGroup]=\"interchangeDefaultsForm\"\n    (ngSubmit)=\"saveInterchangeDefaults()\"\n    (keydown.enter)=\"$event.preventDefault()\"\n    >\n    @if (selectedMerchantAccount) {\n      <aur-card\n        emphasis=\"subdued\"\n        style=\"margin-top: 15px\"\n        >\n        <div>\n          <div class=\"p-grid row\">\n            <div class=\"interchange-dropdown-field p-lg-3 p-md-4\">\n              <aur-dropdown\n                [options]=\"optimizationPreferenceOptions\"\n                formControlName=\"optimizationPreference\"\n                label=\"Optimization Preference\"\n                placeholder=\"Select Optimization Preference\"\n                [style]=\"{ width: '100%' }\"\n                id=\"pay-copy-optimizationpref-dropdown\"\n                >\n              </aur-dropdown>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row center-vertical\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-po-text\"\n                formControlName=\"poNumber\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_PO_NUMBER_LABEL' | translate\n              }}\"\n              ></aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4\">\n              <div class=\"p-grid\" style=\"margin: auto\">\n                <div class=\"p-col-2 center\">\n                  <span>{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR'\n                    | translate\n                  }}</span>\n                </div>\n                <div class=\"p-col-10 indent\">\n                  <aur-toggle\n                    id=\"pay-level23-po-toggle\"\n                    checkedLabel=\"\"\n                    uncheckedLabel=\"\"\n                  label=\"{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_USE_MERCHANT_REF_CODE_TOGGLE_INDICATOR'\n                      | translate\n                  }}\"\n                    labelPosition=\"right\"\n                    (valueChange)=\"togglePoFixed()\"\n                    formControlName=\"poNumberIsReferential\"\n                    >\n                  </aur-toggle>\n                </div>\n              </div>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-orderdate-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_ORDER_DATE_LABEL' | translate\n              }}\"\n                formControlName=\"orderDate\"\n              pTooltip=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_ORDER_DATE_TOOLTIP'\n                  | translate\n              }}\"\n                tooltipPosition=\"bottom\"\n                [errorMessages]=\"customErrorMessage\"\n              ></aur-input>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-shipamt-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIPPING_AMOUNT_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"shippingAmount\"\n                [errorMessages]=\"customErrorMessage\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-fromzip-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_FROM_ZIP_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"shipFromPostalCode\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row center-vertical\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-tozip-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_TO_ZIP_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"shipToPostalCode\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4\">\n              <div class=\"p-grid\" style=\"margin: auto\">\n                <div class=\"p-col-2 center\">\n                  <span>{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR'\n                    | translate\n                  }}</span>\n                </div>\n                <div class=\"p-col-10 indent\">\n                  <aur-toggle\n                    id=\"pay-level23-tozip-toggle\"\n                    checkedLabel=\"\"\n                    uncheckedLabel=\"\"\n                  label=\"{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_BILLING_ZIP_TOGGLE_INDICATOR'\n                      | translate\n                  }}\"\n                    labelPosition=\"right\"\n                    (valueChange)=\"toggleShipToZipFixed()\"\n                    formControlName=\"shipToPostalCodeIsReferential\"\n                    >\n                  </aur-toggle>\n                </div>\n              </div>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row center-vertical\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-tocountry-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SHIP_TO_COUNTRY_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"shipToCountry\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4\">\n              <div class=\"p-grid\" style=\"margin: auto\">\n                <div class=\"p-col-2 center\">\n                  <span>{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_OR_FORM_FIELD_INDICATOR'\n                    | translate\n                  }}</span>\n                </div>\n                <div class=\"p-col-10 indent\">\n                  <aur-toggle\n                    id=\"pay-level23-tocountry-toggle\"\n                    checkedLabel=\"\"\n                    uncheckedLabel=\"\"\n                  label=\"{{\n                    'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_BILLING_COUNTRY_TOGGLE_INDICATOR'\n                      | translate\n                  }}\"\n                    labelPosition=\"right\"\n                    (valueChange)=\"toggleshipToCountryFixed()\"\n                    formControlName=\"shipToCountryIsReferential\"\n                    >\n                  </aur-toggle>\n                </div>\n              </div>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n        </div>\n        <div>\n          <div class=\"p-grid row\">\n            <div class=\"p-col-4\">\n              <h3 style=\"margin-bottom: 0px\">\n                {{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEMS_HEADER'\n                | translate\n                }}\n              </h3>\n            </div>\n            <div class=\"p-col\"></div>\n          </div>\n          <div class=\"p-grid row\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-description-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_DESCRIPTION_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"lineItemDescription\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-commoditycode-text\"\n                label=\"Commodity Code\"\n              pTooltip=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_COMMODITY_CODE_TOOLTIP'\n                  | translate\n              }}\"\n                formControlName=\"lineItemCommodityCode\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-unit-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_UNITS_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"lineItemUnits\"\n                >\n              </aur-input>\n            </div>\n          </div>\n          <div class=\"p-grid row\">\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-name-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_NAME_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"lineItemName\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-taxrate-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_TAX_RATE_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"lineItemTaxRate\"\n                [errorMessages]=\"customErrorMessage\"\n                >\n              </aur-input>\n            </div>\n            <div class=\"p-lg-3 p-md-4 interchange-text-field\">\n              <aur-input\n                id=\"pay-level23-partnum-text\"\n              label=\"{{\n                'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_LINE_ITEM_PART_NUMBER_LABEL'\n                  | translate\n              }}\"\n                formControlName=\"lineItemPartNumber\"\n              ></aur-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"p-grid\" style=\"margin-top: 20px\">\n          <div class=\"col-2\">\n            <button\n              aur-button\n              importance=\"secondary\"\n              [disabled]=\"!(hasPermissionToSave$ | async)\"\n              (click)=\"clearFields()\"\n              id=\"pay-level23-clear-button\"\n              type=\"button\"\n              >\n              {{\n              'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_CLEAR_FIELDS_BUTTON'\n              | translate\n              }}\n            </button>\n          </div>\n          <div class=\"p-col audit-col\">\n            @if (selectedMerchantAccount.merchantAccountId) {\n              <payments-last-updated-by\n                [target]=\"selectedMerchantAccount.merchantAccountId\"\n                [targetType]=\"auditTargetType\"\n                [auditEventStoreKey]=\"auditStoreKey\"\n                >\n              </payments-last-updated-by>\n            }\n          </div>\n          <div class=\"p-justify-end\">\n            <button\n              aur-button\n              importance=\"secondary\"\n              (click)=\"resetToSelectedMerchantAccount()\"\n              id=\"pay-level23-cancel-button\"\n              type=\"button\"\n              >\n              {{ 'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_CANCEL_BUTTON' | translate }}\n            </button>\n            <button\n              aur-button\n            [disabled]=\"\n              !interchangeDefaultsForm.dirty || !(hasPermissionToSave$ | async)\n            \"\n              id=\"pay-level23-save-button\"\n              importance=\"primary\"\n              >\n              {{ 'ARC_PAYMENTS_INTERCHANGE_DEFAULTS_SAVE_BUTTON' | translate }}\n            </button>\n          </div>\n        </div>\n      </aur-card>\n    }\n  </form>\n</div>\n", styles: [".row{margin:0}.interchange-label-field label{width:100%;padding-left:5px}.interchange-text-field aur-input{width:100%;margin-top:0}.interchange-dropdown-field aur-dropdown{width:100%;margin-top:0}.center{text-align:center;margin:auto}.center-vertical{align-items:center}.indent{padding-left:12px}.audit-col{align-self:center;text-align:right}\n"] }]
    }], () => [{ type: i1$2.Store }, { type: MerchantRegistrationPermissions }], { merchantAccounts: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(InterchangeDetailComponent, { className: "InterchangeDetailComponent", filePath: "lib/components/interchange-detail/interchange-detail.component.ts", lineNumber: 31 }); })();

class CardProcessingComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.merchantAccounts$ = this.store.pipe(select(MerchantAccountListStore));
        this.gateways$ = this.store.pipe(select(GatewayListStore));
        this.tenantUsers$ = this.store.pipe(select(TenantUserListStore));
        //Load stores
        this.store.dispatch(new LoadGatewayListAction({}));
        this.store.dispatch(new LoadTenantUserListAction({}));
        let initialized = false;
        this.merchantSubscription = this.merchantAccounts$.pipe(map(accounts => {
            if (accounts.length < 1 && !initialized) {
                this.store.dispatch(new LoadMerchantAccountListAction({}));
                initialized = true;
            }
        })).subscribe();
    }
    ngOnDestroy() {
        if (this.merchantSubscription && !this.merchantSubscription.closed)
            this.merchantSubscription.unsubscribe();
    }
    resetSelectedMerchantAccount() {
        this.store.dispatch(new ResetMerchantAccountAction({}));
    }
    /** @nocollapse */ static { this.ɵfac = function CardProcessingComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CardProcessingComponent)(i0.ɵɵdirectiveInject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: CardProcessingComponent, selectors: [["pay-card-processing"]], decls: 12, vars: 18, consts: [[3, "onChange"], [3, "header"], [3, "merchantAccounts", "gateways", "tenantUsers"], [3, "merchantAccounts"]], template: function CardProcessingComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "p-tabView", 0);
            i0.ɵɵlistener("onChange", function CardProcessingComponent_Template_p_tabView_onChange_1_listener() { return ctx.resetSelectedMerchantAccount(); });
            i0.ɵɵelementStart(2, "p-tabPanel", 1);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelement(4, "pay-merchant-account-table", 2);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "async");
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p-tabPanel", 1);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelement(10, "pay-interchange-detail", 3);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(3, 6, "ARC_PAYMENTS_CARD_PROCESSING_MERCHANT_TABLE_TAB_HEADER"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("merchantAccounts", i0.ɵɵpipeBind1(5, 8, ctx.merchantAccounts$))("gateways", i0.ɵɵpipeBind1(6, 10, ctx.gateways$))("tenantUsers", i0.ɵɵpipeBind1(7, 12, ctx.tenantUsers$));
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("header", i0.ɵɵpipeBind1(9, 14, "ARC_PAYMENTS_CARD_PROCESSING_INTERCHANGE_DEFAULTS_TAB_HEADER"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("merchantAccounts", i0.ɵɵpipeBind1(11, 16, ctx.merchantAccounts$));
        } }, dependencies: [i2$3.TabView, i2$3.TabPanel, MerchantAccountTableComponent, InterchangeDetailComponent, i1$4.AsyncPipe, i1$1.TranslatePipe], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardProcessingComponent, [{
        type: Component,
        args: [{ selector: 'pay-card-processing', template: "<div>\n  <p-tabView (onChange)=\"resetSelectedMerchantAccount()\">\n    <p-tabPanel\n      header=\"{{\n        'ARC_PAYMENTS_CARD_PROCESSING_MERCHANT_TABLE_TAB_HEADER' | translate\n      }}\"\n    >\n      <pay-merchant-account-table\n        [merchantAccounts]=\"merchantAccounts$ | async\"\n        [gateways]=\"gateways$ | async\"\n        [tenantUsers]=\"tenantUsers$ | async\"\n      >\n      </pay-merchant-account-table>\n    </p-tabPanel>\n    <p-tabPanel\n      header=\"{{\n        'ARC_PAYMENTS_CARD_PROCESSING_INTERCHANGE_DEFAULTS_TAB_HEADER'\n          | translate\n      }}\"\n    >\n      <pay-interchange-detail [merchantAccounts]=\"merchantAccounts$ | async\">\n      </pay-interchange-detail>\n    </p-tabPanel>\n  </p-tabView>\n</div>\n" }]
    }], () => [{ type: i1$2.Store }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CardProcessingComponent, { className: "CardProcessingComponent", filePath: "lib/components/card-processing/card-processing.component.ts", lineNumber: 24 }); })();

class AccountSummaryComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadMerchantAccountListAction({}));
        this.numRegistered$ = this.store.pipe(select(MerchantAccountListStore)).pipe(map(accounts => {
            return accounts.filter(x => x.status.toLowerCase() == 'registered').length;
        }));
        this.numAutoRegistered$ = this.store.pipe(select(MerchantAccountListStore)).pipe(map(accounts => {
            return accounts.filter(x => x.status.toLowerCase() == 'autoregistered').length;
        }));
        this.numOnBoarding$ = this.store.pipe(select(MerchantAccountListStore)).pipe(map(accounts => {
            return accounts.filter(x => x.status.toLowerCase() == 'onboarding').length;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = function AccountSummaryComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountSummaryComponent)(i0.ɵɵdirectiveInject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: AccountSummaryComponent, selectors: [["pay-account-summary"]], decls: 21, vars: 21, consts: [[1, "pay-mars-account-summary-header"], [1, "pay-mars-account-summary-content"], ["id", "pay-account-summary-registered"], [1, "pay-mars-account-summary-separator"], ["id", "pay-account-summary-autoregistered"], ["id", "pay-account-summary-onboarding"]], template: function AccountSummaryComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "p", 0);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "p", 1)(5, "span", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵpipe(8, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "span", 3);
            i0.ɵɵtext(10, "\u00A0|\u00A0");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "span", 4);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵpipe(14, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "span", 3);
            i0.ɵɵtext(16, "\u00A0|\u00A0");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "span", 5);
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵpipe(20, "async");
            i0.ɵɵelementEnd()()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, "ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_HEADER"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(7, 9, "ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_REGISTERED_LABEL"), ": ", i0.ɵɵpipeBind1(8, 11, ctx.numRegistered$), "");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(13, 13, "ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_AUTOREGISTERED_LABEL"), ": ", i0.ɵɵpipeBind1(14, 15, ctx.numAutoRegistered$), "");
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(19, 17, "ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_ONBOARDING_LABEL"), ": ", i0.ɵɵpipeBind1(20, 19, ctx.numOnBoarding$), "");
        } }, dependencies: [i1$4.AsyncPipe, i1$1.TranslatePipe], styles: [".pay-mars-account-summary-header[_ngcontent-%COMP%]{color:#797979;font-size:14px;margin-bottom:4px}.pay-mars-account-summary-content[_ngcontent-%COMP%]{font-size:16px;margin-top:4px}.pay-mars-account-summary-separator[_ngcontent-%COMP%]{color:#9ea7b3}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountSummaryComponent, [{
        type: Component,
        args: [{ selector: 'pay-account-summary', template: "<div>\n  <p class=\"pay-mars-account-summary-header\">\n    {{ 'ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_HEADER' | translate }}\n  </p>\n  <p class=\"pay-mars-account-summary-content\">\n    <span id=\"pay-account-summary-registered\"\n      >{{\n        'ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_REGISTERED_LABEL'\n          | translate\n      }}: {{ numRegistered$ | async }}</span\n    >\n    <span class=\"pay-mars-account-summary-separator\">&nbsp;|&nbsp;</span>\n    <span id=\"pay-account-summary-autoregistered\"\n      >{{\n        'ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_AUTOREGISTERED_LABEL'\n          | translate\n      }}: {{ numAutoRegistered$ | async }}</span\n    >\n    <span class=\"pay-mars-account-summary-separator\">&nbsp;|&nbsp;</span>\n    <span id=\"pay-account-summary-onboarding\"\n      >{{\n        'ARC_PAYMENTS_ACCOUNT_SUMMARY_SYSTEM_SETTINGS_ONBOARDING_LABEL'\n          | translate\n      }}: {{ numOnBoarding$ | async }}</span\n    >\n  </p>\n</div>\n", styles: [".pay-mars-account-summary-header{color:#797979;font-size:14px;margin-bottom:4px}.pay-mars-account-summary-content{font-size:16px;margin-top:4px}.pay-mars-account-summary-separator{color:#9ea7b3}\n"] }]
    }], () => [{ type: i1$2.Store }], null); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AccountSummaryComponent, { className: "AccountSummaryComponent", filePath: "lib/components/account-summary/account-summary.component.ts", lineNumber: 17 }); })();

class PaymentSettingsAuditHttpService {
    buildBaseUrl(tenantId) {
        return (this._configSettings.getconfig("paymentAcceptanceRulesServiceUrl") +
            `/v1/tenants/${tenantId}/paymentsettings/audit`);
    }
    constructor(_http, _configSettings) {
        this._http = _http;
        this._configSettings = _configSettings;
    }
    savePaymentSettingsAudit(tenantId, userEmail, target, targetType, configurationData) {
        const dataBody = {
            initiator: userEmail,
            initiatorType: "User",
            target,
            targetType,
            configurationData,
        };
        return this._http.post(this.buildBaseUrl(tenantId), dataBody);
    }
    getPaymentSettingsAudit(tenantId, target, targetType) {
        const currentDateTime = new Date();
        const pastDateTime = new Date();
        pastDateTime.setFullYear(pastDateTime.getFullYear() - 1);
        return this._http.post(`${this.buildBaseUrl(tenantId)}/records`, {
            utcTimeStampBetween: pastDateTime.toISOString() + "~" + currentDateTime.toISOString(),
            target,
            targetType,
        });
    }
    /** @nocollapse */ static { this.ɵfac = function PaymentSettingsAuditHttpService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PaymentSettingsAuditHttpService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppConfigSettings)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: PaymentSettingsAuditHttpService, factory: PaymentSettingsAuditHttpService.ɵfac, providedIn: "root" }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentSettingsAuditHttpService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], () => [{ type: i1.HttpClient }, { type: i2.AppConfigSettings }], null); })();

/* eslint-disable no-undef */
class SettingsAuditEffects {
    constructor(actions$, paymentSettingsAuditService, store$) {
        this.actions$ = actions$;
        this.paymentSettingsAuditService = paymentSettingsAuditService;
        this.store$ = store$;
        this.fetchSettingsAudit$ = createEffect(() => this.actions$.pipe(ofType(GetSettingAuditData), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([action, { activeTenant }]) => {
            return this.paymentSettingsAuditService
                .getPaymentSettingsAudit(activeTenant.tenantId, action.payload.target, action.payload.targetType)
                .pipe(map((lastUpdatedBy) => {
                return GetSettingAuditDataSuccess({
                    payload: {
                        auditData: lastUpdatedBy,
                        auditEventStoreKey: action.payload.auditEventStoreKey,
                    },
                });
            }), catchError$1((err) => {
                return of(GetSettingAuditDataError({
                    payload: {
                        auditEventStoreKey: action.payload.auditEventStoreKey,
                    },
                }));
            }));
        })));
        this.saveSettingsAudit$ = createEffect(() => this.actions$.pipe(ofType(SaveSettingAuditData), withLatestFrom$1(this.store$.select(AuthUserStore)), switchMap$1(([{ payload }, { activeTenant, user }]) => {
            const { target, targetType, configurationData } = payload;
            return this.paymentSettingsAuditService
                .savePaymentSettingsAudit(activeTenant.tenantId, user.email, target, targetType, configurationData)
                .pipe(map((response) => {
                return SaveSettingAuditDataSuccess();
            }));
        })));
    }
    /** @nocollapse */ static { this.ɵfac = function SettingsAuditEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SettingsAuditEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(PaymentSettingsAuditHttpService), i0.ɵɵinject(i1$2.Store)); }; }
    /** @nocollapse */ static { this.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: SettingsAuditEffects, factory: SettingsAuditEffects.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SettingsAuditEffects, [{
        type: Injectable
    }], () => [{ type: i1$3.Actions }, { type: PaymentSettingsAuditHttpService }, { type: i1$2.Store }], null); })();

const effects = [SettingsAuditEffects];

class SettingsAuditStoreModule {
    /** @nocollapse */ static { this.ɵfac = function SettingsAuditStoreModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SettingsAuditStoreModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SettingsAuditStoreModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule,
            StoreModule.forFeature(settingsAuditFeature),
            EffectsModule.forFeature(effects)] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SettingsAuditStoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    StoreModule.forFeature(settingsAuditFeature),
                    EffectsModule.forFeature(effects),
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SettingsAuditStoreModule, { imports: [CommonModule, i1$2.StoreFeatureModule, i1$3.EffectsFeatureModule] }); })();

class CardMerchantRegistrationModule {
    /** @nocollapse */ static { this.ɵfac = function CardMerchantRegistrationModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CardMerchantRegistrationModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: CardMerchantRegistrationModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [
            UserService,
            MerchantAccountService,
            GatewayRegistrationV1Service,
            MessageService$1,
            PermissionTypes,
            MerchantRegistrationPermissions,
            provideHttpClient(withInterceptorsFromDi()),
        ], imports: [MerchantAccountStoreModule,
            SettingsAuditStoreModule,
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            BrowserAnimationsModule,
            ArcSharedModule,
            ClipboardModule,
            AureusModule,
            DropdownModule,
            TabViewModule,
            TooltipModule,
            CheckboxModule,
            TableModule,
            OverlayPanelModule,
            MessagesModule, ClipboardModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardMerchantRegistrationModule, [{
        type: NgModule,
        args: [{ declarations: [
                    MerchantAccountTableComponent,
                    CardProcessingComponent,
                    InterchangeDetailComponent,
                    MerchantEditorComponent,
                    TokenViewComponent,
                    MerchantFilterPipe,
                    MerchantConfirmationComponent,
                    SortByNamePipe,
                    ToSelectItemPipe,
                    PresentInterchangePipe,
                    AddGlobalDefaultsOptionPipe,
                    TranslateStatusPipe,
                    BuildActionMenuItemsPipe,
                    AccountSummaryComponent,
                    LastUpdatedByComponent,
                    LastUpdatedByPipe,
                    GatewayCredentialsDetailsComponent,
                    GatewayCredentialsEditTableComponent,
                    LoadingButtonComponent,
                    GatewayCredentialDeleteModalComponent
                ],
                exports: [CardProcessingComponent, AccountSummaryComponent, ClipboardModule],
                bootstrap: [], imports: [MerchantAccountStoreModule,
                    SettingsAuditStoreModule,
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    BrowserAnimationsModule,
                    ArcSharedModule,
                    ClipboardModule,
                    AureusModule,
                    DropdownModule,
                    TabViewModule,
                    TooltipModule,
                    CheckboxModule,
                    TableModule,
                    OverlayPanelModule,
                    MessagesModule], providers: [
                    UserService,
                    MerchantAccountService,
                    GatewayRegistrationV1Service,
                    MessageService$1,
                    PermissionTypes,
                    MerchantRegistrationPermissions,
                    provideHttpClient(withInterceptorsFromDi()),
                ] }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CardMerchantRegistrationModule, { declarations: [MerchantAccountTableComponent,
        CardProcessingComponent,
        InterchangeDetailComponent,
        MerchantEditorComponent,
        TokenViewComponent,
        MerchantFilterPipe,
        MerchantConfirmationComponent,
        SortByNamePipe,
        ToSelectItemPipe,
        PresentInterchangePipe,
        AddGlobalDefaultsOptionPipe,
        TranslateStatusPipe,
        BuildActionMenuItemsPipe,
        AccountSummaryComponent,
        LastUpdatedByComponent,
        LastUpdatedByPipe,
        GatewayCredentialsDetailsComponent,
        GatewayCredentialsEditTableComponent,
        LoadingButtonComponent,
        GatewayCredentialDeleteModalComponent], imports: [MerchantAccountStoreModule,
        SettingsAuditStoreModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ArcSharedModule,
        ClipboardModule,
        AureusModule,
        DropdownModule,
        TabViewModule,
        TooltipModule,
        CheckboxModule,
        TableModule,
        OverlayPanelModule,
        MessagesModule], exports: [CardProcessingComponent, AccountSummaryComponent, ClipboardModule] }); })();

// export * from './src/models';
// export * from './src/stores';

/**
 * Generated bundle index. Do not edit.
 */

export { AccountSummaryComponent, CardMerchantRegistrationModule, CardProcessingComponent, CreateAndUpdateGatewayCredentialAction, CreateInterchangeDefaultsAction, CreateMerchantAccountAction, DeleteGateWayCredentialAction, DeleteGateWayCredentialErrorAction, DeleteGateWayCredentialSuccessAction, DeleteInterchangeDefaultsAction, DeleteMerchantAccountAction, DisableMerchantAccountAction, EnableMerchantAccountAction, GatewayActionTypes, GatewayCredentialCreatedOrUpdatedAction, GatewayCredentialsActionTypes, GatewayCredentialsEffects, GatewayEffects, GatewayListLoadedAction, GatewayListStore, GatewayLoadedAction, InterchangeDefaultsCreatedAction, InterchangeDefaultsDeletedAction, InterchangeDefaultsUpdatedAction, InterchangeDetailComponent, LoadGatewayAction, LoadGatewayListAction, LoadMerchantAccountAction, LoadMerchantAccountListAction, LoadTenantUserListAction, MerchantAccountActionTypes, MerchantAccountDeletedAction, MerchantAccountDisabledAction, MerchantAccountEffects, MerchantAccountEnabledAction, MerchantAccountListLoadedAction, MerchantAccountListStore, MerchantAccountLoadedAction, MerchantAccountStoreModule, MerchantAccountTableComponent, MerchantAccountUpdatedAction, MerchantConfirmationComponent, MerchantEditorComponent, NewMerchantAccountCreatedAction, ResetGatewayAction, ResetMerchantAccountAction, SelectConfigurationChanged, SelectDeleteCredential, SelectSingleMerchantAccount, SelectVerifyingCredentials, SingleGatewayStore, SingleMerchantAccountStore, TenantUserActionTypes, TenantUserEffects, TenantUserListLoadedAction, TenantUserListStore, TokenViewComponent, UpdateInterchangeDefaultsAction, UpdateMerchantAccountAction, VerifyGatewayCredentialAction, VerifyGatewayCredentialErrorAction, VerifyGatewayCredentialSuccessAction, effects$1 as effects, getMerchantAccountState, reducers };
